<template>
  <div ref="testSingle" class="testSingle">
    <div v-if="eidtTaskFlag"
      :class="$store.state.taskListSelectedArr.includes(item)?'task-list-radio-check':'task-list-radio'"
      class="icon-util list-radio-position"></div>
    <div ref="threadParents"
      :class="[eidtTaskFlag?'task-list-edit-box':'task-list-box',collapseFlage==index&&detailShow&&!item.sources&&(item.type==1||item.type==6)?'task-list-collapse-box':'',collapseFlage==index&&detailShow&&item.type==2?'singletask-collapse-box':'']"
      :style="{height:getSingleHeight()?getSingleHeight():''}">
      <div class="task-list-back">
        <div v-if="showBackGround(item)" :class="item.percent?'task-list-backgroud':''"
          :style="{width:item.percent+'%'}">
        </div>
        <div v-if="item.avgpercent" :class="item.avgpercent?'task-list-backgroud':''"
          :style="{width:item.avgpercent+'%'}"></div>
      </div>
      <div class="task-lists-info">
        <div class="transfer-type">
          <div class="task-type-icon task-lists-position"
            :class="[(item.type==1&&item.options.way=='cloudEmail')?'task-lists-email-transfer':item.branchType=='businessTransfer'?'task-lists-business':'',item.type==1&&item.branchType!='share'&&item.branchType!='businessTransfer'?'task-lists-transfer':'',item.type==1&&item.branchType=='share'?'task-lists-share':'',item.type==2?'task-lists-sync':'',item.type==6?'task-lists-backup':'']">
          </div>
          <div :class="[item.type==6||item.branchType=='businessTransfer'?'task-order-backup':'task-order']">
            00{{tasklistData.length-index}}</div>
        </div>
        <div class="task-information">
          <div class="tasks-type">
            <div class="tasks-type">
              <div :title="this.taskUpTxt">
                <span class="list-title-name">{{this.taskUpTxt}}:</span>
              </div>
              <div ref="listDriveName" @click="editTaskListName(index,item)" class="task-list-name"
                @mouseenter="hoverCurrent=index" @mouseleave="hoverCurrent=-1" :title="item.name">
                <div class="tasks-lists-name">
                  {{item.name}}

                </div>
                <div class="icon-util edit-small edit-small-position" v-if="hoverCurrent==index"></div>
              </div>
              <span class="list-outclass" ref="listInputName" @mouseover.stop="hoverCurrent=-1"
                @click.stop="hoverCurrent=-1,clickCurrent=-1">
                <input class="list-task-edit" v-model="item.inputValue" @focus="isflage=true"
                  @blur="submitTaskListName(item,index)" />
                <span class="tasks-edit-name">
                  <i class="icon-util name-sure" @click.stop='submitTaskListName(item,index)'></i>
                  <i class="icon-util name-cancel " @mousedown.stop='cancelEditDriveName(index,item)'></i>
                </span>
              </span>
            </div>
          </div>
          <!-- 显示源目录 -->
          <div class="tasks-destion" v-show="item.type == 1||item.type == 6">
            <div style="float:left;width:100%;display:flex;">
              <div class="transfers-from" v-show="item.type == 1" id="transferFrom">
                <span v-show="$i18n.locale!='japanese'">{{$t('language.common.from')}}:</span>
                <span v-show="$i18n.locale=='japanese'">{{$t('language.cloudTransfer.from')}}:</span>
              </div>
              <div class="transfers-from" v-if="item.type == 6">
                <span
                  v-if="(item.tranferWay=='restore'||item.tranferWay=='retry-restore')&&(item.status=='Running'||item.status=='Waiting')">{{$t('language.cloudBackup.restore')}}:</span>
                <span v-else>
                  <span v-if="$i18n.locale=='japanese'">
                    {{$t('language.cloudTransfer.cloudBackupFrom')}}:
                  </span>
                  <span v-else>
                    {{$t('language.cloudBackup.backup')}}:
                  </span>
                </span>
              </div>
              <!-- 如果是单源 -->
              <div class="list-node-name" :style="{width:getFromWidth}"
                v-if="item.type!=6 && item.branchType!='share'&&!item.sources"
                @click.stop="toSourceCatalog(item.fromItem)" :title='item.fromItem.nodes|getCatalog|getCatalogTitle'>
                {{item.fromItem.nodes|getCatalog}}
              </div>
              <div v-if="item.type==6" class="list-node-name">
                <!-- 显示运行还原中的源 -->
                <span
                  v-if="(item.tranferWay=='restore'||item.tranferWay=='retry-restore')&&(item.status=='Running'||item.status=='Waiting')">
                  <span @click.stop="toRestoreSource(item)" :title='item.fromItem.nodes|getCatalog|getCatalogTitle'>
                    {{item.fromItem.nodes|getCatalog}}
                  </span>
                </span>
                <span v-else>
                  <!-- 如果是单源 -->
                  <span v-if="!item.fromItem.data" @click.stop="toSourceCatalog(item.fromItem)"
                    :title='item.fromItem.nodes|getCatalog|getCatalogTitle'>
                    {{item.fromItem.nodes|getCatalog}}
                  </span>
                  <!-- 如果是多源 -->
                  <span v-if="item.fromItem.data  && item.fromItem.data.length"
                    @click.stop="openBackupSource(item.fromItem)"
                    :title='item.fromItem.data[0].nodes|getCatalog|getBackupInfo'>
                    {{item.fromItem.data[0].nodes|getCatalog|getBackupInfo}}
                  </span>
                </span>

              </div>

              <div class="list-node-name" v-if="item.branchType=='share'&&!item.sources"
                @click.stop="toSharelicLink(item)">
                <span v-if="item.fromItem.sharePath"
                  :title='JSON.parse(item.fromItem.sharePath)|getCatalog'>{{JSON.parse(item.fromItem.sharePath)|getCatalog|ellipsis}}</span>
                <span v-else :title='item.fromItem.name|getCatalogTitle'>{{item.fromItem.name}}</span>
              </div>
              <task-list-select ref="taskListSelect" v-if="item.sources&&item.branchType!='businessTransfer'"
                :type=item.type :clickDialogCurrent="clickCurrent" :item="item" :index="index"
                :itemSource="getMultiSourceCatalog(item)">
              </task-list-select>
              <div class="list-node-name" v-if="item.sources&&item.branchType=='businessTransfer'"
                @click.stop="toSourceCatalog(item.fromItem,'businessTransfer')"
                :title='item.toItem.nodes|getCatalog|getCatalogTitle'>
                {{item.fromItem.nodes|getBusinessTransferCatalog}}
              </div>
            </div>
          </div>
          <div class="tasks-destion" v-if="item.type == 2">
            <div style="float:left;width:100%;display:flex;">
              <div class="transfers-from">{{$t('language.common.from')}}:</div>
              <div class="list-node-name" @click.stop="toSyncSourceCatalog(item.fromItem)"
                :title='item.fromItem.nodes|getCatalog|getCatalogTitle'>
                {{item.fromItem.nodes|getCatalog}}
              </div>
            </div>
          </div>
          <div class="tasks-shedule"
            v-if="item&&item.schedules&&item.schedules.type!='Now'&&item.branchType!='realtime'">
            <div>
              <div v-if="!item.updateFlag" class="icon-util  task-shedule-position"
                :class="!item.schedules.disabled?'check-small':'nocheck-small-blue'"
                @click.stop="changeSchedulesStatus(item,index)"></div>
              <div v-if="item.updateFlag" class="icon-util  task-shedule-position"
                :class="!item.schedules.disabled?'nocheck-small-disable':'check-small-disable'"></div>
              <span>{{$t('language.taskList.scheduled')}}</span>
            </div>
          </div>
        </div>
        <!-- 显示目标目录 -->
        <div class="task-information-to">
          <div class="tasks-to-destion">
            <div class="transfers-from" v-if="item.type==1||item.type==6">
              <span v-if="$i18n.locale!='japanese'">{{$t('language.common.to')}}:</span>
              <span v-else>
                <span v-if="item.type==1 ">{{$t('language.cloudTransfer.to')}}:</span>
                <span v-if='item.type==6'>{{$t('language.cloudTransfer.cloudBackupto')}}:</span>
              </span>
            </div>
            <div class="transfers-from" v-if="item.type==2||item.branch=='realtime'">{{$t('language.common.with')}}:
            </div>
            <span v-if="item.type == 6">
              <span
                v-if="(item.tranferWay=='restore'||item.tranferWay=='retry-restore')&&(item.status=='Running'||item.status=='Waiting')">
                <div v-if="item.toItem.data  && item.toItem.data.length" >
                <!-- 还原到新位置 -->
                    <div v-if="item.toItem.isRestoreNew" @click="openBackupToItems(item.toItem)" :title='item.toItem.data[0].nodes|getCatalog|getBackupInfo'>
                      {{item.toItem.data[0].nodes|getCatalog|getBackupInfo}}
                    </div>
                    <div class="list-node-name" v-else @click="openBackupToItems(item.toItem)">Original</div>
                </div>
                <div v-else>
                  <div class="list-node-name" @click="toAimCatalog(item.toItem)">
                    Original
                  </div>
                </div>
                
              </span>
              <span v-else>
                <div class="list-node-name" v-if="item.toItem.data  && item.toItem.data.length"
                  @click.stop="openBackupSource(item.toItem)"
                  :title='item.toItem.data[0].nodes|getCatalog|getBackupInfo'>
                  {{item.toItem.data[0].nodes|getCatalog|getBackupInfo}}
                </div>

                <div class="list-node-name" v-if="!item.toItem.data" @click.stop="toAimCatalog(item.toItem)"
                  :title='item.toItem.nodes|getCatalog|getCatalogTitle'>
                  {{item.toItem.nodes|getCatalog}}
                </div>
              </span>
            </span>
            <div class="list-node-name team-aims"
              v-if="(!item.sources||(item.type==1&& item.branchType!='businessTransfer'))&&item.type!=6&&item.toItem"
              @click.stop="toAimCatalog(item.toItem)" :title='item.toItem.nodes|getCatalog|getCatalogTitle'>
              {{item.toItem.nodes|getCatalog}}
            </div>
            <task-list-select ref="taskListSelect" v-if="item.sources&&item.type==2" :type=2
              :clickDialogCurrent="clickCurrent" :item="item" :index="index" :itemSource="getMultiAimsCatalog(item)">
            </task-list-select>
            <div class="list-node-name team-aims" v-if="item.sources&&item.branchType=='businessTransfer'"
              @click.stop="toAimCatalog(item.toItem,'businessTransfer')"
              :title='item.toItem.nodes|getBusinessTransferCatalog'>
              {{item.toItem.nodes|getBusinessTransferCatalog}}
            </div>
          </div>
        </div>
        <!-- 操作按钮 -->
        <div :class="[eidtTaskFlag?'transfer-edit-operating':'transfer-operating']">
          <div class="transfer-operate">
            <div :class="[item.updateFlag?'task-list-menu-update':'task-list-menu']"
              class="icon-util  task-operating-menu" v-if="showtasklistMenuOpen(item)"
              @click.stop="tasklistMenuOpen(index)">
              <div class="operate-menu" v-if="operateMenuIndex==index" ref="taskListMenus"
                v-clickoutside="tasklistMenuClose" :style="{top:taskListMenuTop+'Px'}">
                <!-- 点击查看日志 -->
                <div class="operate-menu-item" @click.stop="viewLogsOpen(item)">
                  <div class="icon-util remote-task operate-icon-position"></div>
                  <div class="operate-menu-name">{{$t('language.popup.taskListPopup.viewLogs')}}</div>
                </div>
                <!-- 还原 -->
                <div v-if="item.type==6" class="operate-menu-item" @click.stop="openBackupRestore()">
                  <div class="icon-util backup-restore-icon operate-icon-position"></div>
                  <div class="operate-menu-name">{{$t('language.cloudExploer.restore')}}</div>
                </div>
                <!-- 还原 -->
                <div v-if="item.type==6" class="operate-menu-item" @click.stop="openVersions()">
                  <div class="icon-util backup-version-icon operate-icon-position"></div>
                  <div class="operate-menu-name">{{$t('language.cloudBackup.versions')}}</div>
                </div>
                <!-- 点击查看设置 -->
                <div class="operate-menu-item" @click.stop="openOptionsDialog(item,index)">
                  <div class="icon-util properties operate-icon-position"></div>
                  <div class="operate-menu-name">{{$t('language.common.options')}}</div>
                </div>
                <!-- 点击查看时间设置 -->
                <div class="operate-menu-item" v-if="item.branchType != 'realtime'"
                  @click.stop="openSchduleDialog(item,index)">
                  <div :class="item.type==6?'schedule-backup-icon':'schedule'" class="icon-util  operate-icon-position">
                  </div>
                  <div class="operate-menu-name">{{$t('language.common.schedule')}}</div>
                </div>
                <!-- 点击删除任务 -->
                <div class="operate-menu-item" @click.stop="deleteTaskItem(item,index)">
                  <div class="icon-util delete operate-icon-position"></div>
                  <div class="operate-menu-name">{{$t('language.common.delete')}}</div>
                </div>
              </div>
            </div>
            <!-- 显示下拉菜单 -->
            <div class="icon-util  task-operating-menu"
              :class="[showSourceCollPageUp(item,index)?'task-list-operating-up':'task-list-operating-down',item.cancelingShow?'task-list-cancel-down':'']"
              @click.stop="collapsePage(index,item)" v-if="showCollPage(item)"></div>
            <!-- 显示按钮 -->
            <button id="canceling" v-loading="item.cancelingShow"
              :class="[item.updateFlag?'transfers-button-update':'transfers-button',eidtTaskFlag?'oprate-not-allowed':'',item.cancelingShow?'canceling item-onlyRead':'']"
              :disabled="eidtTaskFlag" @click.stop="clickButton(item,index)">{{buttonTxt}}
            </button>
            <!-- 付费提示按钮按钮 -->
            <!-- <button v-if="statusTxt==($t('language.common.waiting')+'...')&&!user.vip"
              class="runnow-button" @click.stop="runNowShow()">{{$t('language.common.runNow')}}
            </button> -->
          </div>
        </div>
        <!-- 显示任务状态 -->
        <div class="transfers-status">
          <!-- 传输状态 -->
          <div class="status-txt">
            <div v-if="iconName" class="icon-util tasks-icon-position" :class="iconName"></div>
            <div v-if="item.branchType=='realtime' && (item.status=='Run' || item.status=='Init')"
              class="realtimetasks-run Rotation tasks-icon-position  task-run-position">
            </div>
            <div
              v-if="item.branchType=='realtime' && (item.status=='Stop'||item.status == 'InitStop'|| item.status=='TimeoutStop')"
              class="icon-paused tasks-icon-position realtime-position"></div>
            <span v-if="(item.type==2 && item.sources && item.avgpercent)">
              <span @click.stop="viewLogs()"
                :class="item.branchType!='realtime'&&(iconName||item.viewed)?'operation-result':''">
                <span v-if="$i18n.locale=='deutsch'&&item.avgpercent">{{item.avgpercent}}%</span>
                {{$t('language.common.syncing')}}...
                <span v-if="$i18n.locale!='deutsch'&&item.avgpercent"> {{item.avgpercent}}%</span>

              </span>
            </span>
            <span v-else @click.stop="viewLogs()"
              :class="item.branchType!='realtime'&&(iconName||item.viewed)?'operation-result':''">{{statusTxt}}</span>
          </div>
        </div>
        <div class="traverse-time-out" v-if="item.status == 'TimeoutStop'" @click.stop="traverseOpen()">
          {{$t('language.cloudSync.timeOut')}}
        </div>
      </div>
    </div>
    <viewLogsDialog ref="viewLogsDialog"></viewLogsDialog>
    <transferOptionsDialog ref="transferOptionsDialog"></transferOptionsDialog>
    <emailTransferOptionsDialog ref="emailTransferOptionsDialog"></emailTransferOptionsDialog>
    <syncOptionsDialog ref="syncOptionsDialog"></syncOptionsDialog>
    <transferScheduleDialog ref="transferScheduleDialog"></transferScheduleDialog>
    <viewRealTimeLogsDialog ref="viewRealTimeLogsDialog"></viewRealTimeLogsDialog>
    <viewBackupLogsDialog ref="viewBackupLogsDialog"></viewBackupLogsDialog>
    <failedFilesDialog ref="failedFilesDialog"></failedFilesDialog>
    <backupOptionDialog ref="backupOptionDialog"></backupOptionDialog>
    <backupRestoreDialog ref="backupRestoreDialog"></backupRestoreDialog>
    <versionsDialog ref="versionsDialog"></versionsDialog>
    <deleteAttentionDialog ref="deleteAttentionDialog"></deleteAttentionDialog>
    <traveseDialog ref="traveseDialog"></traveseDialog>
    <noticeDialog ref="noticeDialog"></noticeDialog>
  </div>

</template>

<script>
  import Vue from 'vue';
  import commonUtils from "@/js/workspace/common_util.js";
  import selectDialog from "@/components/common/select/task_list_select";
  //单个传输任务详情
  import transferDetail from "@/components/common/tabs/tabs_task_list/tabs_transfer_detail";
  //单个云备份任务详情
  import backupDetail from "@/components/common/tabs/tabs_task_list/tabs_backup_detail";
  //显示多个同步任务详情
  import syncThreads from "@/components/common/tabs/tabs_task_list/tabs_sync_threads";
  //显示单个同步任务详情
  import syncDetail from "@/components/common/tabs/tabs_task_list/tabs_sync_detail";
  import transferScheduleDialog from "@/components/popup/task_list_popups/task_list_schedule_popup";
  import viewLogsDialog from "@/components/popup/task_list_popups/view_logs_popups";
  import commonstate from '@/js/constant.js';
  import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
  import taskListUtils from "@/js/workspace/task_list_util.js";
  import failedFilesDialog from "@/components/popup/task_list_popups/view_failed_files_popups";
  import transferOptionsDialog from "@/components/popup/task_list_popups/task_transfer_options_popup";
  import emailTransferOptionsDialog from "@/components/popup/task_list_popups/task_email_transfer_options_popup";
  import syncOptionsDialog from "@/components/popup/task_list_popups/task_sync_options_popup";
  import viewRealTimeLogsDialog from "@/components/popup/task_list_popups/view_realtime_logs_popups";
  import viewBackupLogsDialog from "@/components/popup/task_list_popups/view_backup_logs_popups";
  import backupOptionDialog from "@/components/popup/task_list_popups/backup_list_options_popup";
  import backupRestoreDialog from "@/components/popup/task_list_popups/backup_restore_popup";
  import versionsDialog from '@/components/popup/task_list_popups/list_versions_popup';
  import deleteAttentionDialog from "@/components/popup/task_list_popups/delete_version_attention_popup";
  import traveseDialog from '@/components/popup/task_list_popups/travese_time_popup';
  //任务详情
  import businessTransferDetail from "@/components/common/tabs/tabs_task_list/tabs_businessTransfer_detail";
  import noticeDialog from "@/components/popup/cloud_transfer_popups/transfer_notice_popup";
  export default {
    props: ['item', 'collapseFlage', 'index', 'tasklistData', 'detailShow', 'eidtTaskFlag', ],
    data: function() {
      return {
        threadChange: false, //用于子组件渲染界面
        hoverCurrent: -1,
        clickCurrent: -1,
        operateMenuIndex: -1,
        unfinishedArr: ["Cancel", "cancel", "error"],
        pathJson: [],
        taskListMenuTop: 32,
        executeFlag: true,
        taskUpTxt: 'cloudTransfer', //显示右上角的文案
        buttonTxt: this.$t('language.cloudTransfer.transferNow'), //用于显示按钮上的文字
        statusTxt: '', //显示单个任务的状态文案
        iconName: null,
        transferDetailChange: false, //用于子组件渲染界面
        refreshFlag: true, //标识是否刷新界面
        switchTypeFlag: true,
        openRestoreFlag: true, //标识是否打开还原界面
        user: commonUtils.getUser(),
      }
    },
    components: {
      "task-list-select": selectDialog,
      'transfer-detail': transferDetail,
      'sync-threads': syncThreads,
      'sync-detail': syncDetail,
      backupDetail,
      viewLogsDialog,
      failedFilesDialog,
      transferOptionsDialog,
      emailTransferOptionsDialog,
      syncOptionsDialog,
      transferScheduleDialog,
      viewRealTimeLogsDialog,
      viewBackupLogsDialog,
      backupOptionDialog,
      backupRestoreDialog,
      versionsDialog,
      deleteAttentionDialog,
      traveseDialog,
      businessTransferDetail,
      noticeDialog,
    },
    activated() {
      //初始化任务显示图标
      this.initTask();
      //初始化任务的进度
      this.initTaskListDataProgress();
    },
    watch: {
      transferDetailChange() {
        this.initTask();
      },
      executeFlag() {
        this.initTask();
      },
      // '$store.state.taskListArr':function(){
      //     this.initTask();
      // },
      threadChange() {
        this.initTask();
      },
      //     tasklistData:{
      //      immediate: true,
      //        handler(value) {
      //        this.initTask();
      //     }
      //     },
      item: {
        immediate: true,
        handler(value) {
          this.initTask();
        }
      }
    },
    mounted() {
      //初始化任务显示图标
      this.initTask();
      //初始化任务的进度
      this.initTaskListDataProgress();

    },
    methods: {
      initTask() {
        //显示左上角的文案
        this.showTaskUpTxt();
        //显示任务的状态
        this.showTaskStatus();
        //显示按钮的文案
        this.showButtonTxt();
      },
      getSingleHeight() {
        let height;
        let item = this.item;
        let collapseFlage = this.collapseFlage;
        let detailShow = this.detailShow;
        let index = this.index;
        let flag = commonUtils.isVip();
        let boxHeight = 390;
        if (flag) {
            boxHeight = 350;
        } else {
            boxHeight = 390;
        }
        if ((item.type == 1) && collapseFlage == index && detailShow && item.transferDetail && item.transferDetail
          .entities) {
          height = item.transferDetail.entities.length * 25 + boxHeight + 'Px';
        }
        if ((item.type == 6) && collapseFlage == index && detailShow && item.transferDetail && item.transferDetail
          .stateSet) {
          height = item.transferDetail.stateSet.length * 25 + boxHeight + 'Px';
        }
        if (item.type == 2 && collapseFlage != index) {
          height = 95 + 'Px';
        }
        if (item.type == 6 && collapseFlage != index) {
          height = 95 + 'Px';
        }
        return height;
      },
      getFromWidth() {
        var value = 0;
        value = 'calc(100% - ' + this.fromWidth + 'px)';
        return value;
      },
      //显示左上角的文案
      showTaskUpTxt() {
        if (this.item.branchType == 'businessTransfer') {
          this.taskUpTxt = this.$t('language.teamTransfer.organizationMigration');
          return;
        }
        if (this.item.type == 1) {
          this.taskUpTxt = this.$t('language.leftBanner.cloudTransfer');
          if (this.item.sources) {
            this.taskUpTxt = this.$t('language.taskList.MultiCloudTransfer');
          }
          if (this.item.options.way == 'cloudEmail') {
            this.taskUpTxt = this.$t('language.emailTransfer.cloudEmail');
          }
          return;
        }
        if (this.item.type == 2) {
          this.taskUpTxt = this.$t('language.leftBanner.cloudSync');
          if (this.item.branchType == 'realtime') {
            this.taskUpTxt = this.$t('language.cloudSync.realSync');
          }
          if (this.item.sources) {
            this.taskUpTxt = this.$t('language.taskList.multiCloudSync');
          }
          return;
        }
        if (this.item.type == 6) {
          if ((this.item.tranferWay == 'restore' || this.item.tranferWay == 'retry-restore') && (this.item.status ==
              'Running' || this.item.status == 'Waiting')) {
            this.taskUpTxt = this.$t('language.cloudBackup.restoreTask');
            return;
          }
          this.taskUpTxt = this.$t('language.cloudBackup.backupTask');
        }
      },
      //显示按钮的文案
      showButtonTxt() {
        if (this.item.branchType == 'realtime') {
          if (this.item.status != 'Stop' && this.item.status != 'InitStop' && this.item.status != 'TimeoutStop' && this.item.result != 'Cancel') {
            this.buttonTxt = this.$t('language.cloudSync.pause');
            return;
          }
          this.buttonTxt = this.$t('language.cloudSync.syncNow');
          return;
        }
        //如果任务未结束显示Cancel按钮
        if (this.showCancelButton()) {
          if (this.item.cancelingShow) {
            this.buttonTxt = null;
            return; //说明任务在取消状态中，不返回文案
          }
          this.buttonTxt = this.$t('language.common.cancel');
          return;
        }
        //如果任务是错误或者部分成功，或者取消显示reTransfer重传按钮
        if (this.showRetransferButton()) {
          if (this.item.type == 1) {
            this.buttonTxt = this.$t('language.taskList.reTransfer');
            return;
          }
          if (this.item.type == 2) {
            this.buttonTxt = this.$t('language.taskList.reSync');
            return;
          }
          if (this.item.type == 6) {
             if(this.item.tranferWay == 'backup' || this.item.tranferWay == 'retry-backup'){
            this.buttonTxt = this.$t('language.taskList.rebackup');
            return;
            }
            this.buttonTxt =  this.$t('language.cloudBackup.backupNow');
          }
          return;
        }
        //剩余情况显示Transfer Now 和 sync Now
        if (this.item.type == 1) {
          this.buttonTxt = this.$t('language.cloudTransfer.transferNow');
          return;
        }
        if (this.item.type == 2) {
          this.buttonTxt = this.$t('language.cloudSync.syncNow');
          return;
        }
        if (this.item.type == 6) {
          if ((this.item.statusTxt == this.$t('language.cloudBackup.backFailure') || this.item.statusTxt == this.$t(
              'language.cloudBackup.backupPartial'))) {
            this.buttonTxt = this.$t('language.taskList.rebackup');
            return;
          }
          // if(this.item.tranferWay == 'backup'){
          this.buttonTxt = this.$t('language.cloudBackup.backupNow');
          return;
          // }
          //this.buttonTxt = 'Restore Now';
          // return;
        }
      },
      //显示任务的状态
      showTaskStatus() {
        let item = this.item;
        this.iconName = null;
        this.statusTxt = null;
        if (item.branchType == 'realtime') {
          if (item.status == 'Stop' || item.status == 'InitStop' || item.status == 'TimeoutStop' || item.result == 'Cancel') {
            this.statusTxt = this.$t('language.cloudSync.paused');
            return;
          }
          if (item.status == 'Init') {
            this.statusTxt = this.$t('language.common.countFiles') + '...';
            //即时同步计数状态
            if (this.showRealTimeCountStatus(item)) {
              if (!item.sources) {
                this.statusTxt = this.$t('language.common.countFiles') + '...(' + item.readyFindFileCount + this.$t(
                  'language.common.transferFiles') + ',' + commonUtils.formatByte(item.totalBytes) + ')';
                return;
              } else {
                this.clountRealTimeFiles();
                this.statusTxt = this.$t('language.common.countFiles') + '...(' + item.allreadyFindFileCount + this.$t(
                  'language.common.transferFiles') + ',' + commonUtils.formatByte(item.alltotalBytes) + ')';
                return;
              }
            }
            return;
          }
          this.statusTxt = this.$t('language.cloudSync.realSyncing');
          return;
        }
        //显示任务的取消状态
        if (taskListUtils.showCancelStatus(item) || item.cancelStatus) {
          this.iconName = 'task-failure';
          this.statusTxt = this.$t('language.common.canceled');
          return;
        }
        //显示任务的运行状态 waiting counting running状态
        //running状态 1.单个或多个传输任务的运行状态
        if (taskListUtils.showTransferRunning(item)) {
          if (this.$i18n.locale != 'deutsch') {
            this.statusTxt = this.$t('language.common.transferring') + '...' + item.percent + '%';
          } else {
            this.statusTxt = item.percent + '%' + this.$t('language.common.transferring') + '...';
          }
          return;
        }
        //如果是备份任务运行中
        if (taskListUtils.showBackupRunning(item)) {
          if (!item.percent) {
            item.percent = 0;
          }
          if (item.tranferWay != 'restore' && item.tranferWay != 'retry-restore') {
            if (item.transferDetail && item.transferDetail.runningStatus == 3) {
              this.statusTxt = this.$t('language.cloudBackup.backingUp') + '...' + item.percent + '%' + this.$t(
                'language.cloudBackup.configFile');
              return;
            }
            if (item.transferDetail) {
              this.statusTxt = this.$t('language.cloudBackup.backingUp') + '...' + item.percent + '%';
            } else if (item.percent == 0) {
              this.statusTxt = this.$t('language.common.loadingData');
              return;
            }
          } else {
            if (item.transferDetail && item.transferDetail.runningStatus == 3) {
              this.statusTxt = this.$t('language.cloudBackup.restoring') + '...' + item.percent + '%' + this.$t(
                'language.cloudBackup.configFile');
              return;
            }
            if (item.transferDetail) {
              this.statusTxt = this.$t('language.cloudBackup.restoring') + '...' + item.percent + '%';
            } else if (item.percent == 0) {
              this.statusTxt = this.$t('language.common.loadingData');
              return;
            }

          }
          return;
        }
        //单目标同步运行中状态
        if (taskListUtils.showSyncSingleRunning(item)) {
          if (this.$i18n.locale != 'deutsch') {
            this.statusTxt = this.$t('language.common.syncing') + '...' + item.percent + '%';
          } else {
            this.statusTxt = item.percent + '%' + this.$t('language.common.syncing') + '...';
          }
          return;
        }
        //多目标同步运行中状态
        if (taskListUtils.showSyncSourceRunning(item)) {
          if (item.avgpercent) {
            if (this.$i18n.locale != 'deutsch') {
              this.statusTxt = this.$t('language.common.syncing') + '...' + item.avgpercent + '%';
              return;
            }
            this.statusTxt = item.avgpercent + '%' + this.$t('language.common.syncing') + '...';
            return;
          }
          this.statusTxt = this.$t('language.common.syncing') + '...';
          return;
        }
        //企业云盘传输的Counting状态
        if (this.showBusinessCountingStatus(item)) {
          var allCountFiles = 0;
          var allTotalBytes = 0;
          for (var i = 0; i < item.sources.length; i++) {
            if (item.sources[i].syncDetail && item.sources[i].syncDetail.state2.status == 1) {
              allCountFiles += item.sources[i].syncDetail.state2.readyFindFileCount;
              allTotalBytes += item.sources[i].syncDetail.state2.totalBytes;
            }
          }
          this.statusTxt = this.$t('language.common.countFiles') + '...(' + allCountFiles + this.$t(
            'language.common.transferFiles') + ',' + commonUtils.formatByte(allTotalBytes) + ')';
          return;
        }
        //2.计数状态
        if (this.showCountingStatus(item)) {
          if (item.type == 1) {
            this.statusTxt = this.$t('language.common.countFiles') + '...(' + item.transferDetail.state2
              .readyFindFileCount + this.$t('language.common.transferFiles') + ',' + commonUtils.formatByte(item
                .transferDetail.state2.totalBytes) + ')';
            return;
          }
          if (item.type == 2) {
            if (!item.sources) {
              this.statusTxt = this.$t('language.common.countFiles') + '...(' + item.syncDetail.readyFindFileCount +
                this.$t('language.common.transferFiles') + ',' + commonUtils.formatByte(item.syncDetail.totalBytes) +
                ')';
              return;
            }
            this.statusTxt = this.$t('language.common.countFiles') + '...(' + item.allreadyFindFileCount + this.$t(
              'language.common.transferFiles') + ',' + commonUtils.formatByte(item.alltotalBytes) + ')';
            return;
          }
          if (item.type == 6) {
            this.statusTxt = this.$t('language.common.countFiles') + '...(' + item.transferDetail.readyFindFileCount +
              this.$t('language.common.transferFiles') + ',' + commonUtils.formatByte(item.transferDetail.totalBytes) +
              ')';
            return;
          }
        }
        //3.显示任务准备状态
        if (taskListUtils.showSyncSingleWaiting(item) || taskListUtils.showTransferWaiting(item) || taskListUtils
          .showSyncSourceWaiting(item) || taskListUtils.showBackupWaiting(item)) {
          this.statusTxt = this.$t('language.common.waiting') + '...';
          return;
        }
        //显示失败，部分成功状态的任务
        //单源失败，单源部分成功 多源失败，多源部分成功
        if (!item.sources) {
          if (taskListUtils.showFailStatus(item)) {
            this.iconName = 'task-failure';
            if (item.type == 6) {
              if (item.tranferWay == 'restore' || item.tranferWay == 'retry-restore') {
                this.statusTxt = this.$t('language.cloudBackup.restoreFailure');
                return;
              }
              this.statusTxt = this.$t('language.cloudBackup.backFailure');
              return;
            }
            if (item.type == 1 && this.$parent.tasklistData[this.index].transferDetail) {
              delete this.$parent.tasklistData[this.index].transferDetail;
            }
            this.statusTxt = this.$t('language.common.failure');
            return;
          }
          if (taskListUtils.showpartialStatus(item)) {
            this.iconName = 'task-patial';
            if (item.type == 6) {
              if (item.tranferWay == 'restore' || item.tranferWay == 'retry-restore') {
                this.statusTxt = this.$t('language.cloudBackup.restorePartial');
              }else{
                this.statusTxt = this.$t('language.cloudBackup.backupPartial');
              }
              return;
            }
            this.statusTxt = this.$t('language.common.patial');
            return;
          }
          if (taskListUtils.showSuccessStatus(item)) {
            this.iconName = 'task-success';
            if (item.type == 6) {
              if (item.tranferWay != 'restore' && item.tranferWay != 'retry-restore') {
                this.statusTxt = this.$t('language.cloudBackup.backSuccess');
              } else {
                this.statusTxt = this.$t('language.cloudBackup.restoreSuccess');
              }
              return;
            }
            this.statusTxt = this.$t('language.common.success');
            return;
          }
        } else {
          if (taskListUtils.showSourcesFailureStatus(item)) {
            this.iconName = 'task-failure';
            if (item.tranferWay == 'restore' || item.tranferWay == 'retry-restore') {
              this.statusTxt = this.$t('language.cloudBackup.restoreFailure');
              return;
            }
            this.statusTxt = this.$t('language.common.failure');
            return;
          }
          if (taskListUtils.showSourcepartialStatus(item)) {
            this.iconName = 'task-patial';
            if (item.tranferWay == 'restore' || item.tranferWay == 'retry-restore') {
              this.statusTxt = this.$t('language.cloudBackup.restorePartial');
              return;
            }
            this.statusTxt = this.$t('language.common.patial');
            return;
          }
          //多源成功
          if (taskListUtils.showSourceSuccessStatus(item)) {
            if (item.type == 2) {
              if (this.$parent.$refs.allcollapsebox[this.index]) {
                this.$parent.$refs.allcollapsebox[this.index].style.height = '';
              }
              if (this.$refs.threadParents) {
                this.$refs.threadParents.style.height = '';
              }
            }
            this.iconName = 'task-success';
            this.statusTxt = this.$t('language.common.success');
            return;
          }
        }
        if (item.viewed && item.branchType != 'realtime' && item.status != 'Normal') {
          this.statusTxt = this.$t('language.popup.taskListPopup.viewLogs');
        }
      },
      //点击最右边按钮
      clickButton() {
        if (this.item.cancelingShow) {
          return;
        }
        if (this.buttonTxt == this.$t('language.common.cancel')) {
          if (this.item.type == 6) {
            this.cancelBackupRun(this.item, this.index);
            return;
          }
          this.cancelTaskRun(this.item, this.index);
          return;
        }
        if (this.item.branchType == "realtime") {
          if (this.item.status != "Stop" && this.item.status != "InitStop" && this.item.result != "Cancel") {
            this.pauseTask();
            return;
          }
          //运行即时同步任务
          this.runRealTimeTask();
          return;
        }
        this.executeTask(this.item, this.index)
      },
      getRealTimeSyncStatus() {
        let that = this;
        if (!this.item.sources) {
          this.getSingleRealTimeProgress(this.item);
        } else {
          this.getSingleRealTimeProgress(this.item);
          $.each(this.item.sources, function(j, jItem) {
            that.getSingleRealTimeProgress(jItem);
          });
        }
      },
      getSingleRealTimeProgress(item) {
        let that = this;
        //如果即时同步的任务状态是Init那么循环获取
        let getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, null);
        this.Utils.doTasksRequest("get_progress", getData).then(result => {
          if (result.status == 200) {
            if (result.progress) {
              that.$parent.tasklistData[that.index].readyFindFileCount = result.progress.readyFindFileCount;
              that.$parent.tasklistData[that.index].totalBytes = result.progress.totalBytes;
              that.$parent.tasklistData[that.index].runningStatus = result.progress.runningStatus;
              that.showTaskStatus();
              if (result.progress.runningStatus <= 1) {
                that.item.realTime = setTimeout(() => {
                  that.getSingleRealTimeProgress(item);
                }, 4000);
              } else {
                that.$parent.tasklistData[that.index].status = 'Run';
                clearTimeout(that.item.realTime);
                that.showTaskStatus();
              }
            } else {
              that.$parent.tasklistData[that.index].status = 'Run';
              clearTimeout(that.item.realTime);
              if (that.item.sources) {
                $.each(that.item.sources, function(j, jItem) {
                  clearTimeout(jItem.realTime);
                });
              }
              that.showTaskStatus();
            }
          }
        });
      },
      openVersions() {
        this.$refs.versionsDialog.versionShow = true;
        this.operateMenuIndex = -1;
        let item = this.item;
        let that = this;
        let getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, item.groupId);
        this.Utils.doTasksRequest("list_versions", getData).then(result => {
          if (result.backup_versions.length) {
            that.$refs.versionsDialog.notRunShow = false;
            result.backup_versions.sort(taskListUtils.sortCreateTime);
            that.$refs.versionsDialog.versions = result.backup_versions;
            that.$refs.versionsDialog.backupRoot = result.backup_backupRoot;
            $.each(that.$refs.versionsDialog.versions, function(j, jItem) {
              jItem.taskId = item.id;
            });
          } else {
            that.$refs.versionsDialog.notRunShow = true;
          }
        });
      },
      //打开付费提示弹窗
      runNowShow(){
        var upgradeNewDialog = this.$parent.$refs.upgradeNewDialog;
        upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_real');
        upgradeNewDialog.curItem = 'real';
        upgradeNewDialog.isShow = true;
        this.switchTypeFlag = true;
        this.executeFlag = true;
      },
      runRealTimeTask() {
        if (!this.switchTypeFlag) {
          return;
        }
        let item = this.item;
        let that = this;
        let realTimeArr = [];
        let syncArr = [];
        let user = commonUtils.getUser();
        let allData = this.$store.state.taskListArr;
        for (let i = 0; i < allData.length; i++) {
          if (allData[i].branchType == 'realtime' && (allData[i].status == 'Run' || allData[i].status == 'Init')) {
            realTimeArr.push(allData[i]);
          }
          for (let i = 0; i < allData.length; i++) {
            if (allData[i].type == 2 && (allData[i].status == 'Running' || allData[i].status == 'Waiting')) {
              syncArr.push(allData[i]);
            }
          }
        }
        this.switchTypeFlag = false;
        //非会员用户不能同时执行两个同步任务，但是可以执行两个传输任务，或者一个同步，一个传输任务
        if (!user.vip && realTimeArr.length >= 1 && item.branchType == 'realtime') {
          var upgradeNewDialog = this.$parent.$refs.upgradeNewDialog;
          upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_real');
          upgradeNewDialog.curItem = 'real';
          upgradeNewDialog.isShow = true;
          this.switchTypeFlag = true;
          this.executeFlag = true;
          return false;
        }
        //取消限制
        if (user.vip && (realTimeArr.length >= 2 && syncArr.length >= 2)) {
          that.$toast({
            text: this.$t('language.exception.taskRunningNumberLimited'),
            type: 'fail',
            idValue: "rightBodyList"
          });
          this.switchTypeFlag = true;
          this.executeFlag = true;
          return false;
        }
        let runData = {
          id: item.id,
          ud: commonUtils.getUser().id,
        }
        this.Utils.doRealtimeSyncRequest('switch_status', runData).then(res => {
          that.switchTypeFlag = true;
          that.executeFlag = true;
          if (res.message == 'success') {
            if (res.data.status == 'Init') {
              that.getRealTimeSyncStatus();
            }
            if (res.data.status == 'Run') {
              that.item.t = setTimeout(() => {
                that.getRealTimeStatus();
              }, 300000);
            }
            item.status = res.data.status;
            if (item.sources) {
              $.each(item.sources, function(i, sitem) {
                sitem.status = res.data.status;
              });
            }
            that.initTask();
          } else {
            if(!user.vip && res.reason=="taskRunningNumberLimited"){
              var upgradeNewDialog = that.$parent.$refs.upgradeNewDialog;
              upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_real');
              upgradeNewDialog.curItem = 'real';
              upgradeNewDialog.isShow = true;
              return false;
            }
            that.$toast({
              text: this.$t('language.exception.' + res.reason),
              type: 'fail',
              idValue: "rightBodyList"
            });
            return false;
          }
        });
      },
      pauseTask() {
        if (!this.switchTypeFlag) {
          return;
        }
        if(this.item.type==1){
          //如果是邮件同步
          this.pauseEmailTask();
          return;
        }
        let item = this.item;
        let that = this;
        let stopData = {
          id: item.id,
          ud: commonUtils.getUser().id,
        }
        clearTimeout(item.t);
        item.updateFlag = true;
        this.switchTypeFlag = false;
        clearTimeout(that.item.realTime);
        this.Utils.doRealtimeSyncRequest('switch_status', stopData).then(res => {
          item.updateFlag = false;
          clearTimeout(that.item.realTime);
          clearTimeout(that.item.t);
          if (res.message == 'success') {
            item.status = res.data.status;
            if (item.sources) {
              $.each(item.sources, function(i, sitem) {
                sitem.status = res.data.status;
                clearTimeout(sitem.realTime);
              });
            }
            delete item.transferGet; //删除已获取进度标识
            that.executeFlag = true;
            that.$forceUpdate();
            that.taskToItemDataRefresh(item, function(res) {});
            //获取该任务最新信息
            that.initOneRealTimeTask(item, function(res) {
              that.switchTypeFlag = true;
            });
            //刷新用户流量
            that.initTask();
            commonUtils.refreshUserInfo(that, function(res) {});
          } else {
            that.$toast({
              text: that.$t('language.exception.' + res.reason),
              type: 'fail',
              idValue: "rightBodyList"
            });
            return false;
          }
        });
      },
      pauseEmailTask() {
        if (!this.switchTypeFlag) {
          return;
        }
        let item = this.item;
        let that = this;
        let stopData = {
          id: item.id,
          ud: commonUtils.getUser().id,
        }
        clearTimeout(item.t);
        item.updateFlag = true;
        this.switchTypeFlag = false;
        this.Utils.doEmailTasksRequest('pause', stopData).then(res => {
          item.updateFlag = false;
          clearTimeout(that.item.t);
          if (res.message == 'success') {
            item.result = "Cancel";
            that.executeFlag = true;
            that.$forceUpdate();
            that.taskToItemDataRefresh(item, function(res) {});
            //获取该任务最新信息
            that.initOneTask(item, function(res) {
              that.initTaskListDataProgress();
            });
            //刷新用户流量数据
            taskListUtils.originalPage(index, that);
            //刷新用户流量
            that.initTask();
            commonUtils.refreshUserInfo(that, function(res) {});
          } else {
            that.$toast({
              text: that.$t('language.exception.' + res.reason),
              type: 'fail',
              idValue: "rightBodyList"
            });
            return false;
          }
        });
      },
      //任务结束后初始化即时同步任务
      initOneRealTimeTask(item, callback) {
        let that = this;
        let getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, item.groupId);
        this.Utils.doRealtimeSyncRequest("get", getData).then(result => {
          if (result.message == 'success') {
            let tasks = result.tasks;
            let allTaskListArr = that.packageTaskList(tasks);
            $.each(allTaskListArr, function(i, aitem) {
              if (aitem.id == item.id) {
                aitem.transferGet = true;
                return false;
              }
            })
            allTaskListArr.sort(taskListUtils.sortCreateTime);
            that.$store.commit('setTaskListArrAll', allTaskListArr);
            that.$parent.tasklistData = allTaskListArr;
            that.$forceUpdate();
            callback(result);
          }
        });

      },
      //查看任务日志
      viewLogs() {
        if (!this.iconName && !this.item.viewed) {
          return;
        }
        if (this.item.branchType == 'realtime') {
          return;
        }
        if (this.item.branchType == 'businessTransfer') {
          if (this.item.status == 'Waiting' || this.item.status == 'Running') {
            return;
          }
        }
        this.viewLogsOpen();
      },
      openBackupRestore(value) {
        let item = this.item;
        let that = this;
        if (!this.openRestoreFlag) {
          return;
        }
        this.openRestoreFlag = false;
        this.operateMenuIndex = -1;
        let dialog = this.$refs.backupRestoreDialog;
        dialog.selecTimeValue = '';
        dialog.$refs.selectOne.currentValue = '';
        let getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, item.groupId);
        this.Utils.doTasksRequest("list_versions", getData).then(result => {
          that.operateMenuIndex = -1;
          if (result.backup_versions.length) {
            dialog.restoreShow = true;
            dialog.stepOne = true;
            dialog.loading = true;
            dialog.onChangeOptionType(this.$t('language.cloudBackup.keepLatest'));
            let array = result.backup_versions;
            //将array通过里面的createTime从新到旧进行排序
            array.sort(taskListUtils.sortCreateTime);
            dialog.versions = array;
            dialog.itemIndex = that.index;
            dialog.selectTimeOption = [];
            dialog.timeOptionAll = [];
            dialog.catalogModel = [];
            let firstItem;
            for (let index = 0; index < array.length; index++) {
              if (index == 0) {
                dialog.selecTimeValue = commonUtils.transferForMatTime(array[index].createTime);
                dialog.$refs.selectOne.currentValue = dialog.selecTimeValue;
                firstItem = {
                  name: dialog.selecTimeValue,
                  bId: array[index].id,
                  backupId: array[index].backupId,
                  versionNum: array[index].versionNum,
                  icon: false,
                  id: 0
                }
              } else {
                let item = commonUtils.transferForMatTime(array[index].createTime);
                dialog.selectTimeOption.push({
                  name: item,
                  backupId: array[index].backupId,
                  bId: array[index].id,
                  versionNum: array[index].versionNum,
                  icon: false,
                  id: index
                });
              }
              if (index == array.length - 1) {
                dialog.timeOptionAll = dialog.selectTimeOption;
                if (firstItem) {
                  dialog.timeOptionAll.unshift(firstItem);
                }
              }
            }
            if (value) {
              dialog.$refs.selectOne.currentValue = commonUtils.transferForMatTime(value);
            }
            that.listRestoreCatalog(result, function(res) {});
          } else { //如果没有返回版本信息再调用taks/get
            delete getData.s;
            this.Utils.doTasksRequest("get", getData).then(result => {
              if (result.status == 200) {
                if (result.tasks[0].lastLog) {
                  that.openRestoreFlag = true;
                  that.$toast({
                    text: that.$t('language.cloudBackup.notRestore'),
                    type: 'fail',
                    idValue: "rightBodyList"
                  });
                } else {
                  let dialog = that.$refs.backupRestoreDialog;
                  dialog.restoreShow = true;
                  dialog.stepOne = true;
                  dialog.execute = false;
                  that.openRestoreFlag = true;

                }
              }
            });
          }
        });
      },
      //列出还原目录
      listRestoreCatalog(value, callback) {
        let that = this;
        let dialog = this.$refs.backupRestoreDialog;
        dialog.loading = false;
        this.openRestoreFlag = true;
        dialog.isSources = false;
        if (this.item.fromItem.data && this.item.fromItem.data.length) {
          //listData.bpid = 1;
          dialog.isSources = true;
        }
        dialog.catalogModel = [];
        dialog.catalogModelCopy = [];
        dialog.vd = value.backup_versions[0].id;
        dialog.backupId = value.backup_versions[0].backupId;
        dialog.versionNum = value.backup_versions[0].versionNum;
        return;

      },

      openBackupSource(data) {
        this.$parent.$refs.backupSourceFilesDialog.allDriveIds = [];
        this.$parent.$refs.backupSourceFilesDialog.model = [];
        this.$parent.$refs.backupSourceFilesDialog.viewBackupShow = true;
        this.$parent.$refs.backupSourceFilesDialog.sourceData = data;
        this.$parent.$refs.backupSourceFilesDialog.isTarget = false;
      },
      openBackupToItems(data) {
        this.$parent.$refs.backupSourceFilesDialog.allDriveIds = [];
        this.$parent.$refs.backupSourceFilesDialog.model = [];
        this.$parent.$refs.backupSourceFilesDialog.viewBackupShow = true;
        this.$parent.$refs.backupSourceFilesDialog.sourceData = data;
        this.$parent.$refs.backupSourceFilesDialog.isTarget = true;
      },
      //获取多个目标目录，返回目录数组
      getMultiAimsCatalog(itemData) {
        let catalogArr = [];
        let catalogName = commonUtils.getCatalog(itemData.toItem.nodes);
        let catalog = {
          catalog: catalogName,
          toItem: itemData.toItem
        }
        catalogArr.push(catalog);
        $.each(itemData.sources, function(i, item) {
          let catalogMultName = commonUtils.getCatalog(item.toItem.nodes);
          let catalogMult = {
            catalog: catalogMultName,
            toItem: item.toItem
          }
          catalogArr.push(catalogMult);
        });
        return catalogArr;
      },
      //显示能打开任务菜单
      showtasklistMenuOpen(item) {
        let flag;
        if (item.type == 2 && item.branchType == 'realtime') {
          flag = true;
          return flag;

        }
        if (item.type == 1 && item.branchType == 'businessTransfer' && item.status == 'Done') {
          flag = true;
          return flag;
        }
        if (!taskListUtils.judgeTaskEnd(item) && !item.sources) {
          flag = false;
          return flag;
        }
        if (item.status != 'Running' && item.status != 'Waiting' && item.status != 'Restoring') {
          flag = true;
        } else {
          flag = false;
        }
        if (item.sources) {
          $.each(item.sources, function(i, sourceItem) {
            if (sourceItem.status == 'Running' || sourceItem.status == 'Waiting' || sourceItem.status ==
              'Restoring') {
              flag = false;
            }
          });
          if (taskListUtils.showSyncSourceWaiting(item)) {
            flag = false;
          };
        }
        if (flag) {
          this.clearLocalPercent(item);
          if (item.type == 2 && item.sources && item.avgpercent) {
            delete item.avgpercent;
            this.$forceUpdate();
            this.$parent.collapseFlage = -1;
            this.$parent.detailShow = false;
            this.$forceUpdate();
            if (this.$refs.syncThread) {
              this.$refs.syncThread.closePage();
            }
          }
          if (this.$parent.collapseFlage == this.index && !item.sources) {
            this.$parent.collapseFlage = -1;
            this.$parent.detailShow = false;
            this.$forceUpdate();
          }
          taskListUtils.originalPage(this.index, this);
        }
        this.$parent.$forceUpdate();
        return flag;
      },
      showBackGround(item) {
        if ((item.type == 1 && taskListUtils.showTransferRunning(item)) || (!item.sources && item.type == 2 &&
            taskListUtils.showSyncSingleRunning(item)) || item.type == 6 && taskListUtils.showBackupRunning(item)) {
          if (item.percent && this.refreshFlag) {
            this.refreshFlag = false;
            this.transferDetailChange = !this.transferDetailChange;
          }
          return true;
        }
      },
      //检查任务的状态是否为取消状态
      checkItemCancel(item) {
        let flag = true;
        if (item.result && item.result.toLowerCase() == 'cancel') {
          flag = false;
          return false;
        } else {
          $.each(item.sources, function(i, sourceItem) {
            if (sourceItem.result && sourceItem.result.toLowerCase() == 'cancel') {
              flag = false;
              return false;
            }
          });
        }
        return flag;
      },
      //显示查看任务状态
      showViewLogStatus(item) {
        let flag = false;
        if (!item.sources && item.viewed && item.result != 'success' && item.status != 'Running' && item.result !=
          "cancel" && ((item.errorFileCount / item.totalFileCount) * 100 > 20)) {
          flag = true;
        }
        if (item.viewed && item.sources && taskListUtils.testSources(item) == 0 && item.status != 'Running') {
          flag = true;
        }

        if (!item.sources && item.viewed && item.result && item.result == "error" && (item.errorFileCount == 1 && item
            .status != 'Running')) {
          flag = true;
        }
        return flag;
      },
      //显示任务运行中的下拉箭头
      showCollPage(item) {
        let flag;
        if (item.branchType == 'businessTransfer' && item.status == 'Done' && !taskListUtils.showTransferRunning(
          item)) {
          flag = false;
          return flag;
        }
        if (item.branchType != 'realtime' && ((!item.sources && !taskListUtils.judgeTaskEnd(item)) || this
            .showSourcesCollPage(item))) {
          flag = true;
        }
        return flag;
      },
      //多源多目标任务显示下拉菜单
      showSourcesCollPage(item) {
        let flag;
        if (item.type == 2 && item.sources && (item.status == 'Running' || item.status == 'Waiting') && (item
            .avgpercent != 100)) {
          flag = true;
        }
        if (item.type == 1 && item.sources && (item.status == 'Running' || item.status == 'Waiting') && !item.result) {
          flag = true;
        }
        if (item.sources) {
          $.each(item.sources, function(i, sourceItem) {
            if ((sourceItem.status == 'Running' || sourceItem.status == 'Waiting')) {
              flag = true;
            }
          });
        }
        return flag;
      },
      isNumber(val) { //判断字段是否是数字
        var regPos = /^\d+(\.\d+)?$/; //非负浮点数
        var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
        if (regPos.test(val) || regNeg.test(val)) {
          return true;
        } else {
          return false;
        }
      },
      //单源单目标显示下拉菜单
      showSourceCollPageUp(item, index) {
        let flag;
        if (((item.status == 'Running' || (item.avgpercent && item.avgpercent != 100)) && this.detailShow && this
            .$parent.collapseFlage == index && (item.transferDetail || item.syncDetail)) || ((item.status ==
              'Waiting' || (item.avgpercent && item.avgpercent != 100)) && this.detailShow && this.$parent
            .collapseFlage == index && (item.transferDetail || item.syncDetail))) {
          flag = true;
        }
        return flag;
      },
      //初始化界面进度
      initTaskListDataProgress() {
        let that = this;
        if (this.item.branchType != 'realtime') {
          this.judgeShowProgress(); //显示每一个的进度
        } else if (this.item.status == 'Init') {
          this.getRealTimeSyncStatus();
        } else if (this.item.status == 'Run') {
          this.getRealTimeStatus();
        }
        //定时获取任务
        this.getTimedExecution();
      },
      //显示企业云盘传输的counting状态
      showBusinessCountingStatus(item) {
        if (item.type == 1 && item.branchType == 'businessTransfer' && item.status != 'Done') {
          for (var i = 0; i < item.sources.length; i++) {
            if (item.sources[i].syncDetail && (item.sources[i].syncDetail.state2.status == 'Done')) {
              return false;
            } else {
              if (item.sources[i].syncDetail && item.sources[i].syncDetail.state2.status == 1) {
                return true;
              }
            }
          }
        }
      },
      showCountingStatus(item) {
        if (item.type == 1) {
          if (item.transferDetail && item.transferDetail.state2 && item.transferDetail.state2.status == 1) {
            return true;
          }
        } else {
          if (!item.sources) {
            if (item.syncDetail && item.syncDetail.runningStatus == 1) {
              return true;
            }
          }
          if (this.showSyncSourceCounting(item)) {
            return true;
          }
        }
        if (item.type == 6 && item.transferDetail && item.transferDetail.runningStatus == 1) return true;
      },
      showRealTimeCountStatus(item) {
        if (item.runningStatus <= 1) {
          return true;
        }
      },
      //显示多目标任务的计数状态
      showSyncSourceCounting(item) {
        let that = this;
        let flag;
        let sourceArr = [];
        let resultArr = [];
        let resultFile = [];
        let resultByte = [];
        sourceArr.push(item);
        sourceArr.concat(item.sources);
        $.each(sourceArr, function(sIndex, sItem) {
          if ((item.syncDetail && item.syncDetail.runningStatus == 0)) {
            resultArr.push(1);
            resultByte.push(item.syncDetail.totalBytes);
            resultArr.push(item.syncDetail.readyFindFileCount);
          }
          if (sIndex == sourceArr.length - 1) {
            if (commonUtils.isAllEqual(resultArr) && resultArr[0] == 1) {
              flag = true;
              item.allreadyFindFileCount = that.sum(resultFile);
              item.alltotalBytes = that.sum(resultByte);
            }
          }
        });
        return flag;
      },
      clountRealTimeFiles() {
        let that = this;
        let item = this.item;
        let sourceArr = [];
        sourceArr.push(item);
        sourceArr.concat(item.sources);
        let resultFile = [];
        let resultByte = [];
        $.each(sourceArr, function(sIndex, sItem) {
          if (item.runningStatus == 1) {
            resultByte.push(item.totalBytes);
            resultFile.push(item.readyFindFileCount);
          }
          if (sIndex == sourceArr.length - 1) {
            let allreadyFindFileCount = that.sum(resultFile);
            if (allreadyFindFileCount != 0) {
              item.allreadyFindFileCount = allreadyFindFileCount;
            }
            let alltotalBytes = that.sum(resultByte);
            item.alltotalBytes = alltotalBytes;
          }
        });


      },
      sum(arr) { //求和
        var len = arr.length;
        if (len == 0) {
          return 0;
        } else if (len == 1) {
          return arr[0];
        } else {
          return arr[0] + sum(arr.slice(1));
        }
      },
      //选择左边的云盘
      selectOption(sourceData) {
        let dom;
        let that = this;
        let driveId;
        if (sourceData.driveId) {
          driveId = sourceData.driveId;
        } else {
          driveId = sourceData.nodes[0].tokenId;
        }
        $.each(that.$parent.$parent.$children, function(i, item) {
          if (item.menuOptions) { //如果是left_banner组件
            dom = that.$parent.$parent.$children[i];
            return;
          }
        });
        dom.driveOptionSelect(driveId);
      },
      //跳转到目标云盘的目录
      toAimCatalog(aimData, type) {
        if (type == 'businessTransfer') {
          aimData.id = aimData.nodes[aimData.nodes.length - 1].fileId;
          aimData.name = aimData.nodes[aimData.nodes.length - 1].fileName;

        }
        this.flag = false;
        //刷新用户流量
        commonUtils.refreshUserInfo(this.$parent, function(res) {});
        let that = this;
        let folderId = aimData.id;
        if (!folderId) {
          folderId = aimData.fileId;
        }
        let fileName = aimData.name;
        this.$store.state.openFileFlag = false; //将云盘管理界面是否打开文件置为否
        let driveId;
        if (aimData.driveId) {
          driveId = aimData.driveId;
        } else {
          driveId = aimData.nodes[0].tokenId;
        }
        let pathData = this.$store.state.pathJson[folderId + driveId];
        this.encapsulationPath(aimData, pathData);
        this.selectOption(aimData);
        if (this.item.branchType == 'realtime') {
          let listData = new cloudExploerUtils.filelistData(this.item.toItem.id, commonUtils.getUser().id, driveId);
          commonUtils.toItemDataRefreshQuest(listData, this.item, function(res) {});
        }
        this.$router.push({
          name: "cloudExploer",
          query: {
            cloudType: aimData.driveType,
            folderId: folderId,
            folderName: fileName,
            tokenId: driveId
          }
        });

      },
      toSyncSourceCatalog(aimData) {
        this.flag = false;
        let that = this;
        let folderId = aimData.id;
        let fileName = aimData.name;
        //刷新用户流量
        commonUtils.refreshUserInfo(this.$parent, function(res) {});
        this.$store.state.openFileFlag = false; //将云盘管理界面是否打开文件置为否
        let driveId;
        if (aimData.driveId) {
          driveId = aimData.driveId;
        } else {
          driveId = aimData.nodes[0].tokenId;
        }
        let pathData = this.$store.state.pathJson[folderId + driveId];
        this.encapsulationPath(aimData, pathData);
        this.selectOption(aimData);
        this.$router.push({
          name: "cloudExploer",
          query: {
            cloudType: aimData.driveType,
            folderId: folderId,
            folderName: fileName,
            tokenId: driveId
          }
        });
      },
      //跳转到源目录
      toSourceCatalog(sourceData, type) {
        let folderId;
        let fileName;
        let that = this;
        let leng = sourceData.nodes.length;
        //刷新用户流量
        commonUtils.refreshUserInfo(this.$parent, function(res) {});
        let driveId;
        this.$store.state.openFileFlag = false; //将云盘管理界面是否打开文件置为否
        if (sourceData.driveId) {
          driveId = sourceData.driveId;
        } else {
          driveId = sourceData.nodes[0].tokenId;
        }
        //若源为云盘根目录,点击后直接打开云盘根目录,子账号
        if (leng <= 1 || type == 'businessTransferAccount') {
          folderId = sourceData.id;
          fileName = sourceData.name;
          if (!folderId) {
            folderId = sourceData.fileId;
            fileName = sourceData.fileName;
          }
        } else {
          //若源为云盘子文件夹/文件，点击后直接在上一级目录选中该文件夹
          folderId = sourceData.nodes[1].fileId;
          if (sourceData.nodes[1].filename) {
            fileName = sourceData.nodes[1].filename;
          } else {
            fileName = sourceData.nodes[1].fileName;
          }
        }
        let listData = new cloudExploerUtils.filelistData(folderId, commonUtils.getUser().id, driveId, null, null,
        null);
        let pathData = this.$store.state.pathJson[folderId + driveId];
        this.encapsulationPath(sourceData, pathData);
        this.selectOption(sourceData);
        var storeFileId;
        storeFileId = sourceData.id;
        if (!sourceData.id) {
          storeFileId = sourceData.fileId;
        }
        if (!type) {
          that.$store.commit("setCatalogFileId", storeFileId);
        }
        if(commonstate.emailClouds.includes(sourceData.driveType)) {
          this.$router.push({
            name: "emailExploer",
            query: {
              cloudType: sourceData.driveType,
              folderId: folderId,
              folderName: fileName,
              tokenId: driveId,
              docType: sourceData.docType,
              queryParameter: sourceData.queryParameter
            }
          });
        }else{
          this.$router.push({
            name: "cloudExploer",
            query: {
              cloudType: sourceData.driveType,
              folderId: folderId,
              folderName: fileName,
              tokenId: driveId
            }
          });
        }
      },
      //清除本地任务进度缓存
      clearLocalPercent(item) {
        if (localStorage.getItem(item.id)) {
          localStorage.setItem(item.id, 0);
        }
        if (item.sources) {
          $.each(item.sources, function(j, jItem) {
            if (localStorage.getItem(jItem.id)) {
              localStorage.setItem(jItem.id, 0);
            }
          });
        }
      },
      //显示立即传输按钮
      showSyncButton(item) {
        let flag = false;
        let that = this;
        let statusArr = [];
        if (((item.status == 'Normal') && !item.sources && item.type == 2 && !item.result) || (item.result ==
            'success' && item.status.toLowerCase() != 'canceled' && item.type == 2 && !item.sources)) {
          flag = true;
        }
        if (item.type == 2 && item.sources) {
          if (item.status == 'Running' || item.status == 'Waiting' || taskListUtils.testSources(item) ==
            0) { //2成功 1部分成功 0失败
            if (item.result) {
              statusArr.push(item.result.toLowerCase());
            }
            flag = false;
            return;
          } else {
            if (item.result) {
              statusArr.push(item.result.toLowerCase());
            }
            flag = true;
          }
          $.each(item.sources, function(sIndex, sItem) { //2成功 1部分成功 0失败
            if (sItem.status == 'Running' || sItem.status == 'Waiting' || (taskListUtils.testSources(item) != 2)) {
              flag = false;
              return false;
            } else {
              flag = true;
            }
            if (sItem.result) {
              statusArr.push(sItem.result.toLowerCase());
            }
          });
          //如果全部都是已取消状态，则显示re-transfer
          if (statusArr[0] == 'cancel' && commonUtils.isAllEqual(statusArr)) {
            flag = false;
          }
        }
        return flag;
      },
      showCancelButton() { //表示该任务未结束
        let flag;
        let item = this.item;
        //判断单个任务未结束
        if (!taskListUtils.judgeTaskEnd(item) && !item.sources) {
          flag = true;
          return flag;
        }
        if (item.branchType == 'businessTransfer' && (item.status == 'Running' || item.status == 'Waiting')) {
          return true;
        }
        //如果是多源或者多目标任务
        if (item.sources && item.branchType != 'businessTransfer') {
          $.each(item.sources, function(sIndex, sItem) {
            //如果任务状态在运行或者等待中
            if ((sItem.status == 'Running' || sItem.status == 'Waiting' || (sItem.syncDetail && sItem.syncDetail
                .runningStatus == 0))) {
              flag = true;

            }
          });
        }
        return flag;
      },
      //显示重传按钮
      showRetransferButton() {
        let that = this;
        let item = this.item;
        let flag;
        //判断单个任务未结束，直接返回错误
        if (!taskListUtils.judgeTaskEnd(item) && !item.sources) {
          return false;
        }
        //如果单个任务存在错误任务，且结果为取消cancel或者错误error
        if (!item.sources && (this.unfinishedArr.includes(item.result) || item.errorFileCount || item.status ==
            'Canceled')) {
          flag = true;
        }
        if (item.sources && item.branchType != 'businessTransfer') {
          if (taskListUtils.judgeTaskEnd(item) && (this.unfinishedArr.includes(item.result) || item.errorFileCount ||
              item.status == 'Canceled')) {
            flag = true;
          }
          //遍历多源多目标子任务，如果结果未结束并是错误或者取消，则显示重传按钮
          $.each(item.sources, function(sIndex, sItem) {
            if (taskListUtils.judgeTaskEnd(sItem) && (that.unfinishedArr.includes(sItem.result) || sItem
                .errorFileCount || sItem.status == 'Canceled')) {
              flag = true;
            }
          });
        }
        if (item.branchType == 'businessTransfer') {
          if (this.unfinishedArr.includes(item.result) || item.errorFileCount || item.status == 'Canceled') {
            flag = true;
          }
        }
        return flag;
      },
      //改变任务的设定时间状态
      changeSchedulesStatus(itemData, index) {
        if (!itemData.updateFlag) {
          let item = Object.assign({}, itemData);
          var updateData;
          let schedules = Object.assign({}, item.schedules);
          let options = Object.assign({}, item.options);
          let disabled;
          let that = this;
          let schType = commonUtils.substringType(schedules.type);
          itemData.updateFlag = true;
          let getData;
          let timeArr = [];
          for (let i = 0; i < schedules.times.length; i++) {
            if (schedules.times[i] && schedules.times[i] != '"null"') {
              timeArr.push(schedules.times[i]);
            }
          }
          schedules.times = timeArr;
          schedules.type = schType;
          if (item.schedules.disabled == false || item.schedules.disabled == true) {
            disabled = !item.schedules.disabled;
          } else if (item.schedules.disabled == undefined) {
            disabled = true;
          }
          schedules.disabled = disabled;
          if (schedules.type == 'Monthly' || schedules.type == '=Monthly') {
            schedules.days = this.packageMonthDaysData(item);
          }
          if (schedules.type == 'Weekly' || schedules.type == '=Weekly') {
            schedules.weeks = this.packageWeekDaysData(item);
          }
          delete schedules.outDate;
          schedules.clientTime = commonUtils.getNowDateFormat();
          if (item.groupId) {
            updateData = new taskListUtils.updateGdData(item.groupId, commonUtils.getUser().id, item.type, item.name,
              options, schedules);
          } else {
            updateData = new taskListUtils.updateIdData(item.id, commonUtils.getUser().id, item.type, item.name,
              options, schedules);
          }
          item.schedules.disabled = disabled;
          if (this.item.branchType != 'businessTransfer') {
              this.Utils.doTasksRequest("update", updateData).then(result => {
              if (result.status == 200) {
                if (item.groupId) {
                  getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, null, item.groupId);
                } else {
                  getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, null);
                }
                itemData.updateFlag = false;
                that.$forceUpdate();
                that.Utils.doTasksRequest("get", getData).then(res => {
                  $.each(that.$parent.tasklistData, function(i, data) {
                    if (data.id == res.tasks[0].id) {
                      data.schedules = res.tasks[0].schedules;
                    }
                  })
                });
                if (disabled) {
                  clearTimeout(item.timeoutExeCute);
                  delete item.timeoutExeCute;
                } else {
                  //定时获取任务进度
                  that.getTimedExecution();
                }
              } else {
                item.schedules.disabled = !disabled;
                itemData.updateFlag = false;
                that.$forceUpdate();
                if (result.msg == "timepassed") {
                  this.$toast({
                    text: result.msg,
                    type: 'fail',
                    idValue: "rightBodyList"
                  });
                } else {
                  this.$toast({
                    text: this.$t('language.exception.' + result.reason),
                    type: 'fail',
                    idValue: "rightBodyList"
                  });
                }
              }
            });
          } else {
            delete updateData.type;
            this.Utils.doBusinessTransferRequest("update", updateData).then(data => {
              itemData.updateFlag = false;
              that.$forceUpdate();
              if (disabled) {
                clearTimeout(item.timeoutExeCute);
                delete item.timeoutExeCute;
              } else {
                //定时获取任务进度
                that.getTimedExecution();
              }
            }).catch(err => {
              item.schedules.disabled = !disabled;
              itemData.updateFlag = false;
              that.$forceUpdate();
              if (err.reason) {
                err = that.$t('language.exception.' + err.reason)
              }
              that.$toast({
                text: err,
                type: 'fail',
                idValue: "rightBodyList"
              });
            });
          }
        }
      },
      //封装按周的数据
      packageWeekDaysData(item) {
        var weekArr;
        let value = item.schedules;
        let weekDaysArr = new Array;
        if (!(value.weeks instanceof Array)) {
          weekArr = value.weeks.split(",");
        } else {
          weekArr = value.weeks;
        }
        $.each(weekArr, function(i, itemData) {
          if (itemData && typeof(itemData) == 'string') {
            let itemSpace = itemData.trim().replace(/\"/g, "");
            itemSpace = parseInt(itemSpace);
            weekDaysArr.push(itemSpace);
          }
        });
        if (weekDaysArr.length) {
          weekArr = weekDaysArr;
        } else {
          weekArr = weekArr;
        }
        return weekArr;
      },
      //封装按月的数据
      packageMonthDaysData(item) {
        let dayArr;
        let monthDayArr = new Array;
        let value = item.schedules;
        if (!(value.days instanceof Array)) {
          dayArr = value.days.split(",");
        } else {
          dayArr = value.days;
        }
        $.each(dayArr, function(i, itemData) {
          if (itemData && typeof(itemData) == 'string') {
            let itemSpace = itemData.trim().replace(/\"/g, "");
            itemSpace = parseInt(itemSpace);
            monthDayArr.push(itemSpace);
          }
        });
        if (monthDayArr.length) {
          dayArr = monthDayArr;
        } else {
          dayArr = dayArr;
        }
        return dayArr;
      },
      //提交任务名
      submitTaskListName(item, index) {
        let that = this;
        if (item.inputValue && item.inputValue != item.oldTaskName) {
          if (item.inputValue.length > 200) {
            this.$toast({
              text: that.$t('language.taskList.taskNameRule'),
              type: 'fail',
              idValue: "rightBodyList"
            });
            this.cancelEditDriveName(index, item);
            return false;
          }
          if (item.branchType == "businessTransfer") {
            this.updateBusinessTask(item);
            return;
          }
          if (this.isflage) {
            this.isflage = false;
            var updateData;
            let schedules = item.schedules;
            let options = item.options;
            if (item.groupId) {
              let gd = item.groupId;
              updateData = new taskListUtils.updateGdData(gd, commonUtils.getUser().id, item.type, item.inputValue,
                null, null);
            } else {
              let id = item.id;
              updateData = new taskListUtils.updateIdData(id, commonUtils.getUser().id, item.type, item.inputValue,
                null, null);
            }
            this.Utils.doTasksRequest("update", updateData).then(result => {
              if (result.status == 200) {
                this.isflage = true;
                item.name = item.inputValue;
                that.editInputStyle("none", "block", index);
              } else {
                that.editInputStyle("none", "block", index);
                this.$toast({
                  text: this.$t('language.exception.' + result.reason),
                  type: 'fail',
                  idValue: "rightBodyList"
                });
              }
            });
          }
        } else if (!item.inputValue) {
          item.inputValue = item.oldTaskName;
        } else {
          that.editInputStyle("none", "block", index);
        }
      },
      //提交重命名的任务名
      updateBusinessTask(item) {
        var updateData = {
          n: item.inputValue,
          id: item.id,
          ud: commonUtils.getUser().id
        }
        if (this.isflage) {
          this.isflage = false;
          this.Utils.doBusinessTransferRequest("update", updateData).then(data => {
            this.isflage = true;
            item.name = item.inputValue;
            this.editInputStyle("none", "block", this.index);
          }).catch(err => {
            if (err.reason) {
              err = that.$t('language.exception.' + err.reason)
            }
            this.editInputStyle("none", "block", this.index);
            this.$toast({
              text: err,
              type: 'fail',
              idValue: "rightBodyList"
            });
          });
        }
      },
      //编辑任务名
      editTaskListName(index, item) {
        if (item.type == 6 && (item.status == 'Waiting' || item.status == 'Running')) {
          this.$parent.$refs.renameDialog.noticeShow = true;
          return;
        }
        this.clickDialogCurrent = -1;
        if (this.$refs.taskListSelect) {
          this.$refs.taskListSelect.clickShowCurrent = -1;
        }
        item.inputValue = item.name;
        item.oldTaskName = item.name;
        this.editInputStyle("block", "none", index);
        this.$forceUpdate();
      },
      editInputStyle(inputDomStye, divDomStyle, index) {
        let inputName = 'listInputName';
        let driveName = 'listDriveName';
        let inputDom = this.$refs.listInputName;
        let divDom = this.$refs.listDriveName;
        inputDom.style.display = inputDomStye;
        divDom.style.display = divDomStyle;
        this.$nextTick(function() {
          inputDom.children[0].select();
        });
      },
      //打开查看日志弹窗
      viewLogsOpen() {
        let item = this.item;
        if (item.branchType == 'realtime') {
          this.viewRealTimeLogOpen(); //如果是即时同步任务则打开即时同步日志弹窗
          return;
        }
        if (item.type == 2) {
          this.viewSyncLogOpen();
          return;
        }
        if (item.type == 6) {
          this.viewBackupLogsOpen();
          return;
        }
        if (item.branchType == 'businessTransfer') {
          this.viewBusinessTransfer();
          return;
        }
        this.viewNormalLogsOpen(); //打开除即时同步之外的日志弹窗
      },
      //查看任务企业传输任务
      viewBusinessTransfer() {
        let that = this;
        var item = this.item;
        this.operateMenuIndex = -1;
        that.$refs.viewLogsDialog.moreTransferFlag = false;
        if (this.item.viewed) {
          that.$refs.viewLogsDialog.loading = false;
          that.$refs.viewLogsDialog.viewLogsShow = true;
          that.$refs.viewLogsDialog.clickCurrent = -1;
          this.item.getViewLogCount = 2;
          var result = {};
          result.tasks = item.sources;
          that.judgeViewPageShow(item, result);
          return;
        }
        var data = {
          id: this.item.id,
          ud: commonUtils.getUser().id
        }
        this.item.viewed = true;
        this.initTask();
        that.$refs.viewLogsDialog.viewLogsShow = true;
        that.$refs.viewLogsDialog.loading = true;
        this.Utils.doBusinessTransferRequest("get", data).then(result => {
          that.$refs.viewLogsDialog.viewLogsShow = true;
          if (result.tasks) {
            for (var i = 0; i < result.tasks.length; i++) {
              result.tasks[i].branchType = 'businessTransfer';
            }
			
            that.$refs.viewLogsDialog.viewDetail = result;
            item.taskDetail = result;
            that.judgeViewPageShow(item, result);
            that.$refs.viewLogsDialog.loading = false;
          }
        }).catch(err =>{
			if (err.reason) {
			  err = that.$t('language.exception.' + err.reason)
			}
			that.$toast({
			  text: err,
			  type: 'fail',
			  idValue: "rightContBan"
			});
		});
      },
      viewBackupLogsOpen() {
        let that = this;
        let item = this.item;
        this.$refs.viewBackupLogsDialog.backupLogsShow = true;
        this.$refs.viewBackupLogsDialog.loading = true;
        this.operateMenuIndex = -1;
        var getData;
        let groupId = item.groupId;
        if (item.groupId) {
          getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, null, groupId);
        } else {
          getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, null);
        }
        this.Utils.doTasksRequest("get", getData).then(result => {
          if (result.status == 200) {
            // that.listTargetFiles(result.tasks[0],function(res){
            //  if ((res.msg&&res.msg.search('not_found') != -1) || res.status == 404 || res.reason=="unknownError" || result.tasks[0].lastLog.error=='backupInitConfigFail') {
            if (result.tasks[0].lastLog && result.tasks[0].lastLog.error == 'backupInitConfigFail' || (result.tasks[
                0].lastLog && result.tasks[0].lastLog.error == 'BackupServiceNotWork')) {
              that.$refs.viewBackupLogsDialog.toItemExist = false;
              that.$refs.viewBackupLogsDialog.errorReason = result.tasks[0].lastLog.error;
            } else {
              that.$refs.viewBackupLogsDialog.toItemExist = true;
            }
            that.$refs.viewBackupLogsDialog.viewDetail = result;
            item.taskDetail = result;
            that.$refs.viewBackupLogsDialog.loading = false;
            if (result.tasks[0].lastLog) {
              that.$refs.viewBackupLogsDialog.nonFlag = false;
            } else {
              that.$refs.viewBackupLogsDialog.nonFlag = true;
            }
            // });

          } else {
            that.$toast({
              text: this.$t('language.exception.' + result.reason),
              type: 'fail',
              idValue: "rightContBan"
            });
            that.$refs.viewBackupLogsDialog.loading = false;
            that.$refs.viewBackupLogsDialog.backupLogsShow = false;
          }
        });
        this.$forceUpdate();
      },
      //
      listTargetFiles(task, callback) {
        var that = this;
        let listData = new cloudExploerUtils.filelistData(task.toItem.fileId, commonUtils.getUser().id, task.toItem
          .driveId, null, null, null);
        that.Utils.doFilesRequest("list", listData, {
          timeout: 600000
        }).then(res => {
          callback(res);
        });

      },
      getRealTimeStatus() {
        let item = this.item;
        let that = this;
        let t;
        var getData;
        if (item.groupId) {
          getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, null, groupId);
        } else {
          getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, null);
        }
        this.Utils.doRealtimeSyncRequest("get", getData).then(result => {
          if (result.data && result.data.status == 'Run') {
            that.item.t = setTimeout(() => {
              that.getRealTimeStatus();
            }, 300000);
          } else if (result.data && result.data.status == 'TimeStop') {
            clearTimeout(that.item.t);
            that.$parent.tasklistData[that.index] = result.data;
            that.$forceUpdate();
          }
        });
      },
      viewRealTimeLogOpen() {
        let that = this;
        let item = this.item;
        var viewRealTimeLogsDialog = this.$refs.viewRealTimeLogsDialog;
        viewRealTimeLogsDialog.realtimeLogsShow = true;
        viewRealTimeLogsDialog.loading = true; //将dialog数据还原
        viewRealTimeLogsDialog.nonFlag = false;
        viewRealTimeLogsDialog.clickCurrent = -1;
        viewRealTimeLogsDialog.viewDetail = {};
        viewRealTimeLogsDialog.maxShow = false;
        this.operateMenuIndex = -1;
        var getData;
        let groupId = item.groupId;
        if (item.groupId) {
          getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, null, groupId);
        } else {
          getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, null);
        }
        this.Utils.doRealtimeSyncRequest("get", getData).then(result => {
          if (result.message == 'success') {
            viewRealTimeLogsDialog.viewDetail = result.data;
            if (viewRealTimeLogsDialog.viewDetail.tasks.length > 1) {
              viewRealTimeLogsDialog.aimsMoresFlag = true; //表明是多目标的即时同步任务
            }
            setTimeout(() => {
              if (result.data.tasks[0].lastLog && result.data.tasks[0].lastLog.newLog && result.data.tasks[0]
                .lastLog.newLog.length >= 200) {
                viewRealTimeLogsDialog.maxShow = true;
              }
            }, 450);
            $.each(viewRealTimeLogsDialog.viewDetail.tasks, function(j, jItem) {
              jItem.times = result.data.times;
              jItem.status = item.status;
              if (j == result.data.tasks.length - 1) {
                // setTimeout(()=>{
                if (result.data.tasks[0].lastLog) {
                  //将返回的数据倒序排序
                  if (result.data.tasks[0].lastLog.newLog.length) {
                    result.data.tasks[0].lastLog.newLog.reverse();

                    viewRealTimeLogsDialog.nonFlag = false;
                  } else {
                    viewRealTimeLogsDialog.nonFlag = true;
                  }
                } else {
                  viewRealTimeLogsDialog.nonFlag = true;
                }
                viewRealTimeLogsDialog.loading = false;
                //   },1000); 
              }
            });
          } else {
            that.$toast({
              text: result.msg,
              type: 'fail',
              idValue: "rightContBan"
            });
            viewRealTimeLogsDialog.loading = false;
            //viewRealTimeLogsDialog.nonFlag = true;
            that.$forceUpdate();
            return;
          }
        });
        this.$forceUpdate();
      },
      viewSyncLogOpen() {
        let that = this;
        let item = this.item;
        var viewRealTimeLogsDialog = this.$refs.viewRealTimeLogsDialog;
        viewRealTimeLogsDialog.realtimeLogsShow = true;
        viewRealTimeLogsDialog.loading = true; //将dialog数据还原
        viewRealTimeLogsDialog.nonFlag = false;
        viewRealTimeLogsDialog.clickCurrent = -1;
        viewRealTimeLogsDialog.viewDetail = {};
        viewRealTimeLogsDialog.maxShow = false;
        this.operateMenuIndex = -1;
        var getData;
        let groupId = item.groupId;
        if (item.groupId) {
          getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, null, groupId);
        } else {
          getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, null);
        }
        this.Utils.doTasksRequest("get", getData).then(result => {
          if (result.status == 200) {
            viewRealTimeLogsDialog.viewDetail = result;
            if (viewRealTimeLogsDialog.viewDetail.tasks.length > 1) {
              viewRealTimeLogsDialog.aimsMoresFlag = true; //表明是多目标的即时同步任务
            }
            setTimeout(() => {
              if (result.tasks[0].lastLog && result.tasks[0].lastLog.newLog && result.tasks[0].lastLog.newLog
                .length >= 200) {
                viewRealTimeLogsDialog.maxShow = true;
              }
            }, 450);
            $.each(viewRealTimeLogsDialog.viewDetail.tasks, function(j, jItem) {
              if (jItem.lastLog) {
                //将返回的数据倒序排序
                if (jItem.lastLog.newLog) {
                  jItem.lastLog.newLog.reverse();
                }
              }
              if (j == result.tasks.length - 1) {
                // console.log(viewRealTimeLogsDialog.viewDetail.tasks);
                viewRealTimeLogsDialog.loading = false;
                if (result.tasks[0].lastLog) {
                  viewRealTimeLogsDialog.nonFlag = false;
                } else {
                  viewRealTimeLogsDialog.nonFlag = true;
                }
              }
            });
          }
        });
        this.$forceUpdate();
      },
      //打开查看日志弹窗
      viewNormalLogsOpen() {
        let that = this;
        let item = this.item;
        item.viewed = true;
        this.$refs.viewLogsDialog.nonFlag = false;
        this.$refs.viewLogsDialog.moreTransferFlag = false;
        this.$refs.viewLogsDialog.singleTransferFlag = false;
        this.operateMenuIndex = -1;
        this.$refs.viewLogsDialog.clickCurrent = 'load';
        this.$refs.viewLogsDialog.viewLogsShow = true;
        if (!item.taskDetail || (item.result != 'error' && item.result != 'success') || item.retransfer) {
          this.$refs.viewLogsDialog.loading = true;
          var getData;
          let groupId = item.groupId;
          if (item.groupId) {
            getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, null, groupId);
          } else {
            getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, null);
          }
          if (item.retransfer || (!item.taskDetail && item.result && item.result.toLowerCase() == 'cancel') || item
            .status == 'Canceled') {
            let t = setTimeout(() => {
              this.Utils.doTasksRequest("get", getData).then(result => {
                if (result.status == 200) {
                  that.$refs.viewLogsDialog.viewDetail = result;
                  item.taskDetail = result;
                  that.judgeViewPageShow(item, result);
                  that.$refs.viewLogsDialog.loading = false;
                }
              });
              clearTimeout(t);
            }, 4000);
          } else {
            this.Utils.doTasksRequest("get", getData).then(result => {
              if (result.status == 200) {
                that.$refs.viewLogsDialog.viewDetail = result;
                item.taskDetail = result;
                that.judgeViewPageShow(item, result);
                that.$refs.viewLogsDialog.loading = false;
              }
            });
          }
        } else {
          that.$refs.viewLogsDialog.viewDetail = item.taskDetail;
          that.judgeViewPageShow(item, item.taskDetail);
        }
        this.$forceUpdate();
      },
      //判断能否查看日志
      judgeViewPageShow(item, result) {
        let that = this;
        that.$refs.viewLogsDialog.loading = false;
        if (result.tasks[0].result || result.tasks[0].lastLog) {
          //多源传输任务
          if (((result.tasks[0].lastLog || result.tasks[0].result) && result.tasks.length > 1 && result.tasks[0].type ==
              1) || (item.branchType == 'businessTransfer')) {
            $.each(result.tasks, function(i, resitem) {
              if (item.toItem.nodes[0].fileName) {
                that.$refs.viewLogsDialog.toNodes = item.toItem.nodes;
                resitem.toItem.nodes = item.toItem.nodes;
                return false;
              }
            });
            that.$refs.viewLogsDialog.moreTransferFlag = true;
            //多目标同步任务
          } else if ((result.tasks[0].lastLog || result.tasks[0].result) && result.tasks.length > 1 && result.tasks[0]
            .type == 2) {
            that.$refs.viewLogsDialog.moreTransferFlag = true;
          } else {
            //单目标传输界面
            that.$refs.viewLogsDialog.singleTransferFlag = true;
          }
        } else {
          //该任务还未执行界面
          that.$refs.viewLogsDialog.nonFlag = true;
        }

      },
      //判断是否是string类型
      isString(str) {
        return (typeof str == 'string') && str.constructor == String;
      },
      //判断显示每天
      judgeShowDailyPage(item) {
        let timeRef;
        let time;
        let timeData;
        let that = this;
        that.$refs.transferScheduleDialog.schedules.type = 'Daily';
        that.$refs.transferScheduleDialog.times = item.schedules.times;
        that.$refs.transferScheduleDialog.$refs.daily.dailyTimeArr = [];
        timeData = item.schedules.times;
        $.each(timeData, function(i, itemData) {
          if (i == 0) {
            timeRef = that.$refs.transferScheduleDialog.$refs.daily.$refs.dailyTime0;
            that.$refs.transferScheduleDialog.$refs.daily.dailyTime0 = itemData;
          }
          if (i == 1) {
            timeRef = that.$refs.transferScheduleDialog.$refs.daily.$refs.dailyTime1;
            that.$refs.transferScheduleDialog.$refs.daily.dailyTime1 = itemData;
          }
          if (i == 2) {
            timeRef = that.$refs.transferScheduleDialog.$refs.daily.$refs.dailyTime2;
            that.$refs.transferScheduleDialog.$refs.daily.dailyTime2 = itemData;
          }
          if (itemData && itemData != '"null"') {
            time = itemData.split(':');
            that.$refs.transferScheduleDialog.$refs.daily.dailyTimeArr.push(i);
            timeRef.hourValue = time[0];
            timeRef.minuteValue = time[1];
          }
        })
        this.$refs.transferScheduleDialog.$refs.daily.checkArr = [1];
        this.$refs.transferScheduleDialog.$refs.daily.dailyDisableFlage = false;
        //清空其他界面数据
        this.$refs.transferScheduleDialog.$refs.weekly.weekArr = [];
        this.$refs.transferScheduleDialog.$refs.monthly.monthArr = [];
      },
      //判断schedule弹框是否禁用
      judgeDisable(disabled) {
        let that = this;
        let tab = that.$refs.transferScheduleDialog.$refs.tab.children[0].children[0].children[0].children[0].children[
          0].children;
        if (disabled) {
          this.$refs.transferScheduleDialog.disable = true;
          this.$refs.transferScheduleDialog.$refs.daily.dailyDisableFlage = true;
          this.$refs.transferScheduleDialog.$refs.daily.onceDisableFlage = true;
          this.$refs.transferScheduleDialog.$refs.weekly.weeklyDisable = true;
          this.$refs.transferScheduleDialog.$refs.monthly.monthlyDisable = true;
          this.$nextTick(function() {
            for (let i = 1; i < tab.length; i++) {
              let classArr = tab[i].classList;
              if (!classArr[2]) {
                tab[i].style.color = "#d2d4d8";
              }
            }
          });
        } else {
          this.$refs.transferScheduleDialog.disable = false;
          this.$refs.transferScheduleDialog.$refs.daily.dailyDisableFlage = false;
          this.$refs.transferScheduleDialog.$refs.daily.onceDisableFlage = false;
          this.$refs.transferScheduleDialog.$refs.weekly.weeklyDisable = false;
          this.$refs.transferScheduleDialog.$refs.monthly.monthlyDisable = false;
          this.$nextTick(function() {
            for (let i = 1; i < tab.length; i++) {
              tab[i].style.color = "";
            }
          });
        }

      },
      //判断是否显示按月界面
      judgeShowMonthPage(item) {
        let days;
        let times;
        let daysArr = [];
        let that = this;
        days = item.schedules.days;
        times = item.schedules.times[0].split(':');
        $.each(days, function(i, item) {
          if (typeof(item) == 'string') {
            item = parseInt(item.replace(/\"/g, ""));
          }
          daysArr.push(item);
          if (i == days.length - 1) {
            that.$refs.transferScheduleDialog.$refs.monthly.monthArr = daysArr;
            that.$refs.transferScheduleDialog.$refs.monthly.$refs.monthTime.hourValue = times[0];
            that.$refs.transferScheduleDialog.$refs.monthly.$refs.monthTime.minuteValue = times[1];
            //清空其他界面数据
            that.$refs.transferScheduleDialog.$refs.daily.checkArr = [];
            that.$refs.transferScheduleDialog.$refs.daily.dailyTimeArr = [];
            that.$refs.transferScheduleDialog.$refs.weekly.weekArr = [];
          }
        });

      },
      //判断显示按月时间，就将其他界面的时间设为现在的时间
      showMonthlyTime() {
        let m = new Date().getMinutes();
        if (m < 10) {
          m = '0' + m;
        }
        this.setOneceDateTimeNow(m);
        this.setWeekTimeNow(m);
        this.setDailyTimeNow(m);
      },
      //设置Once时间为现在的时间
      setOneceDateTimeNow(m) {
        this.$refs.transferScheduleDialog.$refs.daily.$refs.onceDate.yearValue = new Date().getFullYear();
        this.$refs.transferScheduleDialog.$refs.daily.$refs.onceDate.monthValue = new Date().getMonth() + 1;
        this.$refs.transferScheduleDialog.$refs.daily.$refs.onceDate.dayValue = new Date().getDate();
        this.$refs.transferScheduleDialog.$refs.daily.$refs.onceTime.hourValue = new Date().getHours();
        this.$refs.transferScheduleDialog.$refs.daily.$refs.onceTime.minuteValue = m;
      },
      //设置Month界面时间为现在的时间
      setMonthTimeNow(m) {
        this.$refs.transferScheduleDialog.$refs.monthly.$refs.monthTime.hourValue = new Date().getHours();
        this.$refs.transferScheduleDialog.$refs.monthly.$refs.monthTime.minuteValue = m;
      },
      //设置Daily界面时间为现在的时间
      setDailyTimeNow(m) {
        this.$refs.transferScheduleDialog.$refs.daily.$refs.dailyTime0.hourValue = new Date().getHours();
        this.$refs.transferScheduleDialog.$refs.daily.$refs.dailyTime0.minuteValue = m;
        this.$refs.transferScheduleDialog.$refs.daily.$refs.dailyTime1.hourValue = new Date().getHours();
        this.$refs.transferScheduleDialog.$refs.daily.$refs.dailyTime1.minuteValue = m;
        this.$refs.transferScheduleDialog.$refs.daily.$refs.dailyTime2.hourValue = new Date().getHours();
        this.$refs.transferScheduleDialog.$refs.daily.$refs.dailyTime2.minuteValue = m;
      }, //设置Week界面时间为现在的时间
      setWeekTimeNow(m) {
        this.$refs.transferScheduleDialog.$refs.weekly.$refs.weekTime.hourValue = new Date().getHours();
        this.$refs.transferScheduleDialog.$refs.weekly.$refs.weekTime.minuteValue = m;
      },
      //判断显示每天时间，除daily界面其他界面都设置为现在时间
      showDailyTime() {
        let m = new Date().getMinutes();
        if (m < 10) {
          m = '0' + m;
        }
        this.setOneceDateTimeNow(m);
        this.setWeekTimeNow(m);
        this.setMonthTimeNow(m);
      },
      //判断显示按周的时间
      showWeekTime() {
        let m = new Date().getMinutes();
        if (m < 10) {
          m = '0' + m;
        }
        this.setOneceDateTimeNow(m);
        this.setMonthTimeNow(m);
        this.setDailyTimeNow(m);
      },
      //判断显示一次性的时间
      showOnceTime() {
        let m = new Date().getMinutes();
        if (m < 10) {
          m = '0' + m;
        }
        this.setMonthTimeNow(m);
        this.setDailyTimeNow(m);
      },
      //判断显示Once界面
      judgeShowOncePage(item) {
        let date;
        let times;
        if (item.schedules.date) {
          date = item.schedules.date.split('-');
          this.$refs.transferScheduleDialog.$refs.daily.$refs.onceDate.yearValue = date[0];
          this.$refs.transferScheduleDialog.$refs.daily.$refs.onceDate.monthValue = date[1];
          this.$refs.transferScheduleDialog.$refs.daily.$refs.onceDate.dayValue = date[2];
          this.$refs.transferScheduleDialog.$refs.daily.dailyTimeArr = [];
        }
        times = item.schedules.times[0].split(':');
        this.$refs.transferScheduleDialog.$refs.daily.checkArr = [0];
        this.$refs.transferScheduleDialog.$refs.daily.$refs.onceTime.hourValue = times[0];
        this.$refs.transferScheduleDialog.$refs.daily.$refs.onceTime.minuteValue = times[1];
        this.$refs.transferScheduleDialog.$refs.daily.dailyDisableFlage = true;
      },
      //判断显示Weekly界面
      judgeShowWeeklyPage(item) {
        let weeks;
        let times;
        let that = this;
        let weeksArr = [];
        weeks = item.schedules.weeks;
        times = item.schedules.times[0].split(':');
        $.each(weeks, function(i, weekItem) {
          if (that.isString(weekItem)) {
            weekItem.replace(/\"/g, "")
          }
          weekItem = parseInt(weekItem);
          weeksArr.push(weekItem);
          if (i == weeks.length - 1) {
            that.$refs.transferScheduleDialog.$refs.weekly.weekArr = weeksArr;
            that.$refs.transferScheduleDialog.$refs.weekly.$refs.weekTime.hourValue = times[0];
            that.$refs.transferScheduleDialog.$refs.weekly.$refs.weekTime.minuteValue = times[1];
            //清空其他界面数据
            that.$refs.transferScheduleDialog.$refs.daily.checkArr = [];
            that.$refs.transferScheduleDialog.$refs.daily.dailyTimeArr = [];
            that.$refs.transferScheduleDialog.$refs.monthly.monthArr = [];
          }
        });
      },
      //打开设置弹窗
      openOptionsDialog(item, index) {
        let that = this;
        let tab1 = this.$refs.syncOptionsDialog.$refs.tab1;
        this.operateMenuIndex = -1;
        let taskDialog;
        if (item.type == 1) { //
          if(item.options.way&&"cloudEmail" == item.options.way){
            //如果是邮件传输
            taskDialog = this.$refs.emailTransferOptionsDialog;
            //显示第一页
            taskDialog.item = item;
            taskDialog.itemIndex = index;
            taskDialog.optionDialogShow = true;
            taskDialog.options = Object.assign({}, item.options);
            //配置tab-transfer界面显示系统中已有的数据 
            let value = taskDialog.caseOption(parseInt(item.options.replace));

            taskDialog.$refs.tab1.isChar = item.options.isChar;
            // taskDialog.$refs.tab1.isRemove == item.options.isRemove;
            // taskDialog.$refs.tab1.isKeep == item.options.isKeep;
            // taskDialog.$refs.tab1.keepRoot == item.options.keepRoot;
            taskDialog.$refs.tab1.isSaveAtt = item.options.attachment;
            taskDialog.$refs.tab1.isConver = item.options.conversationQuoted;
            taskDialog.$refs.tab1.isSaveOnly = item.options.onlyLastMail;
          
          }else{
            this.$refs.transferOptionsDialog.activeName = "first";
            taskDialog = this.$refs.transferOptionsDialog;
            taskDialog.item = item;
            taskDialog.itemIndex = index;
            taskDialog.optionDialogShow = true;
            taskDialog.options = Object.assign({}, item.options);
            //配置tab-transfer界面显示系统中已有的数据 
            let value = taskDialog.caseOption(parseInt(item.options.replace));
            taskDialog.$refs.tab1.$refs.cloudSelect.currentValue = value;
            taskDialog.$refs.tab1.checkArr = [];
            if (item.options.isChar == 1) {
              taskDialog.$refs.tab1.checkArr.push(2);
            }
            if (item.options.isRemove == 1) {
              taskDialog.$refs.tab1.checkArr.push(0);
            }
            if (item.options.isKeep == 1) {
              taskDialog.$refs.tab1.checkArr.push(1);
            }
            if (item.options.keepRoot == 1) {
              taskDialog.$refs.tab1.checkArr.push(3);
            }
            if (item.options.newTrans == 1) {
              taskDialog.$refs.tab1.checkArr.push(4);
            }
            this.$refs.transferOptionsDialog.$refs.tab1.oldCheckArr = this.$refs.transferOptionsDialog.$refs.tab1
              .checkArr;
          }
        }
        if (item.type == 6) {
          this.$refs.backupOptionDialog.activeName = "second";
          taskDialog = this.$refs.backupOptionDialog;
          taskDialog.item = item;
          taskDialog.itemIndex = index;
          taskDialog.backupOptionDialogShow = true;
          taskDialog.options = Object.assign({}, item.options);
        }
        if (item.type == 2 || item.branchType == 'realtime') {
          this.$refs.syncOptionsDialog.activeName = "first";
          taskDialog = this.$refs.syncOptionsDialog;
          this.$refs.syncOptionsDialog.item = item;
          this.$refs.syncOptionsDialog.itemIndex = index;
          this.$refs.syncOptionsDialog.syncOptionShow = true;
          taskDialog.options = Object.assign({}, item.options);
          //配置tab-sync界面显示系统中已有的数据
          that.$refs.syncOptionsDialog.caseOption(parseInt(item.options.way));
          that.$refs.syncOptionsDialog.chooseChar(parseInt(item.options.isChar));
          that.$refs.syncOptionsDialog.oldOptions = item.options;
          if (item.branchType == 'realtime') {
            tab1.$refs.selectrealTime.currentValue = this.$t('language.cloudSync.realTimeSync');
            if (parseInt(item.options.way) == 20) {
              tab1.selectOption = [{
                name: this.$t('language.cloudSync.oneWaySimple'),
                id: 0
              }];
            } else {
              tab1.$refs.selectOne.currentValue = this.$t('language.cloudSync.oneWaySimple');
              tab1.selectOption = [{
                name: this.$t('language.popup.twowaySync'),
                id: 1
              }];
            }
            tab1.selectTwoShow = false; //不显示第三项
          } else {
            tab1.$refs.selectrealTime.currentValue = this.$t('language.cloudSync.normalSync');
            tab1.selectOptionTwo = this.$refs.syncOptionsDialog.$refs.tab1.selectOptionTwoAll;
          }
          if (item.options.way == 10 && item.sources) { //如果是多源单向同步，只能选择简单同步
            this.$nextTick(() => {
              tab1.selectOption = [];
              tab1.$refs.selectOne.selectLength = [];
              tab1.$forceUpdate();
            });
          }
        }
        if (item.sources && item.sources.length && item.branchType != 'realtime') {
          tab1.listNormalOpen = true;
          tab1.$refs.selectrealTime.listNormalOpen = true;
        }
        //配置tab-email界面显示系统中已有的数据
        if (item.options.email) {
          taskDialog.$refs.tab2.sendShow = true;
          taskDialog.$refs.tab2.email = item.options.email;
        } else {
          taskDialog.$refs.tab2.sendShow = false;
          taskDialog.$refs.tab2.email = '';
        }
        this.$nextTick(() => {
          tab1.$refs.selectrealTime.setInputWidth();
        });
        //配置tab-filter界面显示系统中已有的数据
        if(item.options.way != 'cloudEmail'){
          if (item.options.pattern == 'include' || item.options.pattern == 'exclude') {
            if (item.options.pattern == 'include') {
              taskDialog.$refs.tab3.radioCurrent = 1;
              taskDialog.$refs.tab3.items = [];
              taskDialog.$refs.tab3.includeArr = [];
              let matchedArr = item.options.matched.split("|");
              $.each(matchedArr, function(i, item) {
                let filterValue = commonUtils.matchExtension(commonUtils.getSuffix(item));
                taskDialog.$refs.tab3.items.push(filterValue);
                taskDialog.$refs.tab3.includeArr.push(filterValue);
              })
            }
            if (item.options.pattern == 'exclude') {
              taskDialog.$refs.tab3.radioCurrent = 0;
              taskDialog.$refs.tab3.items = [];
              taskDialog.$refs.tab3.ignoreArr = [];
              let matchedArr = item.options.matched.split("|");
              $.each(matchedArr, function(i, item) {
                let filterValue = commonUtils.matchExtension(commonUtils.getSuffix(item));
                taskDialog.$refs.tab3.items.push(filterValue);
                taskDialog.$refs.tab3.ignoreArr.push(filterValue);
              })
            }
          } else {
            taskDialog.$refs.tab3.radioCurrent = 0;
            taskDialog.$refs.tab3.items = [];
            taskDialog.$refs.tab3.includeArr = [];
            taskDialog.$refs.tab3.ignoreArr = [];
          }
        }
      },
      //显示schedule弹框
      openSchduleDialog(itemValue, index) {
        let item = Object.assign({}, itemValue);
        this.operateMenuIndex = -1;
        this.$refs.transferScheduleDialog.taskSchduleShow = true;
        this.$refs.transferScheduleDialog.item = item;
        this.$refs.transferScheduleDialog.itemIndex = index;
        this.$refs.transferScheduleDialog.schedules = Object.assign({}, item.schedules);
        this.$refs.transferScheduleDialog.flag = true;
        if (item.schedules && item.schedules.type != 'Now') {
          if (item.schedules.type == 'Monthly' || item.schedules.type == '=Monthly') {
            let days = [];
            this.$refs.transferScheduleDialog.activeName = "monthly";
            $.each(item.schedules.days, function(dayIndex, dayItem) {
              if (typeof(obj) == 'string') {
                dayItem = parseInt(dayItem.replace(/\"/g, ""));
              }
              if (dayItem != null && dayItem != undefined && dayItem != "") {
                days.push(dayItem);
              }
            });
            this.$refs.transferScheduleDialog.oldMonthlyTimes = Object.assign([], item.schedules.times);
            this.$refs.transferScheduleDialog.oldWeekTimes = [];
            this.$refs.transferScheduleDialog.oldOnceTimes = [];
            this.$refs.transferScheduleDialog.days = days;
            this.$refs.transferScheduleDialog.weeks = [];
            this.$refs.transferScheduleDialog.date = '';
            this.showMonthlyTime();
            this.judgeShowMonthPage(item);
          } else if (item.schedules.type == 'Weekly' || item.schedules.type == '=Weekly') {
            this.$refs.transferScheduleDialog.weeks = item.schedules.weeks;
            this.$refs.transferScheduleDialog.oldWeekTimes = Object.assign([], item.schedules.times);
            this.$refs.transferScheduleDialog.oldMonthlyTimes = [];
            this.$refs.transferScheduleDialog.oldOnceTimes = [];
            this.$refs.transferScheduleDialog.days = [];
            this.$refs.transferScheduleDialog.date = '';
            this.$refs.transferScheduleDialog.activeName = "weekly";
            this.showWeekTime();
            this.judgeShowWeeklyPage(item);
          } else {
            if (item.schedules.type == 'Once' || item.schedules.type == '=Once') {
              this.$refs.transferScheduleDialog.activeName = "once";
              this.$refs.transferScheduleDialog.date = item.schedules.date;
              this.$refs.transferScheduleDialog.$refs.daily.$refs.onceDate.dateValue = item.schedules.date;
              this.$refs.transferScheduleDialog.oldOnceTimes = Object.assign([], item.schedules.times);
              this.$refs.transferScheduleDialog.oldWeekTimes = [];
              this.$refs.transferScheduleDialog.oldMonthlyTimes = [];
              this.$refs.transferScheduleDialog.$refs.monthly.monthArr = [];
              this.$refs.transferScheduleDialog.$refs.weekly.weekArr = [];
              this.showOnceTime();
              this.judgeShowOncePage(item);
            } else if (item.schedules.type == 'Daily' || item.schedules.type == '=Daily') {
              this.$refs.transferScheduleDialog.activeName = "daily";
              this.$refs.transferScheduleDialog.weeks = [];
              this.$refs.transferScheduleDialog.date = '';
              this.$refs.transferScheduleDialog.$refs.monthly.monthArr = [];
              this.$refs.transferScheduleDialog.$refs.weekly.weekArr = [];
              this.$refs.transferScheduleDialog.$refs.daily.times = item.schedules.times;
              this.showDailyTime();
              this.judgeShowDailyPage(item);
            }
          }
          this.judgeDisable(item.schedules.disabled);
        } else {
          //清空所有界面的数据
          this.$refs.transferScheduleDialog.activeName = "once";
          this.$refs.transferScheduleDialog.disable = false;
          this.$refs.transferScheduleDialog.$refs.daily.checkArr = [];
          this.$refs.transferScheduleDialog.$refs.daily.dailyTimeArr = [];
          this.$refs.transferScheduleDialog.$refs.daily.dailyDisableFlage = true;
          this.$refs.transferScheduleDialog.$refs.daily.onceDisableFlage = true;
          this.$refs.transferScheduleDialog.$refs.monthly.monthlyDisable = false;
          this.$refs.transferScheduleDialog.$refs.weekly.weeklyDisable = false;
          this.$refs.transferScheduleDialog.$refs.weekly.weekArr = [];
          this.$refs.transferScheduleDialog.$refs.monthly.monthArr = [];
          this.showDailyTime();
          this.showMonthlyTime();
          this.judgeDisable(false);
        }
      },
      //如果没有path，则封装Path数据
      encapsulationPath(sourceAimData, pathData) {
        let that = this;
        let driveId;
        that.pathJson = [];
        if (sourceAimData.driveId) {
          driveId = sourceAimData.driveId;
        } else {
          driveId = sourceAimData.nodes[0].tokenId;
        }
        if (!pathData) {
          for (let i = sourceAimData.nodes.length - 1; i >= 0; i--) {
            let name;
            if (sourceAimData.nodes[i].fileName) {
              name = sourceAimData.nodes[i].fileName;
            } else {
              name = sourceAimData.nodes[i].filename;
            }
            that.pathJson.push({
              id: sourceAimData.nodes[i].fileId,
              name: name,
              driveId: driveId
            });
            let JsonList = Object.assign([], that.pathJson);
            that.$store.commit("setPathJson", {
              folderId: sourceAimData.nodes[i].fileId + driveId,
              json: JsonList
            });
          }
        }
      },
      //未执行的任务和已执行成功的任务显示Transfer Now状态
      showTransferNow(item) {
        let result;
        if ((item.status == 'Normal' && (!item.result || (item.result && item.result.toLowerCase() == 'cancel')) && item
            .type == 1) || (item.result == 'success' && item.type == 1)) {
          result = true;
        }
        if (item.sources && taskListUtils.testSources(item) && taskListUtils.testSources(item) != 2) { //2成功 1部分成功 0失败
          result = false;
        }
        return result;
      },
      //获取多个源目录，返回目录数组
      getMultiSourceCatalog(itemData) {
        let catalogArr = [];
        let catalogName;
        if (itemData.branchType == 'share') {
          //有路径则显示路径，没有就显示名字
          if (itemData.fromItem.sharePath) {
            catalogName = commonUtils.getCatalog(JSON.parse(itemData.fromItem.sharePath));
          } else {
            catalogName = itemData.fromItem.name;
          }
        } else {
          if (itemData.fromItem) {
            catalogName = commonUtils.getCatalog(itemData.fromItem.nodes);
          }
        }
        var shareUrl;
        if (itemData.fromItem) {
          shareUrl = itemData.fromItem.shareUrl
        }
        let catalog = {
          catalog: catalogName,
          fromItem: itemData.fromItem,
          isShare: itemData.branchType == 'share' ? true : false,
          shareUrl: shareUrl
        }
        catalogArr.push(catalog);
        $.each(itemData.sources, function(i, item) {
          let catalogMultName;
          if (itemData.branchType == 'share') {
            if (item.fromItem.sharePath) {
              catalogMultName = commonUtils.getCatalog(JSON.parse(item.fromItem.sharePath));
            } else {
              catalogMultName = item.fromItem.name;
            }
          } else {
            if (item.fromItem) {
              catalogMultName = commonUtils.getCatalog(item.fromItem.nodes);
            }
          }
          let catalogMult = {
            catalog: catalogMultName,
            fromItem: item.fromItem
          }
          catalogArr.push(catalogMult);
        });
        return catalogArr;
      },
      //取消修改任务名
      cancelEditDriveName(index, item) {
        let currentThis = this;
        currentThis.isflage = false;
        setTimeout(function() {
          currentThis.editInputStyle("none", "block", index);
          item.inputValue = item.oldTaskName;
        }, 200);
      },
      //点击分享链接
      toSharelicLink(item) {
        if (item.fromItem.sharePath) {
          this.$store.commit("setSharePath", JSON.parse(item.fromItem.sharePath));
        }
        let link = item.fromItem.shareUrl;
        window.open(link);
      },
      //切换到老版本
      switchOldVersion() {
        let language = commonUtils.getLocaleTo(localStorage.getItem("locale"));
        var tmp = new Date().getTime();
        window.location.href = commonstate.oldVersionUrl + "/index.jsp?rl=" + language + "&tmp=" + tmp + "#home";
      },

      //打开任务列表
      tasklistMenuOpen(index) {
        let that = this;
        if (this.operateMenuIndex == index) {
          this.operateMenuIndex = -1;
          this.$forceUpdate();
          return false;
        }
        if (!this.eidtTaskFlag && !this.closeMentFlag) {
          if (this.operateMenuIndex == -1) {
            this.operateMenuIndex = index;
          }
          this.$nextTick(function() {
            let bottomedge = document.body.offsetHeight - event.clientY;
            if (bottomedge < that.$refs.taskListMenus.offsetHeight) {
              if (that.item.type == 6) {
                if (index == 0) {
                  that.taskListMenuTop = 32;
                  return;
                }
                that.taskListMenuTop = -150;
                return;
              }
              that.taskListMenuTop = -65;
            } else {
              that.taskListMenuTop = 32;
            }
          });
        }
      },
      //任务列表菜单关闭
      tasklistMenuClose() {
        this.operateMenuIndex = -1;
        this.closeMentFlag = true;
        let that = this;
        setTimeout(() => {
          that.closeMentFlag = false;
        }, 100);
      },
      //打开删除单个任务弹窗
      deleteTaskItem(item, index) {
        this.operateMenuIndex = -1;
        this.$parent.$refs.deleteTaskDialog.deleteTaskShow = true;
        this.$parent.$refs.deleteTaskDialog.deleteItem = item;
        this.$parent.$refs.deleteTaskDialog.itemIndex = index;
      },
      //打开和关闭详情界面
      collapsePage(index, item) {
        if (item.cancelingShow) {
          return;
        }
        let that = this;
        if (item.transferDetail && item.transferDetail.state2 && item.transferDetail.state2.sourceToken || item
          .syncDetail || (item.type == 6 && item.transferDetail)) {
          if (this.$parent.collapseFlage != index) {
            if (item.transferDetail && !item.transferDetail.entities) {
              item.transferDetail.entities = [];
            }
            if (item.syncDetail && !item.syncDetail.entities) {
              item.syncDetail.entities = [];
            }
            this.$parent.collapseFlage = index;
            that.$parent.detailShow = true;
            that.$forceUpdate();
          } else {
            this.$parent.collapseFlage = -1;
            that.$parent.detailShow = false;
            if (item.type == 6) {
              this.$parent.$refs.allcollapsebox[index].style.height = '';
              this.$refs.testSingle.style.height = '';
              this.$refs.testSingle.parentElement.style.height = '';
              this.$refs.threadParents.style.height = '';
            }
            that.$forceUpdate();
            if ((item.type == 2 || item.branchType == 'businessTransfer') && item.sources && item.sources.length) {
              if (this.$refs.syncThread) {
                this.$refs.syncThread.closePage();
              }
            }
          }
          if (item.type == 2) {
            if (item.sources) { //如果是多源任务
              $.each(item.sources, function(j, jItem) {
                if (!jItem.syncDetail && localStorage.getItem('syncDetail' + jItem.id) && localStorage.getItem(
                    'syncDetail' + jItem.id) != "null" && Base64.decode(localStorage.getItem('syncDetail' + jItem
                    .id)) && JSON.parse(Base64.decode(localStorage.getItem('syncDetail' + jItem.id)))) {
                  jItem.syncDetail = JSON.parse(Base64.decode(localStorage.getItem('syncDetail' + jItem.id)));
                }
                if (j == item.sources.length - 1) {
                  if (!item.syncDetail && localStorage.getItem('syncDetail' + item.id) && localStorage.getItem(
                      'syncDetail' + item.id) != "null" && Base64.decode(localStorage.getItem('syncDetail' + item
                      .id)) && JSON.parse(Base64.decode(localStorage.getItem('syncDetail' + item.id)))) {
                    item.syncDetail = JSON.parse(Base64.decode(localStorage.getItem('syncDetail' + item.id)));
                  }
                  that.$forceUpdate();
                  return false;
                }
              });
            }
          }
        } else {
          //如果是没有详情的传输任务，则赋值空值
          if (item.type == 1) {
            this.structureTransferDetail(item);
            if (item.branchType == 'businessTransfer') {
              this.structureBusinessTransfer(item); //构造企业云盘参数
            }
            that.openOrClosePage(index);
            that.$forceUpdate();
          }
          if (item.type == 6) {
            this.structureBackupDetail(item);
            that.openOrClosePage(index);
          }
          //如果是没有详情的传输任务，则赋值空值
          if (item.type == 2) {
            let Base64 = require('js-base64').Base64;
            if (item.sources) { //如果是多源任务
              $.each(item.sources, function(j, jItem) {
                if (!jItem.syncDetail && localStorage.getItem('syncDetail' + jItem.id) && localStorage.getItem(
                    'syncDetail' + jItem.id) != "null" && Base64.decode(localStorage.getItem('syncDetail' + jItem
                    .id)) && JSON.parse(Base64.decode(localStorage.getItem('syncDetail' + jItem.id)))) {
                  jItem.syncDetail = JSON.parse(Base64.decode(localStorage.getItem('syncDetail' + jItem.id)));
                }
                if (j == item.sources.length - 1) {
                  if (!item.syncDetail && localStorage.getItem('syncDetail' + item.id) && localStorage.getItem(
                      'syncDetail' + item.id) != "null" && Base64.decode(localStorage.getItem('syncDetail' + item
                      .id)) && JSON.parse(Base64.decode(localStorage.getItem('syncDetail' + item.id)))) {
                    item.syncDetail = JSON.parse(Base64.decode(localStorage.getItem('syncDetail' + item.id)));
                  }
                  that.openOrClosePage(index);
                  that.$forceUpdate();
                  return false;
                }
              });
            } else {
              if (!item.syncDetail && localStorage.getItem('syncDetail' + item.id) && localStorage.getItem(
                  'syncDetail' + item.id) != "null" && JSON.parse(Base64.decode(localStorage.getItem('syncDetail' + item
                  .id)))) {
                item.syncDetail = JSON.parse(Base64.decode(localStorage.getItem('syncDetail' + item.id)));
                that.openOrClosePage(index);
                return;
              }
              that.openOrClosePage(index);
              that.structureSyncDetail(item);
            }
          }
        }
      },
      openOrClosePage(index) {
        let that = this;
        if (that.$parent.collapseFlage != index) {
          that.$parent.collapseFlage = index;
          that.$parent.detailShow = true;
          that.$forceUpdate();
        } else {
          that.$parent.collapseFlage = -1;
          that.$parent.detailShow = false;
          that.$forceUpdate();
        }
      },
      //cloudExploer listData 当任务结束时，刷新目标目录数据
      taskToItemDataRefresh(item, callback) {
        let that = this;
        let driveId;
        if (item.toItem.driveId) {
          driveId = item.toItem.driveId;
        } else {
          if (item.toItem.nodes) {
            driveId = item.toItem.nodes[0].tokenId;
          } else {
            driveId = item.toItem.data[0].nodes[0].tokenId;
          }
        }
        var aimId = item.toItem.id; //目标id
        if (item.type == 6) {
          aimId = item.toItem.fileId;
        }
        let listData = new cloudExploerUtils.filelistData(aimId, commonUtils.getUser().id, driveId);
        commonUtils.toItemDataRefreshQuest(listData, item, function(res) {
          callback(res);
          // if(item.type==6){//如果是备份任务紧接着刷新MultCloud Cloud Backup

          // }
        });
        //如果是双向同步，则两边文件夹都需要更新
        if ((item.type == 2 && item.options && item.options.way == "20") || (item.type == 1 && item.options && item
            .options.isRemove == '1')) {
          let listDataSource = new cloudExploerUtils.filelistData(item.fromItem.id, commonUtils.getUser().id, item
            .fromItem.driveId);
          commonUtils.toItemDataRefreshQuest(listDataSource, item, function(res) {
            callback(res);
          });
        }
      },
      //获取平均的进度百分比
      getAveragePercent(data, index) {
        let that = this;
        let time;
        let divisorNum = 0; //初始化多源的任务条数
        if (data.sources) {
          divisorNum = data.sources.length + 1;
        }
        let allPercent = 0; //初始化总进度
        let allSpeed = 0; //初始化总速度
        if (data) {
          if (!data.percent) {
            this.getRefreshPercent(data);
          }
          if (data.percent) {
            allPercent = parseInt(data.percent);
          }
          allSpeed = that.Utils.fromatSpeedBytes(data.speed); //把带单位的速度转换为字节
          $.each(data.sources, function(index, itemSourceData) {
            if (!itemSourceData.percent) {
              that.getRefreshPercent(itemSourceData);
            }
            if (!itemSourceData.speed) {
              itemSourceData.speed = 0;
            }
            //求出总速度和总进度
            allSpeed = that.Utils.fromatSpeedBytes(itemSourceData.speed) + allSpeed;
            allPercent = parseInt(itemSourceData.percent) + allPercent;
          });
          if (!data.avgpercent) {
            data.avgpercent = 0;
          }
          //求出平均速度,并防止进度回档
          let avgpercent = (allPercent / divisorNum);
          if (Math.floor(avgpercent) >= parseInt(data.avgpercent)) {
            data.avgpercent = Math.floor(avgpercent);
          }
          data.avgspeed = that.Utils.formatByteSpeed(allSpeed); //总速度
          if (parseInt(data.avgpercent) != 100 && parseInt(data.avgpercent) < 100) {
            data.time = setTimeout(() => {
              that.getAveragePercent(data, index);
            }, 2000);
          } else if (parseInt(data.avgpercent) >= 100) {
            that.$forceUpdate();
            data.status = "Done";
            that.initOneTask(data, function(res) {
              that.initTaskListDataProgress();
            });
            that.clearLocalPercent(data);
            that.clearLocalSyncDetail(data);
            that.initTask();
            that.$forceUpdate();
            delete data.avgpercent;
            //如果平均的进度为100，则收拢界面
            taskListUtils.originalPage(index, that);
            clearTimeout(data.time);
          }
          that.$forceUpdate();
          //渲染子组件
          that.threadChange = !that.threadChange;
        }
      },
      getRefreshPercent(itemSourceData) {
        itemSourceData.percent = parseInt(localStorage.getItem(itemSourceData.id));
        if (!itemSourceData.percent) {
          if (taskListUtils.judgeTaskEnd(itemSourceData)) {
            itemSourceData.percent = 100;
            return;
          }
          if ((itemSourceData.status != 'Running' && itemSourceData.status != 'Waiting')) {
            itemSourceData.percent = 100;
          } else {
            itemSourceData.percent = 0;
          }
        }
      },
      //构造单个企业云盘传输任务
      structureSingleBusinessTransfer(singleTask, item) {
        singleTask.syncDetail = {};
        singleTask.syncDetail.state2 = {};
        singleTask.syncDetail.entities = [];
        if (item.lastLog && item.lastLog.errorList) {
          singleTask.syncDetail.state2.errorList = item.lastLog.errorList;
        }
        singleTask.syncDetail.totalFileCount = item.totalFileCount;
        let fromNodes = Object.assign([], singleTask.fromItem.nodes);
        var SourceNodes = [];
        let toNodes = Object.assign([], singleTask.toItem.nodes);
        var AimNodes = [];
        $.each(fromNodes, function(fromIndex, fromNode) {
          let node = {
            filename: fromNode.fileName,
            fileId: fromNode.fileId,
          }
          SourceNodes.push(node);
        });
        $.each(toNodes, function(toIndex, toNode) {
          let node = {
            filename: toNode.fileName,
            fileId: toNode.fileId,
          }
          AimNodes.push(node);
        });
        singleTask.syncDetail.state2.sourceToken = singleTask.fromItem.driveId;
        singleTask.syncDetail.state2.sourceCloudType = singleTask.fromItem.driveType;
        singleTask.syncDetail.state2.sourceId = singleTask.fromItem.id;
        singleTask.syncDetail.state2.desToken = singleTask.toItem.driveId;
        singleTask.syncDetail.state2.desCloudType = singleTask.toItem.driveType;
        singleTask.syncDetail.state2.desId = singleTask.toItem.id;
        singleTask.syncDetail.state2.sourceFilename = singleTask.fromItem.fromEmail;
        singleTask.syncDetail.state2.desFilename = singleTask.toItem.toEmail;
        singleTask.syncDetail.state2.sourceNode = SourceNodes;
        singleTask.syncDetail.state2.desNode = AimNodes;
      },
      //构造企业云盘传输任务
      structureBusinessTransfer(item) {
        for (var i = 0; i < item.sources.length; i++) {
          if (!item.sources[i].syncDetail) {
            item.sources[i].syncDetail = {};
            item.sources[i].syncDetail.state2 = {};
            item.sources[i].syncDetail.entities = [];
            let fromNodes = Object.assign([], item.sources[i].fromItem.nodes);
            var SourceNodes = [];
            let toNodes = Object.assign([], item.sources[i].toItem.nodes);
            var AimNodes = [];
            $.each(fromNodes, function(fromIndex, fromNode) {
              let node = {
                filename: fromNode.fileName,
                fileId: fromNode.fileId,
              }
              SourceNodes.push(node);
            });
            $.each(toNodes, function(toIndex, toNode) {
              let node = {
                filename: toNode.fileName,
                fileId: toNode.fileId,
              }
              AimNodes.push(node);
            });
            item.sources[i].syncDetail.state2.sourceToken = item.fromItem.driveId;
            item.sources[i].syncDetail.state2.sourceCloudType = item.fromItem.driveType;
            item.sources[i].syncDetail.state2.sourceId = item.fromItem.id;
            item.sources[i].syncDetail.state2.desToken = item.toItem.driveId;
            item.sources[i].syncDetail.state2.desCloudType = item.toItem.driveType;
            item.sources[i].syncDetail.state2.desId = item.toItem.id;
            item.sources[i].syncDetail.state2.sourceFilename = item.sources[i].fromItem.fromEmail;
            item.sources[i].syncDetail.state2.desFilename = item.sources[i].toItem.toEmail;
            item.sources[i].syncDetail.state2.taskStartTimeLong = null;
            item.sources[i].syncDetail.state2.readedBytes = null;
            item.sources[i].syncDetail.state2.totalBytes = null;
            item.sources[i].syncDetail.state2.status = 0;
            item.sources[i].syncDetail.speed = null;
            item.sources[i].syncDetail.percent = null;
            item.sources[i].syncDetail.state2.readyTranFileCount = null;
            item.sources[i].syncDetail.state2.totalFileCount = null;
            item.sources[i].syncDetail.state2.taskStartTimeLong = null;
            item.sources[i].syncDetail.state2.sourceNode = SourceNodes;
            item.sources[i].syncDetail.state2.desNode = AimNodes;
          }
        }
        this.$parent.tasklistData[this.index] = item;
      },
      //构造传输任务详情
      structureTransferDetail(item) {
        item.transferDetail = {};
        item.transferDetail.state2 = {};
        item.transferDetail.entities = [];
        let fromNodes = Object.assign([], item.fromItem.nodes);
        var SourceNodes = [];
        let toNodes = Object.assign([], item.toItem.nodes);
        var AimNodes = [];
        $.each(fromNodes, function(fromIndex, fromNode) {
          let node = {
            filename: fromNode.fileName,
            fileId: fromNode.fileId,
          }
          SourceNodes.push(node);
        });
        $.each(toNodes, function(toIndex, toNode) {
          let node = {
            filename: toNode.fileName,
            fileId: toNode.fileId,
          }
          AimNodes.push(node);
        });
        item.transferDetail.state2.sourceToken = item.fromItem.driveId;
        item.transferDetail.state2.sourceCloudType = item.fromItem.driveType;
        item.transferDetail.state2.sourceId = item.fromItem.id;
        item.transferDetail.state2.desToken = item.toItem.driveId;
        item.transferDetail.state2.desCloudType = item.toItem.driveType;
        item.transferDetail.state2.desId = item.toItem.id;
        item.transferDetail.state2.taskStartTimeLong = null;
        item.transferDetail.state2.readedBytes = null;
        item.transferDetail.state2.totalBytes = null;
        item.transferDetail.state2.status = 0;
        item.speed = null;
        item.percent = null;
        item.transferDetail.state2.readyTranFileCount = null;
        item.transferDetail.state2.totalFileCount = null;
        item.transferDetail.state2.taskStartTimeLong = null;
        item.transferDetail.state2.sourceNode = SourceNodes;
        item.transferDetail.state2.desNode = AimNodes;
        //分享任务用
        item.transferDetail.state2.branchType = item.branchType;
        if (item.branchType == 'share') {
          item.transferDetail.state2.shareUrl = item.fromItem.shareUrl;
          item.transferDetail.state2.shareName = item.fromItem.name;
          item.transferDetail.state2.sharePath = item.fromItem.sharePath ? JSON.parse(item.fromItem.sharePath) : {
            'fileName': item.fromItem.name
          };
        }
      },
      structureBackupDetail(item) {
        item.transferDetail = {};
        item.transferDetail;
        item.transferDetail.entities = [];
        let fromNodes = Object.assign([], item.fromItem.nodes);
        var SourceNodes = [];
        let toNodes = Object.assign([], item.toItem.nodes);
        var AimNodes = [];
        $.each(fromNodes, function(fromIndex, fromNode) {
          let node = {
            filename: fromNode.fileName,
            fileId: fromNode.fileId,
          }
          SourceNodes.push(node);
        });
        $.each(toNodes, function(toIndex, toNode) {
          let node = {
            filename: toNode.fileName,
            fileId: toNode.fileId,
          }
          AimNodes.push(node);
        });
        item.transferDetail.tranferWay = item.tranferWay;
        item.transferDetail.sourceToken = item.fromItem.driveId;
        item.transferDetail.sourceCloudType = item.fromItem.driveType;
        item.transferDetail.sourceId = item.fromItem.id;
        item.transferDetail.desToken = item.toItem.driveId;
        item.transferDetail.desCloudType = item.toItem.driveType;
        item.transferDetail.desId = item.toItem.id;
        item.transferDetail.taskStartTimeLong = null;
        item.transferDetail.readedBytes = null;
        item.transferDetail.totalBytes = null;
        item.transferDetail.status = 0;
        item.speed = null;
        item.percent = null;
        item.transferDetail.readyTranFileCount = null;
        item.transferDetail.totalFileCount = null;
        item.transferDetail.taskStartTimeLong = null;
        item.transferDetail.sourceNode = SourceNodes;
        item.transferDetail.desNode = AimNodes;
      },
      //构造同步任务详情，当没有时
      structureSyncDetail(item) {
        item.syncDetail = {};
        item.syncDetail.entities = [];
        let fromNodes = Object.assign([], item.fromItem.nodes);
        var SourceNodes = [];
        let toNodes = Object.assign([], item.toItem.nodes);
        var AimNodes = [];
        $.each(fromNodes, function(fromIndex, fromNode) {
          let node = {
            filename: fromNode.fileName,
            fileId: fromNode.fileId,
          }
          SourceNodes.push(node);
        });
        $.each(toNodes, function(toIndex, toNode) {
          let node = {
            filename: toNode.fileName,
            fileId: toNode.fileId,
          }
          AimNodes.push(node);
        });
        item.syncDetail.sourceToken = item.fromItem.driveId;
        item.syncDetail.sourceCloudType = item.fromItem.driveType;
        item.syncDetail.sourceId = item.fromItem.id;
        item.syncDetail.desToken = item.toItem.driveId;
        item.syncDetail.desCloudType = item.toItem.driveType;
        item.syncDetail.desId = item.toItem.id;
        item.syncDetail.taskStartTimeLong = null;
        item.syncDetail.addFileCount = null;
        item.syncDetail.readedBytes = null;
        item.syncDetail.totalBytes = null;
        item.syncDetail.speed = null;
        item.syncDetail.percent = null;
        item.syncDetail.runningStatus = 0;
        item.syncDetail.readyTranFileCount = null;
        item.syncDetail.totalFileCount = null;
        item.syncDetail.taskStartTimeLong = null;
        item.syncDetail.sourceNode = SourceNodes;
        item.syncDetail.desNode = AimNodes;
      },
      //执行企业传输任务
      executeBusinessTask(item, index) {
        var data = {
          id: item.id,
          ud: commonUtils.getUser().id
        }
        var that = this;
        this.$parent.tasklistData[index].updateFlag = true;
        this.$forceUpdate();
        this.Utils.doBusinessTransferRequest('execute', data).then(res => {
          item.status = 'Running';
          delete item.result;
          delete item.percent;
          delete item.viewed; //去掉该任务的已查看日志标识
          delete item.cancelStatus;
          if (this.$parent.tasklistData[index].transferDetail) {
            delete this.$parent.tasklistData[index].transferDetail;
          }
          for (var i = 0; i < item.sources.length; i++) {
            item.sources[i].status = 'Waiting';
            delete item.sources[i].result;
            delete item.sources[i].percent;
            delete item.sources[i].syncDetail;
            if (item.sources[i].lastLog) {
              delete item.sources[i].lastLog
            }
          }
          that.$parent.tasklistData[index] = item;
          item.transferGet = true;
          that.getBusinessTransferProgress(item);
          that.initTask();
          that.$parent.tasklistData[index].updateFlag = false;
          that.$forceUpdate();
        }).catch(err =>{
			if (err.reason) {
			  err = that.$t('language.exception.' + err.reason)
			}
			that.$parent.tasklistData[index].updateFlag = false;
			that.$forceUpdate();
			that.$toast({
			  text: err,
			  type: 'fail',
			  idValue: "rightContBan"
			});
		});

      },
      //执行任务
      executeTask(item, index) {
        if (item.branchType == 'businessTransfer') {
          this.executeBusinessTask(item, index);
          return;
        }
        let that = this;
        this.$forceUpdate();
        if (this.executeFlag) {
          this.executeFlag = false;
          let taskId;
          item.percent = 0;
          let that = this;
          let user = commonUtils.getUser();
          var executeData;
          if (item.groupId) {
            executeData = new taskListUtils.executeData(user.id, item.type, null, item.groupId);
          } else {
            executeData = new taskListUtils.executeData(user.id, item.type, item.id, null);
          }
          let allData = this.$parent.tasklistData;
          let syncArr = [];
          let backupArr = [];
          if (item.type == 2) {
            that.clearLocalPercent(item);
            that.clearLocalSyncDetail(item);
          }
          for (let i = 0; i < allData.length; i++) {
            if (allData[i].type == 2 && (allData[i].status == 'Running' || allData[i].status == 'Waiting')) {
              syncArr.push(allData[i]);
            }
            if (allData[i].type == 6 && (allData[i].status == 'Running' || allData[i].status == 'Waiting' || allData[i]
                .updateFlag)) {
              backupArr.push(allData[i]);
            }
          }
          // if(backupArr.length >= 1){
          //    this.$toast({
          //       text: this.$t('language.cloudBackup.oneBackup'),
          //       type: 'fail',
          //       idValue: "rightBodyList"
          //     });
          //     this.executeFlag = true;
          //     return false;
          // }
          //非会员用户不能同时执行两个同步任务，但是可以执行两个传输任务，或者一个同步，一个传输任务
          if (!user.vip && syncArr.length >= 1 && item.type == 2) {
            var upgradeNewDialog = this.$parent.$refs.upgradeNewDialog;
            upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_sync');
            upgradeNewDialog.curItem = 'sync';
            upgradeNewDialog.isShow = true;
            this.executeFlag = true;
            return false;
          }
          let usedTraffic = user.usedBytes;
          //流量不足弹窗提醒
          if (user.vip && user.payLevel > 1) {
            usedTraffic = user.payUsedTraffic;
          }
          if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
            var upgradeNewDialog = this.$parent.$refs.upgradeNewDialog;
            upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
            upgradeNewDialog.curItem = 'traffic';
            upgradeNewDialog.isShow = true;
            this.executeFlag = true;
            return false;
          }
          //邮件传输次数不足弹窗提醒
          if(item.options.way=='cloudEmail'&&!user.vip&&user.usageCount>=user.totalCount){
            var upgradeNewDialog = this.$parent.$refs.upgradeNewDialog;
            upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_pdf');
            upgradeNewDialog.curItem = 'pdf';
            upgradeNewDialog.isShow = true;
            this.executeFlag = true;
            return false;
          }
          if (that.$refs.threadParents[index]) {
            that.$refs.threadParents[index].style.height = '';
            //that.$refs.threadParents[index].parentElement.style.height = '';
          }
          item.updateFlag = true;
          this.$parent.tasklistData[index].updateFlag = true;
          this.$forceUpdate();
          this.Utils.doTasksRequest("execute", executeData).then(res => {
            that.executeFlag = true;
            if (item.type == 6) {
              delete item.tranferWay;
            }
            if (res.status == 200) {
              if (item.type == 2) {
                item.syncDetail = {};
                item.syncDetail.runningStatus = 0;
              }
              if (item.type == 6) {
                //this.$parent.tasklistData[index].tranferWay="backup";
              }
              if (item.type == 1) {
                item.transferDetail = {};
                item.transferDetail.state2 = {};
                item.transferDetail.state2.status = 0;
                delete item.percent;
                delete item.spercent;
                if (item.sources) {
                  $(item.sources, function(i, sitem) {
                    delete sitem.percent;
                    delete sitem.spercent;
                  });
                }
              }
              item.retransfer = true;
              item.updateFlag = false;
              this.$parent.tasklistData[index].updateFlag = false;
              item.status = "Waiting"; //执行成功后把任务状态设置为运行中
              if (backupArr.length) {
                item.status = 'Waiting';
                this.$parent.tasklistData[index].status = 'Waiting';
              }

              that.$forceUpdate();
              delete item.avgpercent;
              delete item.transferGet;
              delete item.cancelStatus;
              delete item.totalFileCount;
              delete item.errorFileCount;
              delete item.result;
              $.each(item.sources, function(index, sourceItem) {
                sourceItem.status = 'Waiting'; //执行成功后把子项任务状态设置为等待中
                delete sourceItem.result;
                delete sourceItem.totalFileCount;
                delete sourceItem.errorFileCount;
              });
              that.$parent.tasklistData[index] = item;
              that.$forceUpdate();
              that.judgeShowProgress();
              that.initTask();
            } else {
              this.$toast({
                text: res.msg,
                type: 'fail',
                idValue: "rightBodyList"
              });
            }
          });
        }
      },
      //判断是否显示传输详情
      judgeShowProgress() {
        let that = this;
        let data = this.$parent.tasklistData[this.index];
        that.$forceUpdate();
        Vue.set(that.$parent.tasklistData, this.index, data);
        let haveGetAvg = false;
        if (data.branchType == 'businessTransfer') {
          if ((data.status == "Running" || data.status == 'Waiting') && !data.transferGet) {
            data.transferGet = true;
            that.getBusinessTransferProgress(data);
          }
          return;
        }
        //当传输任务是单个源时，显示传输详情,或者第一个父项是运行或等待状态，则获取进度
        if (data && (data.status == "Running" || data.status == 'Waiting') && (data.type == 1 || data.type == 6) && !
          data.transferGet) {
          delete data.result;
          data.transferGet = true; //标识是否已经获取了数据的进度
          that.getTransferProgress(data, this.index);
        }
        //当传输任务是多个源时，显示传输详情
        if (data && (data.type == 1 || data.type == 6) && data.sources) {
          if (data.branchType == 'businessTransfer') {
            return;
          }
          $.each(data.sources, function(dataIndex, dataItem) { //当子项都未获取进度，并且父项也未获取进度时，并且状态是在运行或等待时，才获取进度，防止重复多次获取进度
            if ((dataItem.status == "Running" || dataItem.status == 'Waiting') && !data.transferGet) {
              delete data.result;
              data.transferGet = true; //标识是否已经获取了数据的进度
              that.getTransferProgress(data, that.index); //为了界面渲染，还是这样获取进度
              return false;
            }
          });
        }
        //当同步任务是单个目标时，显示传输详情
        if (data && data.type == 2 && !data.sources && (data.status == "Running" || data.status == "Waiting") && !data
          .transferGet) {
          data.single = true;
          data.transferGet = true;
          if (data.status == "Running" || data.status == "Waiting") { //如果刚开始任务是Running的，优先获取进度
            delete data.result;
            that.getSyncProgress(data, that.index);
          }
        }
        //当同步任务是多个目标时，显示同步详情
        if (data && data.type == 2 && data.sources) {
          //对总进度条进行计算
          data.single = false;
          if ((data.status == 'Running' || data.status == 'Waiting') && !data.transferGet) {
            delete data.result;
            data.transferGet = true;
            that.getSyncProgress(data, that.index);
            that.getAveragePercent(data, that.index); //获取平均进度
            haveGetAvg = true;
          }
          $.each(data.sources, function(index, sourceItem) {
            sourceItem.single = false;
            sourceItem.fromItem = data.fromItem;
            sourceItem.parentNode = true; //表示其有父节点
            if ((sourceItem.status == 'Running' || sourceItem.status == 'Waiting') && !sourceItem.transferGet) {
              delete data.result;
              sourceItem.transferGet = true;
              that.getSyncProgress(sourceItem, index);
              if (!haveGetAvg) {
                that.getAveragePercent(data, that.index); //获取平均进度
              }
            }
          });
        }
      },
      //获取同步任务的进度,
      getSyncProgress(item, index) {
        var fileCountPercent;
        var t;
        let that = this;
        var originalItem;
        if (item.schedules && item.schedules.disabled) {
          return;
        }
        var progressData = new taskListUtils.progressData(commonUtils.getUser().id, item.type, item.id, null);
        if (!item.cancelStatus) { //若用户没有点击取消按钮，就继续执行这个方法
          this.Utils.doTasksRequest("get_progress", progressData, {
            timeout: 60000
          }).then(res => {
            if (res.status == 200 && res.progress) {
              let taskId = res.progress.id; //设置任务id为返回进度的id
              if (taskId == item.id) {
                item.syncDetail = res.progress; //设置同步详情为返回的进度
                that.$forceUpdate();
                if (!item.readyBytes) { //如果item.readyBytes不存在则先设置为0
                  item.readyBytes = 0;
                }
                if (!item.percent) {
                  item.percent = 0;
                } else { //如果该任务的进度不为0，则让其状态是Running
                  item.status = 'Running';
                  item.syncDetail.status = 'Running';
                }
                item.oldReadyBytes = item.readyBytes;
                item.readyBytes = item.syncDetail.readedBytes;
                if (item.syncDetail.totalFileCount && !isNaN(item.syncDetail.response)) {
                  fileCountPercent = (parseInt(item.syncDetail.response) / item.syncDetail.totalFileCount);
                } else {
                  fileCountPercent = 0;
                }
                if (item.syncDetail.totalFileCount <= 2) {
                  let percent = Math.floor(((item.readyBytes / item.syncDetail.totalBytes) * 100));
                  if (percent >= parseInt(item.percent)) { //防止进度回档
                    if (percent > 100) { //防止显示超过100
                      item.percent = 100;
                    } else {
                      item.percent = percent;
                    }
                  }
                } else {
                  if (Math.floor(fileCountPercent * 100) >= parseInt(item.percent)) { //防止进度回档
                    if (Math.floor(fileCountPercent * 100) > 100) { //防止显示超过100
                      item.percent = 100;
                    } else {
                      item.percent = Math.floor(fileCountPercent * 100);
                    }
                  }
                }
                if (item.percent && !item.cancelStatus) {
                  localStorage.setItem(item.id, item.percent);
                }
                if (!item.oldReadyBytes) {
                  item.oldReadyBytes = 0;
                }
                let interval = (item.readyBytes - item.oldReadyBytes) / 6; //获取每隔6秒的字节增量
                if (interval) {
                  item.speed = that.Utils.formatByteSpeed(interval); //计算进度运行的速度
                }
                item.syncDetail.percent = item.percent;
                item.syncDetail.speed = item.speed;
                // Vue.set(that.$parent.tasklistData, index, item);
                that.$parent.$forceUpdate();
                that.$nextTick(() => {
                  that.initTask();
                });
                that.$store.state.threadChange = !that.$store.state.threadChange; //强制渲染数据
                that.threadChange = !that.threadChange;
                that.showTaskStatus();
                if (that.$refs.syncDetail && that.$refs.syncDetail[0]) {
                  that.$refs.syncDetail[0].$forceUpdate();
                }
                if (that.$refs.syncThread && that.$refs.syncThread[0]) {
                  if (that.$refs.syncThread[0].$refs.syncThreadDetail && that.$refs.syncThread[0].$refs
                    .syncThreadDetail[0]) {
                    that.$refs.syncThread[0].$refs.syncThreadDetail[0].$forceUpdate();
                  }
                }
                that.$forceUpdate();
                item.t = setTimeout(() => {
                  that.getSyncProgress(item, index); //6秒后继续获取进度
                }, 6000);
                if (taskListUtils.judgeTaskEnd(item)) {
                  that.setSyncDetailtoLocal(item);
                }
                if (item.syncDetail.errorList.length && item.syncDetail.errorList[0].cause) { //如果进度返回了错误列表
                  that.SyncNoSpace(item, index);
                  that.$forceUpdate();
                  return false;
                }
                if (item.syncDetail.response == 'success') { //如果进度返回成功
                  item.status = "Done";
                  item.percent = 100;
                  item.syncDetail.status = "Done";
                  item.syncDetail.percent = 100;
                  that.clearLocalPercent(item);
                  that.setSyncDetailtoLocal(item);
                  item.result = 'success';
                  clearTimeout(item.t);
                }
              }
              that.$forceUpdate();
            } else if (res.status == 200 && res.task) { //如果进度返回200并返回res.task，
              if (!item.percent) { //如果首次请求没有进度
                if (!item.requestTime) {
                  item.requestTime = 1;
                } else {
                  item.requestTime = item.requestTime + 1;
                }
                if (item.requestTime < 4) { //如果请求小于4次就继续获取进度,实际获取了4次
                  item.t = setTimeout(() => {
                    that.getSyncProgress(item, index); //6秒后继续获取进度
                  }, 6000);
                } else { //如果请求大于6次，则结束任务
                  that.syncProgressFinallyEnd(item, index, res);
                }
              } else { //结束任务
                that.syncProgressFinallyEnd(item, index, res);
              }
            }
          }, err => {
            setTimeout(() => {
              that.getSyncProgress(item, index);
            }, 5000);
          });
        }
      },
      syncProgressFinallyEnd(item, index, res) {
        this.initTask();
        let that = this;
        if (item.requestTime) {
          delete item.requestTime;
        }
        item.status = "Done";
        if (res.task.lastLog) {
          res.task.lastLog.newLog.reverse();
          var lastLog = res.task.lastLog.newLog[0];
          if (lastLog.response != 'error') { //如果没返回错误信息，则设置任务成功
            item.percent = 100;
            item.result = 'success'; //关闭界面
            if (item.syncDetail) {
              item.syncDetail.status = "Done";
              item.syncDetail.percent = 100;
            } else {
              item.syncDetail = {};
              item.syncDetail.status = "Done";
              item.syncDetail.percent = 100;
            }
          } else {
            item.result = 'error';
            item.lastLog = lastLog;
            item.errorFileCount = res.task.errorFileCount; //让界面更快显示结果
            item.totalFileCount = res.task.totalFileCount; //关闭界面
            if (!item.sources && that.$parent.collapseFlage == index && !item.parentNode) {
              that.$parent.collapseFlage = -1;
            }
          }
        }
        if (item.syncDetail && item.syncDetail.runningStatus) {
          delete item.syncDetail.runningStatus;
        }
        clearTimeout(item.t);
        that.taskToItemDataRefresh(item, function(res) {}); //刷新目标目录
        if (lastLog && !lastLog.errorList.length || !lastLog) { //如果数据没报错则状态设置为成功
          item.result = 'success';
        }
        item.status = "Done";
        commonUtils.refreshUserInfo(that, function(res) {});
        if (!item.sources && that.$parent.collapseFlage == index && !item.parentNode) {
          that.$parent.collapseFlage = -1;
        }
        let syncDetail = item.syncDetail;
        let parentNode = false;
        let sources;
        if (item.parentNode) {
          parentNode = true;
        }
        if (item.sources) {
          sources = item.sources;
        }
        item = res.task;
        if (syncDetail) {
          item.syncDetail = syncDetail;
        }
        if (parentNode) {
          item.parentNode = parentNode;
        }
        if (sources) {
          item.sources = sources;
        }
        that.syncProgressEnd(item); //结束同步请求
      },
      //同步任务无空间
      SyncNoSpace(item, index) {
        let causeArr = item.syncDetail.errorList[0].cause.split(':');
        if (causeArr[causeArr.length - 1].trim() == 'The remaining space is insufficient' || item.syncDetail.response ==
          'cancel' || item.syncDetail.response == 'error') {
          if (item.syncDetail.response == 'cancel') {
            item.result = 'cancel';
          }
          if (item.syncDetail.response == 'error') {
            item.result = 'error';
          }
          item.status = "Done";
          //如果是单目标同步才收起界面
          if (!item.sources && !item.parentNode) {
            this.closeSyncThreadPage(item, index);
          }
          clearTimeout(item.t);
        }
      },
      //传输任务无空间
      transferNoSpace(item, index) {
        let causeArr = item.transferDetail.state2.errorList[0].cause.split(':');
        let reason = causeArr[causeArr.length - 1].trim();
        if (reason == 'The remaining space is insufficient' || reason ==
          'The task stopped running due to insufficient free space') {
          item.result = 'cancel';
          item.status = "Done";
          if (item.sources) {
            $.each(item.sources, function(j, jItem) {
              jItem.result = 'cancel';
              jItem.status = "Done";
            });
          }
          clearTimeout(item.t);
        } else {
          item.result = 'error';
          item.status = "Done";
          if (item.sources) {
            $.each(item.sources, function(j, jItem) {
              jItem.result = 'error';
              jItem.status = "Done";
            });
          }
          clearTimeout(item.t);
        }
        if (this.$parent.collapseFlage == index) {
          this.$parent.collapseFlage = -1;
          this.$forceUpdate();
        }
      },
      //把已成功的同步任务详情存入缓存
      setSyncDetailtoLocal(item) {
        let Base64 = require('js-base64').Base64;
        //    console.log('存入'+item.syncDetail);
        let jsonString = JSON.stringify(item.syncDetail);
        if (item.syncDetail && jsonString.length > 50) {
          localStorage.setItem('syncDetail' + item.id, Base64.encode(jsonString));
        }
      },
      //关闭同步任务界面
      closeSyncThreadPage(item, index) {
        let that = this;
        //如果该任务是单源任务结束则清空详情缓存
        that.clearLocalSyncDetail(item);
        if (that.$parent.collapseFlage == index) {
          that.$parent.collapseFlage = -1;
          if (that.$refs.threadParents[index]) {
            that.$refs.threadParents[index].style.height = 95 + 'Px';
            that.$refs.threadParents[index].parentElement.style.height = 95 + 'Px';
            that.$forceUpdate();
            clearTimeout(item.t);
          }
        }
      },
      //当同步任务结束以后界面刷新数据，获取watiting数据的进度
      syncProgressEnd(item) {
        let that = this;
        that.clearLocalPercent(item);
        that.setSyncDetailtoLocal(item);
        that.initOneTask(item, function(res) {
          if (!item.sources && !item.parentNode) {
            that.initTaskListDataProgress();
          }
        });
      },
      clearLocalSyncDetail(item) {
        if (localStorage.getItem('syncDetail' + item.id)) {
          localStorage.setItem('syncDetail' + item.id, null);
        }
        if (item.sources) {
          $.each(item.sources, function(j, jItem) {
            if (localStorage.getItem('syncDetail' + jItem.id)) {
              localStorage.setItem('syncDetail' + jItem.id, null);
            }
          });
        }
      },
      setPercent(item) {
        if (item.percent) { //如果该任务有进度了，但是进度不是100，则赋值，让进度变成100
          if (item.percent && item.percent != 100) {
            item.percent = 100;
            item.getId = item.workId;
          }
        }
      },
      setSourcePercent(item) {
        if (item.percent) {
          if (item.sources) { //如果是多源任务，有进度了，但是进度不是100，则赋值，让进度变成100
            $.each(item.sources, function(i, souItem) {
              if (souItem.spercent && souItem.spercent != 100) {
                souItem.spercent = 100;
                item.getId = souItem.workId; //让最后获取进度判断是否完成的wd为进度不为100的id
              }
            });
            item.spercent = 100;
            item.percent = 100;
          }
        }
      },
      //获取企业云盘任务结束
      getbusinessTransferEnd(item, index) {
        let that = this;
        var getData = {
          id: item.id,
          ud: commonUtils.getUser().id
        }
        // var runFlag = false;//刷新标识
        this.Utils.doBusinessTransferRequest("get", getData).then(result => {
          if (result.businessTask) {
            item.status = result.businessTask.status;
            if (result.businessTask.status == 'Waiting' || result.businessTask.status == 'Running') {
              //runFlag=true;
              setTimeout(() => {
                item.transferGet = true;
                that.getBusinessTransferProgress(item);
              }, 6000);
            } else {
              item.result = result.businessTask.result;
              clearTimeout(item.t);
              delete item.transferGet;
              delete item.requestTime;
              that.initTask();
              if (that.$parent.collapseFlage == index) {
                that.$parent.collapseFlage = -1;
                that.$parent.$forceUpdate();
              }
              that.taskToItemDataRefresh(item, function(res) {});
              that.$forceUpdate();
              if (result.tasks) {
                for (var i = 0; i < result.tasks.length; i++) {
                  for (var j = 0; j < item.sources.length; j++) {
                    if (result.tasks[i].workId == item.sources[j].workId) {
                      item.sources[j].status = result.tasks[i].status;
                      item.sources[j].result = result.tasks[i].result;
                    }
                  }
                }
              }
              that.$parent.tasklistData[index] = item;
              that.$store.commit('setTaskListArrAll', that.$parent.tasklistData);
              that.initTask();
            }
          }
        }).catch(err =>{
			if (err.reason) {
			  err = that.$t('language.exception.' + err.reason)
			}
			that.$toast({
			  text: err,
			  type: 'fail',
			  idValue: "rightContBan"
			});
		});
      },
      //获取传输和云备份任务结束
      getTransferEnd(item, index) {
        let that = this;
        clearTimeout(item.t);
        that.taskToItemDataRefresh(item, function(res) {});
        if (!item.totalFileCount) {
          item.totalFileCount = 0;
        }
        if (that.$parent.collapseFlage == index) {
          that.$parent.collapseFlage = -1;
          that.$parent.$forceUpdate();
        }
        that.$forceUpdate();
        item.status = 'Done';
        that.initTask();
        that.initOneTask(item, function(res) {});
        commonUtils.refreshUserInfo(that, function(res) {});
        if (this.$parent.tasklistData[index].transferDetail) {
          delete this.$parent.tasklistData[index].transferDetail;
        }
        this.$parent.$refs.allcollapsebox[index].style.height = '';
        this.$refs.testSingle.style.height = '';
        this.$refs.testSingle.parentElement.style.height = '';
      },
      //任务结束后，初始化一条任务，可能是单或者多
      initOneTask(item, callback) {
        let that = this;
        that.$parent.tasklistData[that.index].status = item.status; //每次都需要更新状态
        let getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, item.groupId);
        this.Utils.doTasksRequest("get", getData).then(result => {
          that.initTask();
          if (result.status == 200 && result.tasks[0]) {
            if (item.type == 6) {
              result.tasks[0].type = 6;
              if (result.tasks[0].status == 'Canceling') {
                this.statusTxt = this.$t('language.common.waiting') + '...';
                setTimeout(() => {
                  that.initOneTask(item, callback);
                }, 4000);
                return false;
              } else {
                delete item.cancelingShow;
              }
            }
            let tasks = result.tasks;
            if (tasks[0].status == 'Waiting') {
              setTimeout(() => {
                that.initOneTask(item, callback);
              }, 4000);
              return false;
            }
            if (tasks.length > 1) {
              $.each(tasks, function(j, jItem) {
                if (jItem.status == 'Waiting') {
                  setTimeout(() => {
                    that.initOneTask(item, callback);
                  }, 4000);
                  return false;
                }
              });
            }
            let allTaskListArr = that.packageTaskList(tasks);
            $.each(allTaskListArr, function(i, aitem) {
              if (aitem.id == item.id) {
                aitem.transferGet = true;
                return false;
              }
            })
            allTaskListArr.sort(taskListUtils.sortCreateTime);
            that.$store.commit('setTaskListArrAll', allTaskListArr);
            that.$parent.tasklistData = allTaskListArr;
            Vue.set(that.$parent.tasklistData, that.index, allTaskListArr[that.index]);
            that.$parent.$forceUpdate();
            that.$nextTick(() => {
              that.initTask();
            });
            that.$forceUpdate();
            //   that.$parent.collapseFlage=-1;
            callback(result);
          }
        });
      },
      //判断传输任务结束
      judgeTransferProgressEnd(item, getId, index) {
        let that = this;
        let progressData;
        if (item.sources) {
          progressData = new taskListUtils.progressData(commonUtils.getUser().id, item.type, item.id, item.workId);
        } else {
          progressData = new taskListUtils.progressData(commonUtils.getUser().id, item.type, item.id, getId);
        }
        this.Utils.doTasksRequest("get_progress", progressData).then(res1 => { //如果该单个进度已结束，则让界面结束
          if (res1.status == 200 && res1.progress) {
            if (res1.progress.state2 && that.isNumber(res1.progress.state2.response)) { //如果返回的是数字，则继续获取进度
              setTimeout(() => {
                that.getTransferProgress(item, index);
                that.transferDetailChange = !that.transferDetailChange;
                that.$forceUpdate();
              }, 6000);
              return false;
            } else { //如果返回的是非数字，则任务结束
              setTimeout(() => {
                that.getTransferEnd(item, index);
                clearTimeout(item.t);
              }, 3000);
            }
          } else if(res1.status == 400 && res1.reason == 'redisCommandTimeOut'){
            //如果是响应超时，6s后再次请求
            setTimeout(() => {
              that.getTransferProgress(item, index);
              that.transferDetailChange = !that.transferDetailChange;
              that.$forceUpdate();
            }, 6000);
          } else {
            if (res1.status == 200) {
              that.getTransferEnd(item, index);
              clearTimeout(item.t);
            }
          }
        });
      },
      //计算传输任务的速度
      calculationTransferSpeed(item, transferInfo) {
        item.oldReadyBytes = item.readyBytes; //把readyBytes赋值给oldReadyBytes
        item.readyBytes = transferInfo.readedBytes; //把最新获取的readedBytes赋值给readyBytes
        if (!item.readyBytes) { //把上一个获取字节初始化为0
          item.readyBytes = 0;
        }
        if (!item.oldReadyBytes) {
          item.oldReadyBytes = 0;
        }
        //计算6秒后的字节差，用于计算速度
        let interval = (item.readyBytes - item.oldReadyBytes) / 6;
        if (interval) {
          item.speed = this.Utils.formatByteSpeed(interval);
          if (item.branchType == 'businessTransfer') {
            transferInfo.speed = item.speed;
          }
          this.$forceUpdate();
        }
      },
      //计算云备份任务的速度
      calculationBackupSpeed(item, transferInfo) {
        item.oldReadyBytes = item.readyBytes; //把readyBytes赋值给oldReadyBytes
        item.readyBytes = transferInfo.totalReadedBytes; //把最新获取的readedBytes赋值给readyBytes
        if (!item.readyBytes) { //把上一个获取字节初始化为0
          item.readyBytes = 0;
        }
        if (!item.oldReadyBytes) {
          //如果没有上一次的字节数，则记为0
          item.oldReadyBytes = item.readyBytes;
        }
        //计算6秒后的字节差，用于计算速度
        let interval = (item.readyBytes - item.oldReadyBytes) / 6;
        if (interval || 0 == interval) {
          item.speed = this.Utils.formatByteSpeed(interval);
          this.$forceUpdate();
        }
      },
      //获取多源传输任务的进度
      getTransferSourceProgressDetail(item, progressData, index) {
        //若用户没有点击取消按钮，就继续执行这个方法
        let sourceItemFlag; //用于标志子任务详情是否显示
        var fileCountPercent;
        let that = this;
        var originalItem;
        var progressData;
        var percentArr = []; //存储多源任务的进度百分比
        let tranTasksId;
        var transferInfo;
        var runItem; //表示后端返回进度的item
        delete progressData.s;
        this.Utils.doTasksRequest("get_progress", progressData, {
          timeout: 60000
        }).then(res => {
          if (res.status == 200 && res.progress) {
            if (item.requestTime) {
              delete item.requestTime;
            }
            tranTasksId = res.progress.state2.taskId; //进度返回的taskId
            $.each(item.sources, function(i, souItem) {
              if (souItem.workId == tranTasksId) {
                sourceItemFlag = true; //表示是有详情的多源任务
                souItem.spercent = commonUtils.calculationPercent(res.progress.state2);
                runItem = Object.assign({}, souItem);
              }
            });
            if (item.workId == tranTasksId || sourceItemFlag) { //如果返回的是该任务的进度，或者是有详情的多源任务
              if (item.workId == tranTasksId) {
                item.spercent = commonUtils.calculationPercent(res.progress.state2);
                runItem = Object.assign({}, item);
              }
              if (res.progress.entities) { //对后端返回的entities在运行的放在第一个
                if (res.progress.entities.length) {
                  $.each(res.progress.entities, function(i, item) {
                    if (item.rate != -1) {
                      res.progress.entities.splice(i, 1);
                      res.progress.entities.unshift(item);
                    }
                  });
                }
              }
              //如果是多源任务，如果任务的这次任务详情和上次的不一致，表示切换了任务，将现在的进度设置为0，将切换之前的任务设置为100%
              if (item.transferDetail && item.transferDetail.state2) {
                if (item.transferDetail.state2.taskId != tranTasksId) {
                  let oldTaskId = item.transferDetail.state2.taskId;
                  $.each(item.sources, function(i, souItem) {
                    if (souItem.workId == oldTaskId) {
                      souItem.spercent = 100;
                    }
                  });
                  if (item.workId == oldTaskId) {
                    item.spercent = 100;
                  }
                  if (item.percent) {
                    item.oldpercent = item.percent;
                    item.percent = 0;
                    that.$forceUpdate();
                    Vue.set(that.$parent.tasklistData, index, item);
                    that.$parent.$forceUpdate();
                    that.$nextTick(() => {
                      that.initTask();
                    })
                  }
                }
              }
              Vue.set(that.$parent.tasklistData, this.index, item);
              that.transferDetailChange = !that.transferDetailChange;
              item.transferDetail = res.progress;

              transferInfo = item.transferDetail.state2;
              transferInfo.desNode = item.toItem.nodes;
              //设置延迟切换进度，好在多源时候有个进度效果
              setTimeout(() => {
                item.percent = commonUtils.calculationPercent(transferInfo);
                if (!item.percent) { //如果进度不存在，则设置进度为0
                  item.percent = 0;
                } else {
                  item.status = 'Running'; //设置进度状态为运行中
                }
              }, 600);
              //计算传输任务的速度
              this.calculationTransferSpeed(item, transferInfo);
              //分享任务用
              this.setShareParams(item);
              //如果返回的进度不是该任务的进度，但是该任务具有进度信息，说明该进度已经完成,给该进度赋值100
            } else {
              this.setSourcePercent(item); //封装进度，防止进度满了，已经运行其他进度了，界面还不结束
            }
            //如果是多源任务，把进度存入数组
            if (item.workId == tranTasksId) {
              item.spercent = commonUtils.calculationPercent(transferInfo);
            }
            percentArr = this.setTransferPercentArr(item, tranTasksId, transferInfo);
            //如果是单个任务传输为成功状态
            if (commonUtils.isAllEqual(percentArr) && percentArr[0] == 100) {
              //获取该任务的单个进度
              that.judgeTransferProgressEnd(item, item.workId, index); //判断传输任务是否结束，如果是结束，则结束传输任务
            } else { //如果任务未成功则继续获取进度
              item.t = setTimeout(() => {
                that.getTransferSourceProgressDetail(item, progressData, index); //隔6秒后继续获取进度
                Vue.set(that.$parent.tasklistData, index, item);
                that.transferDetailChange = !that.transferDetailChange;
                that.$forceUpdate();
              }, 6000);
            }
            this.transferDetailChange = !this.transferDetailChange; //渲染数据
            that.$store.state.transferDetailChange = !that.$store.state.transferDetailChange; //强制渲染数据
            that.$forceUpdate();
            //若该任务传输完毕
          } else {
            //如果任务原来有进度
            //如果后端返回没有任务在执行,让最多请求2次后结束任务
            if (!item.requestTime) {
              item.requestTime = 1;
            } else {
              item.requestTime = item.requestTime + 1;
            }
            if (item.requestTime < 3) {
              item.t = setTimeout(() => {
                that.getTransferSourceProgressDetail(item, progressData, index); //隔6秒后继续获取进度
              }, 6000);
            } else { //如果请求大于2次，则结束任务
              //如果是多源任务，把进度存入数组
              that.getTransferEnd(item, index); //判断传输任务是否结束，如果是结束，则结束传输任务
              delete item.requestTime;
              clearTimeout(item.t);
            }
            that.$forceUpdate();
          }
        }, err => {
          setTimeout(() => {
            that.getTransferSourceProgressDetail(item, progressData, index);
          }, 6000);
        });
      },
      //如果有错误的结果则结束传输任务
      haveErrorResultEndTransferTask(item, index) {
        if (item.transferDetail && item.transferDetail.state2 && item.transferDetail.state2.errorList && item
          .transferDetail.state2.errorList.length) {
          if (item.lastLog) {
            item.lastLog.errorList = item.transferDetail.state2.errorList;
          } else {
            item.lastLog = item.transferDetail.state2;
          }
          delete item.transferGet;
          clearTimeout(item.t);
          this.$parent.$refs.allcollapsebox[index].style.height = '';
          this.$refs.testSingle.style.height = '';
          this.$refs.testSingle.parentElement.style.height = '';
          this.transferNoSpace(item, index);
        }
      },
      //设置传输的任务进度
      setTransferPercentArr(item, tranTasksId, transferInfo) {
        let percentArr = [];
        let that = this;
        if (tranTasksId == item.workId) {
          item.spercent = commonUtils.calculationPercent(transferInfo);
        }
        percentArr.push(parseInt(item.spercent));
        $.each(item.sources, function(i, souItem) {
          if (souItem.workId == tranTasksId) {
            souItem.percent = item.percent;
            souItem.spercent = commonUtils.calculationPercent(transferInfo);
          }
          percentArr.push(parseInt(souItem.spercent));
        });
        return percentArr;
      },
      //封装请求返回的taskList数据
      packageTaskList(tasks) {
        let that = this;
        let allNotGropArr = that.$store.state.taskListNotGropArr;
        $.each(tasks, function(j, jItem) {
          $.each(allNotGropArr, function(i, aItem) {
            if (jItem.id == aItem.id) {
              allNotGropArr[i] = Object.assign({}, tasks[j]);
            }
          });
        });
        let newValueCopy = Object.assign([], allNotGropArr);
        $.each(newValueCopy, function(i, aItem) {
          if (aItem.sources) {
            if (aItem.branchType != 'businessTransfer') {
              delete aItem.sources;
            }
          }
        });
        let allTaskListArr = taskListUtils.constructGroupData(newValueCopy);
        that.$store.commit('setTaskListNotGropArr', newValueCopy); //把最近的数据进行封装
        return allTaskListArr; //更新TaskList数据，因为数据相同监听不到数据，手动封装,并返回
      },
      //判断是否是重传任务
      getRetransferFlag(originalItem) {
        let that = this;
        if (originalItem) {
          $.each(that.$parent.tasklistData, function(nowIndex, nowItem) {
            if (originalItem.id == nowItem.id) {
              nowItem.retransfer = originalItem.retransfer;
              return false;
            }
          });
        }
      },
      //如果运行中的任务是传输任务，给其赋值参数
      setShareParams(item) {
        item.transferDetail.state2.branchType = item.branchType;
        if (item.branchType == 'share') {
          item.transferDetail.state2.shareUrl = item.fromItem.shareUrl;
          item.transferDetail.state2.shareName = item.fromItem.name;
          item.transferDetail.state2.sharePath = item.fromItem.sharePath ? JSON.parse(item.fromItem.sharePath) : {
            'fileName': item.fromItem.name
          };
        }
      },
      //取消一个正在运行的备份任务
      cancelBackupRun(item, index) {
        let that = this;
        let workId = item.id;
        let cancelData;
        clearTimeout(item.t);
        item.updateFlag = true;
        if (item.groupId) {
          cancelData = new taskListUtils.cancelGdData(commonUtils.getUser().id, item.type, item.groupId, workId);
        } else {
          cancelData = new taskListUtils.cancelIdData(commonUtils.getUser().id, item.type, item.id, workId);
        }
        that.$forceUpdate();
        clearTimeout(item.t);
        this.Utils.doTasksRequest('cancel', cancelData).then(res => {
		  if (item.transferDetail) {
		    delete item.transferDetail;
		  }
		  //收拢界面
		  taskListUtils.originalPage(index, that);
		  //获取该任务最新信息
		  item.cancelingShow = true; //标识该任务在正在取消的状态
		  item.updateFlag = false;
		  that.initTask();
		  that.initOneTask(item, function(res) {
		  
		  });
        }).catch(err =>{
			if (err.reason) {
				if(err.reason == 'notFoundTask'){
					if (item.transferDetail) {
					  delete item.transferDetail;
					}
					//收拢界面
					taskListUtils.originalPage(index, that);
					//获取该任务最新信息
					item.cancelingShow = true; //标识该任务在正在取消的状态
					item.updateFlag = false;
					that.initTask();
					that.initOneTask(item, function(res) {
					
					});
					return
				}else{
					 err = that.$t('language.exception.' + err.reason)
				}
			}
			item.updateFlag = false;
			that.$forceUpdate();
			that.$toast({
			  text: err,
			  type: 'fail',
			  idValue: "rightBodyList"
			});
		});
      },
      //取消一个正在运行的企业传输任务
      cancelBusinessTransfer(item, index) {
        var data = {
          id: item.id,
          ud: commonUtils.getUser().id
        }
        var that = this;
        this.Utils.doBusinessTransferRequest('cancel', data).then(res => {
          item.cancelStatus = true;
          item.status = "Done";
          item.result = "Cancel";
          delete item.requestTime;
          if (item.syncDetail) {
            delete item.syncDetail;
          }
          if (item.transferDetail) {
            delete item.transferDetail;
          }
          delete item.transferGet;
          delete item.t;
          //this.$parent.detailShow=false;
          if (item.sources) {
            for (var i = 0; i < item.sources.length; i++) {
              item.sources[i].status = 'Done'
              item.sources[i].result = "Cancel";
            }
          }
          that.$parent.tasklistData[that.index] == item;
          Vue.set(that.$parent.tasklistData, this.index, item);
          that.transferDetailChange = !that.transferDetailChange;
          that.$forceUpdate();
          that.initTask();
        }).catch(err =>{
			if(err.reason){
				 err = that.$t('language.exception.' + err.reason)
			}
			that.$toast({
			  text: err,
			  type: 'fail',
			  idValue: "rightBodyList"
			});
		});
      },
      //取消一个正在进行传输的进程
      cancelTaskRun(item, index) {
        if (item.branchType == 'businessTransfer') {
          this.cancelBusinessTransfer(item, index);
          return;
        }
        let that = this;
        let workId = item.id;
        let cancelData;
        clearTimeout(item.t);
        item.updateFlag = true;
        if (item.type == 1) {
          let transDetail = item.transferDetail;
          if (transDetail) {
            workId = transDetail.state2.taskId;
            if (!workId) {
              workId = item.id;
            }
          }
        } else {
          that.clearLocalPercent(item);
          that.clearLocalSyncDetail(item);
        }
        if (item.type == 2 && item.sources) {
          item.avgpercent = 0;
          delete item.percent;
          that.$forceUpdate();
          clearTimeout(item.time);
        }
        if (item.groupId) {
          cancelData = new taskListUtils.cancelGdData(commonUtils.getUser().id, item.type, item.groupId, workId);
        } else {
          cancelData = new taskListUtils.cancelIdData(commonUtils.getUser().id, item.type, item.id, workId);
        }
        that.$forceUpdate();
        item.cancelStatus = true;
        clearTimeout(item.t);
        this.Utils.doTasksRequest('cancel', cancelData).then(res => {
          if (res.status == 200 || res.reason == 'notFoundTask') {
            item.status = "Done";
            item.result = "cancel";
            if (item.syncDetail) {
              delete item.syncDetail;
            }
            if (item.transferDetail) {
              delete item.transferDetail;
            }
            that.$parent.tasklistData[that.index] == item;
            Vue.set(that.$parent.tasklistData, this.index, item);
            delete item.transferGet; //删除已获取进度标识
            that.executeFlag = true;
            that.transferDetailChange = !that.transferDetailChange;
            that.$forceUpdate();
            if (item.type == 2 && item.sources) {
              item.avgpercent = 0;
              that.$forceUpdate();
              if (that.$refs.syncThread) {
                that.$refs.syncThread.closePage();
              }
            }
            $.each(item.sources, function(sIndex, sItem) {
              sItem.status = "Done";
              sItem.result = "cancel";
              sItem.cancelStatus = true;
              delete sItem.percent;
              clearTimeout(sItem.t);
              that.$forceUpdate();
            });
            item.updateFlag = false;
            that.taskToItemDataRefresh(item, function(res) {});
            //获取该任务最新信息
            that.initOneTask(item, function(res) {
              that.initTaskListDataProgress();
            });
            //刷新用户流量数据
            commonUtils.refreshUserInfo(that, function(res) {});
            taskListUtils.originalPage(index, that);
            that.initTask();
          } else {
            item.updateFlag = false;
            that.$forceUpdate();
            // that.$toast({
            //     text: this.$t('language.exception.'+ res.reason),
            //     type: 'fail',
            //     idValue: "rightBodyList"
            //  });
          }
        });
      },
      //不管是否传了id 获取的都是一个正在传输进程的进度
      getTransferProgress(item, index) {
        let that = this;
        if (!item.cancelStatus && item.transferGet) { //若用户没有点击取消按钮，就继续执行这个方法
          var progressData = new taskListUtils.progressData(commonUtils.getUser().id, item.type, item.id, item.workId);
          if (item && item.type == 1 && !item.sources) { //如果是单个任务，则传入wd
            this.getTransferSingleProgressDetail(item, progressData, index);
          }
          if (item && item.type == 6 && !item.sources) { //如果是单个任务，则传入wd
            this.getBackupSingleProgressDetail(item, progressData, index);
          }
          if (item.sources) {
            progressData = new taskListUtils.progressData(commonUtils.getUser().id, item.type, item.id, null);
            //如果是多个源，则不传入wd，获取正在执行的任务
            this.getTransferSourceProgressDetail(item, progressData, index);
          }
        }
      },
      getBackupSingleProgressDetail(item, progressData, index) {
        let tranTasksId;
        var transferInfo;
        var fileCountPercent;
        let that = this;
        delete progressData.s;
        this.Utils.doTasksRequest("get_progress", progressData, {
          timeout: 60000
        }).then(res => {
          //如果返回进度数据
          if (res.status == 200 && res.progress) {
            //删除请求次数字段
            if (item.requestTime) {
              delete item.requestTime;
            }
            tranTasksId = res.progress.id; //进度返回的taskId
            if (item.id == tranTasksId) { //如果返回的是该任务的进度，或者是有详情的多源任务
              //对任务详情进行赋值
              res.progress.tranferWay = item.tranferWay;
              item.transferDetail = res.progress;
              item.transferDetail.sourceCloudType = item.fromItem.driveType;
              item.transferDetail.sourceToken = item.fromItem.driveId;
              item.transferDetail.desCloudType = item.toItem.driveType;
              item.transferDetail.desToken = item.toItem.driveId;
              transferInfo = item.transferDetail;
              if (!item.fromItem.data) {
                transferInfo.sourceNode = item.fromItem.nodes;
              } else {
                transferInfo.sourceNode = item.fromItem;
              }
              if (!item.toItem.data) {
                transferInfo.desNode = item.toItem.nodes;
              } else {
                transferInfo.desNode = item.toItem;
              }
              if (transferInfo.nextCount) { //如果返回了nextCount，任务进度以fileCountPercent为准
                fileCountPercent = transferInfo.nextCount / transferInfo.totalFileCount;
              } else {
                fileCountPercent = 0;
              }
              var percent = commonUtils.calculateBackupPercent(transferInfo);
              //if(percent > item.percent){
              item.percent = percent;
              //}
              //stateSet排序
              if (item.transferDetail.stateSet) {
                let firstSet = [];
                $.each(item.transferDetail.stateSet, function(toIndex, setItem) {
                  if (setItem.status == 0) {
                    firstSet.unshift(setItem);
                  } else {
                    firstSet.push(setItem);
                  }
                });
                item.transferDetail.stateSet = firstSet;
              }
              that.$forceUpdate();
              if (!item.percent) { //如果进度不存在，则设置进度为0
                item.percent = 0;
              } else {
                if (item.percent != 100) { //如果是单源任务则不再设为运行状态
                  item.status = 'Running';
                }
              }
              if (res.progress.runningStatus <= 1) {
                item.status = 'Waiting';
              } else {
                item.status = 'Running';
              }
              this.calculationBackupSpeed(item, transferInfo);
              //分享任务用
              //如果返回的进度不是该任务的进度，但是该任务具有进度信息，说明该进度已经完成,给该进度赋值100
            } else {
              this.setPercent(item); //封装进度，防止进度满了，已经运行其他进度了，界面还不结束
            }
            if (item.transferDetail && item.transferDetail.totalFileCount) {
              item.totalFileCount = item.transferDetail.totalFileCount;
            }
            this.$forceUpdate();
            //如果是单个任务传输为成功状态
            if (((((fileCountPercent) * 100).toFixed(0) >= 100 && transferInfo && transferInfo.readedBytes ==
                transferInfo
                .totalBytes && !item.transferDetail.errorList.length) || (((fileCountPercent) * 100).toFixed(0) >=
                100 && item.transferDetail.response == 'success' && !item.transferDetail.errorList.length)) && item
              .transferDetail.isFinishConfig) {
              that.judgeTransferProgressEnd(item, item.id, index); //结束传输任务
              that.$parent.$refs.allcollapsebox[index].style.height = '';
              that.$refs.testSingle.style.height = '';
              that.$refs.testSingle.parentElement.style.height = '';
              that.initTask();
              that.$forceUpdate();
              //如果进度是100，但是又报错文件，则可能是部分成功
            } else { //如果任务未成功则继续获取进度
              item.t = setTimeout(() => {
                that.getBackupSingleProgressDetail(item, progressData, index); //隔6秒后继续获取进度
                that.transferDetailChange = !that.transferDetailChange;
                that.$forceUpdate();
              }, 6000);
            }
            this.transferDetailChange = !this.transferDetailChange; //渲染数据
            that.$store.state.transferDetailChange = !that.$store.state.transferDetailChange; //强制渲染数据
            that.$forceUpdate();
            //若该任务传输完毕
          } else if(res.status == 400 && res.reason == 'redisCommandTimeOut'){
            //如果是响应超时，6s后再次请求
            item.t = setTimeout(() => {
              that.getBackupSingleProgressDetail(item, progressData, index); //隔6秒后继续获取进度
            }, 6000);
          } else {
            //如果后端返回没有任务在执行,让最多请求四次后结束任务
            if (!item.percent || res.task.status == "Waiting") {
              if (!item.requestTime) {
                item.requestTime = 1;
              } else {
                item.requestTime = item.requestTime + 1;
              }
              if (item.requestTime < 3 || res.task.status == "Waiting") {
                if (res.task.status == "Waiting") {
                  item.status = 'Waiting';
                  that.$parent.tasklistData[index].status = 'Waiting';
                }
                item.t = setTimeout(() => {
                  that.getBackupSingleProgressDetail(item, progressData, index); //隔6秒后继续获取进度
                }, 6000);
              } else { //如果请求大于6次，则结束任务
                item.status = 'Done';
                that.$parent.tasklistData[index].status = 'Done';
                delete item.requestTime;
                that.getTransferEnd(item, index);
              }
            } else {
              if (item.requestTime) {
                delete item.requestTime;
              }
              that.getTransferEnd(item, index);
            }
            that.haveErrorResultEndTransferTask(item, index);
            that.$forceUpdate();
          }
        }, err => {
          setTimeout(() => {
            that.getBackupSingleProgressDetail(item, progressData, index);
          }, 6000);
        });
      },
      //获取企业云盘传输进度
      getBusinessTransferProgress(item) {
        if (item.transferGet) {
          var data = {
            id: item.id,
            ud: commonUtils.getUser().id
          }
          if (item.schedules && item.schedules.disabled) {
            return;
          }
          var that = this;
          this.Utils.doBusinessTransferRequest("progress", data, {
            timeout: 60000
          }).then(res => {
            //    console.log('获取企业云盘传输任务进度');
            //    console.log(res);
            var tasksProgress = res.tasks; //后端返回的进度
            var allPercent = 0; //总进度
            var taskEnd = true; //标记任务是否结束
            // if(tasksProgress[0].progress){
            for (var i = 0; i < item.sources.length; i++) {
              if (tasksProgress) {
                for (var j = 0; j < tasksProgress.length; j++) {
                  if (tasksProgress[j].progress) { //如果返回了进度
                    taskEnd = false;
                    if (item.sources[i].workId == tasksProgress[j].progress.state2.taskId) {
                      var speed = item.speed;
                      item.sources[i].syncDetail = tasksProgress[j].progress;
                      if (speed) { //速度回显
                        item.sources[i].syncDetail.state2.speed = speed;
                      }
                      if (tasksProgress[j].progress.entities && tasksProgress[j].progress.entities
                        .length) { //对后端返回的entities在运行的放在第一个
                        $.each(tasksProgress[j].progress.entities, function(i, item) {
                          if (item.rate != -1) {
                            tasksProgress[j].progress.entities.splice(i, 1);
                            tasksProgress[j].progress.entities.unshift(item);
                          }
                        });
                      }

                      var transferInfo = tasksProgress[j].progress.state2;
                      transferInfo.percent = commonUtils.calculationPercent(transferInfo);
                      this.calculationTransferSpeed(item, transferInfo);
                      if (!transferInfo.percent) {
                        transferInfo.percent = 0;
                      }
                      allPercent = allPercent + transferInfo.percent;
                      that.$forceUpdate();
                    }
                  } else {
                    if (item.sources[i].workId == tasksProgress[j].task.workId) {
                      item.sources[i].runCount = tasksProgress[j].task.runCount;
                      item.sources[i].status = tasksProgress[j].task.status;
                      if (tasksProgress[j].task.result) {
                        item.sources[i].result = tasksProgress[j].task.result;
                      }
                      if (!item.sources[i].syncDetail) { //封装单个任务的详情
                        that.structureSingleBusinessTransfer(item.sources[i], tasksProgress[j].task);
                      }
                      if (tasksProgress[j].task.lastLog && tasksProgress[j].task.lastLog.errorList && tasksProgress[
                          j].task.lastLog.errorList.length) {
                        item.sources[i].result = 'error';
                        if (item.sources[i].syncDetail) {
                          item.sources[i].syncDetail.state2.errorList = tasksProgress[j].task.lastLog.errorList;
                          item.sources[i].syncDetail.state2.totalFileCount = tasksProgress[j].task.totalFileCount;
                        }
                      }
                      if (item.sources[i].status == 'Waiting' || !item.sources[i].status) {
                        item.sources[i].percent = 0;
                      }
                      if (item.sources[i].status == 'Waiting' || item.sources[i].status == 'Running') {
                        taskEnd = false;
                      }
                      if (item.sources[i].status == 'Done' || (item.sources[i].status == 'Normal' && item.sources[i]
                          .result)) {
                        item.sources[i].lastLog = tasksProgress[j].task.lastLog;
                        item.sources[i].percent = 100;
                        if (item.sources[i] && item.sources[i].syncDetail) {
                          item.sources[i].syncDetail.state2.percent = 100;
                          item.sources[i].syncDetail.entities = []; //任务结束后为控制界面高度，entities为空
                        }
                      }
                      if (item.sources[i] && item.sources[i].syncDetail) {
                        item.sources[i].syncDetail.state2.status = tasksProgress[j].task.status;
                      }
                      allPercent = allPercent + item.sources[i].percent;
                      that.$store.state.threadChange = !that.$store.state.threadChange; //强制渲染数据
                    }

                  }
                }
              }

              if (i == item.sources.length - 1) {
                item.percent = Math.floor(allPercent / item.sources.length);
                that.$store.state.threadChange = !that.$store.state.threadChange; //强制渲染数据
                that.threadChange = !that.threadChange;
                //console.log(item);
                //表明此时任务已结束
                if (taskEnd) {
                  if (!item.requestTime) {
                    item.requestTime = 1;
                  } else {
                    item.requestTime = item.requestTime + 1;
                  }
                  if (item.requestTime < 6) {
                    setTimeout(() => {
                      that.getBusinessTransferProgress(item); //隔6秒后继续获取进度
                    }, 6000);
                  } else { //如果请求大于6次，则结束任务
                    //delete item.requestTime;
                    delete item.t;
                    delete item.transferGet;
                    clearTimeout(item.t);
                    that.getbusinessTransferEnd(item, this.index);
                  }
                } else { //如果未结束则继续获取进度
                  item.t = setTimeout(() => {
                    that.getBusinessTransferProgress(item);
                    that.$store.state.threadChange = !that.$store.state.threadChange; //强制渲染数据
                    that.threadChange = !that.threadChange;
                  }, 6000);
                }
              }
            }
          }).catch(err =>{
			  if (err.reason) {
			    err = that.$t('language.exception.' + err.reason)
			  }
			  that.$toast({
			    text: err,
			    type: 'fail',
			    idValue: "rightContBan"
			  });
		  });
        }
      },
      getTransferSingleProgressDetail(item, progressData, index) {
        let tranTasksId;
        var transferInfo;
        var fileCountPercent;
        let that = this;
        delete progressData.s;
        this.Utils.doTasksRequest("get_progress", progressData, {
          timeout: 60000
        }).then(res => {
          //如果返回进度数据
          if (res.status == 200 && res.progress) {
            //删除请求次数字段
            if (item.requestTime) {
              delete item.requestTime;
            }
            tranTasksId = res.progress.state2.taskId; //进度返回的taskId
            if (item.workId == tranTasksId) { //如果返回的是该任务的进度，或者是有详情的多源任务
              if (res.progress.entities && res.progress.entities.length) { //对后端返回的entities在运行的放在第一个
                $.each(res.progress.entities, function(i, item) {
                  if (item.rate != -1) {
                    res.progress.entities.splice(i, 1);
                    res.progress.entities.unshift(item);
                  }
                });
              }
              //对任务详情进行赋值
              item.transferDetail = res.progress;
              transferInfo = item.transferDetail.state2;
              transferInfo.desNode = item.toItem.nodes;
              if (transferInfo.nextCount) { //如果返回了nextCount，任务进度以fileCountPercent为准
                fileCountPercent = transferInfo.nextCount / transferInfo.totalFileCount;
              } else {
                fileCountPercent = 0;
              }
              item.percent = commonUtils.calculationPercent(transferInfo);
              that.$forceUpdate();
              if (!item.percent) { //如果进度不存在，则设置进度为0
                item.percent = 0;
              } else {
                if (item.percent != 100) { //如果是单源任务则不再设为运行状态
                  item.status = 'Running';
                }
              }
              this.calculationTransferSpeed(item, transferInfo);
              //分享任务用
              this.setShareParams(item);
              //如果返回的进度不是该任务的进度，但是该任务具有进度信息，说明该进度已经完成,给该进度赋值100
            } else {
              this.setPercent(item); //封装进度，防止进度满了，已经运行其他进度了，界面还不结束
            }
            item.totalFileCount = item.transferDetail.state2.totalFileCount;
            this.$forceUpdate();
            //如果是单个任务传输为成功状态
            if ((((fileCountPercent) * 100).toFixed(0) >= 100 && transferInfo && transferInfo.readedBytes ==
                transferInfo
                .totalBytes && !item.transferDetail.state2.errorList.length) || (((fileCountPercent) * 100).toFixed(
                  0) >= 100 && item.transferDetail.state2.response == 'success' && !item.transferDetail.state2
                .errorList.length)) {
              that.judgeTransferProgressEnd(item, item.workId, index); //结束传输任务
              //如果进度是100，但是又报错文件，则可能是部分成功
            } else if (((fileCountPercent) * 100).toFixed(0) >= 100 && item.transferDetail.state2.errorList
              .length) {
              item.result = 'error';
              item.status = 'Done';
              item.errorFileCount = item.transferDetail.state2.errorList.length;
              item.totalFileCount = item.transferDetail.state2.totalFileCount;
              that.judgeTransferProgressEnd(item, item.workId, index);
            } else { //如果任务未成功则继续获取进度
              item.t = setTimeout(() => {
                that.getTransferSingleProgressDetail(item, progressData, index); //隔6秒后继续获取进度
                that.transferDetailChange = !that.transferDetailChange;
                that.$forceUpdate();
              }, 6000);
            }
            Vue.set(that.$parent.tasklistData, this.index, item);
            this.transferDetailChange = !this.transferDetailChange; //渲染数据
            that.$store.state.transferDetailChange = !that.$store.state.transferDetailChange; //强制渲染数据
            that.$forceUpdate();
            //若该任务传输完毕
          } else if(res.status == 400 && res.reason == 'redisCommandTimeOut'){
            //如果是响应超时，6s后再次请求
            item.t = setTimeout(() => {
              that.getTransferSingleProgressDetail(item, progressData, index); //隔6秒后继续获取进度
            }, 6000);
          } else {
            //如果后端返回没有任务在执行,让最多请求四次后结束任务
            if (!item.percent) {
              if (!item.requestTime) {
                item.requestTime = 1;
              } else {
                item.requestTime = item.requestTime + 1;
              }
              if (item.requestTime < 3) {
                item.t = setTimeout(() => {
                  that.getTransferSingleProgressDetail(item, progressData, index); //隔6秒后继续获取进度
                }, 6000);
              } else { //如果请求大于6次，则结束任务
                delete item.requestTime;
                that.getTransferEnd(item, index);
              }
            } else {
              if (item.requestTime) {
                delete item.requestTime;
              }
              that.getTransferEnd(item, index);
            }
            that.haveErrorResultEndTransferTask(item, index);
            that.$forceUpdate();
          }
        }, err => {
          setTimeout(() => {
            that.getTransferSingleProgressDetail(item, progressData, index);
          }, 6000);
        });
      },
      //定时获取任务进度
      getTimedExecution() {
        var dailyDiff;
        let that = this;
        let now = new Date();
        let item = this.item;
        let nowSeconds = (now.getHours() * 3600) + (now.getMinutes() * 60) + (now.getSeconds()); //获取现在时间的时分秒
        if (item.schedules) {
          let timeSchedule = item.schedules;
          //获取现在的时间
          let DateStr = commonUtils.getNowDateFormat();
          if (timeSchedule.type == 'Once' && !timeSchedule.outDate) { //获取类型为一次还未过时的任务
            let DateArr = DateStr.trim().split(" ");
            let DateValue = DateArr[0];
            //若该任务今天就执行，计算现在时间和即将执行时间的时间差
            let diff = that.calculDateTimeDifference(timeSchedule, item.type);
            that.setTimeoutExeCute(diff, item);
          }
          if (timeSchedule.type == 'Daily') {
            let timeSecondsArr = that.getDailyDiffArr(timeSchedule, item);
            for (let k = 0; k < timeSecondsArr.length; k++) { //计算时间差，开始执行
              if (nowSeconds < timeSecondsArr[k]) {
                dailyDiff = (timeSecondsArr[k] - nowSeconds) * 1000;
                that.setTimeoutExeCute(dailyDiff, item);
              }
            }
          }
          if (timeSchedule.type == 'Weekly') {
            let weeKdiff = that.getWeeklyDiffArr(timeSchedule, item);
            if (weeKdiff && weeKdiff > 0) { //若有即将执行的任务开始执行
              that.setTimeoutExeCute(weeKdiff, item);
            }
          }
          if (timeSchedule.type == 'Monthly') {
            let monthdiff = that.getMonthlyDiffArr(timeSchedule, item);
            if (monthdiff && monthdiff > 0) { //若有即将执行的任务开始执行
              that.setTimeoutExeCute(monthdiff, item);
            }
          }
        }
      },
      //设置每个定时任务的定时器
      setTimeoutExeCute(diff, item) {
        let that = this;
        if (diff >= 0) {
          item.timeoutExeCute = setTimeout(function() {
            delete item.result;
            delete item.cancelStatus;
            if (item.schedules && item.schedules.disabled) {
              return;
            }
            //如果是传输任务开始执行，删除之前的一个结果，让状态变为传输中，获取传输进度
            if (item.type == 1 || item.type == 6) {
              if (item.type == 6) {
                //备份任务定时器启动时自动更改为备份任务
                item.tranferWay = 'backup';
              }
              delete item.result;
              item.transferGet = true;
              if(item.status != 'Running'){
                item.status = 'Waiting';
              }
              // item.status = 'Running';
              if (item.branchType != 'businessTransfer') {
                that.getTransferProgress(item, that.index);
              } else {
                delete item.result;
                delete item.percent;
                delete item.viewed;
                delete item.cancelStatus;
                if (that.$parent.tasklistData[that.index].transferDetail) {
                  delete that.$parent.tasklistData[that.index].transferDetail;
                }
                for (var i = 0; i < item.sources.length; i++) {
                  item.sources[i].status = 'Waiting';
                  delete item.sources[i].percent;
                  delete item.sources[i].result;
                  delete item.sources[i].syncDetail;
                  if (item.sources[i].lastLog) {
                    delete item.sources[i].lastLog
                  }
                }
                that.getBusinessTransferProgress(item);
              }
              that.transferDetailChange = !that.transferDetailChange;
              //如果是同步任务开始执行，删除之前的一个结果，让状态变为传输中，获取同步进度
            } else if (item.type == 2) {
              item.status = 'Running';
              delete item.result;
              that.getSyncProgress(item, that.index);
              if (item.sources) {
                //如果是多源同步任务，获取平均进度
                that.getAveragePercent(item, that.index);
                $.each(item.sources, function(sindex, sourceItem) {
                  //删除之前的一个结果，让状态变为等待中，获取同步进度
                  delete sourceItem.result;
                  sourceItem.status = 'Waiting';
                  that.getSyncProgress(sourceItem, sindex);
                });
              }
            }
            clearTimeout(item.timeoutExeCute);
            delete item.timeoutExeCute;
          }, diff);
        }
      },
      clearTime() {
        clearTimeout(this.item.timeoutExeCute);
        delete this.item.timeoutExeCute;
      },
      //计算现在时间和即将执行时间的时间差
      calculDateTimeDifference(schedule, type) {
        let onceTime = schedule.date + " " + schedule.times[0];
        //标准日期格式转成Long型
        var nextTimeLong = new Date(onceTime.replace(new RegExp("-", "gm"), "/")).getTime();
        let nowTimeLong = new Date().getTime();
        //计算时间差
        let diffence = (nextTimeLong - nowTimeLong);
        return diffence;
      },
      //计算执行时间为今天的时间差
      calcuTimeDifference(time) {
        let now = new Date(); //获取今天的日期
        let nowSeconds = (now.getHours() * 3600) + (now.getMinutes() * 60) + (now.getSeconds()); //获取现在时间的时分秒
        //把时间转换为秒数
        var arr = time.split(":");
        let hs = parseInt(arr[0] * 3600); //时转为秒
        let ms = parseInt(arr[1] * 60); //分转为秒
        let ss;
        if (arr[2]) {
          ss = parseInt(arr[2]);
        } else {
          ss = 0;
        }
        let seconds = hs + ms + ss;
        let diff = (seconds - nowSeconds) * 1000;
        return diff; //返回今天即将执行的时间差
      },
      //获取即将执行的Daily定时任务时间集合
      getDailyDiffArr(timeSchedule, item) {
        var dailyDiff;
        var dailyExeCute;
        let nowSeconds = (new Date().getHours() * 3600) + (new Date().getMinutes() * 60) + (new Date()
          .getSeconds()); //获取现在时间的时分秒
        let valueTimes;
        let timeSecondsArr = [];
        valueTimes = timeSchedule.times;
        for (let i = 0; i < valueTimes.length; i++) {
          if (valueTimes[i]) {
            var arr = valueTimes[i].split(":");
            let hs = parseInt(arr[0] * 3600);
            let ms = parseInt(arr[1] * 60);
            let ss;
            if (arr[2]) {
              ss = parseInt(arr[2]);
            } else {
              ss = 0;
            }
            let seconds = hs + ms + ss;
            timeSecondsArr.push(seconds);
          }
        }
        timeSecondsArr = timeSecondsArr.slice().sort(function(a, b) {
          return a - b
        });
        return timeSecondsArr;
      },
      //获取即将执行的weekly定时任务时间差
      getWeeklyDiffArr(timeSchedule, item) {
        let that = this;
        let nextTime;
        let weekArr;
        let nextWeek;
        let weeKdiff;
        let nowWeek = new Date().getDay() + 1;
        weekArr = timeSchedule.weeks;
        if (weekArr) {
          weekArr = weekArr.slice().sort(function(a, b) {
            return a - b
          });
          for (let i = 0; i < weekArr.length; i++) {
            if (nowWeek <= weekArr[i] && weekArr[i] != 0) {
              nextWeek = parseInt(weekArr[i]);
              break;
            } else {
              nextWeek = 0;
            }
          }
        }
        //如果每周执行的时间为今天
        if (nextWeek == nowWeek) {
          nextTime = timeSchedule.times[0];
          weeKdiff = parseInt(that.calcuTimeDifference(nextTime));
        }
        return weeKdiff;
      },
      //获取即将执行的monthly定时任务时间差
      getMonthlyDiffArr(timeSchedule, item) {
        let that = this;
        let nextTime;
        let monthdiff;
        let nextDay;
        let dayArr;
        let monthDayArr = new Array;
        let nowDate = new Date().getDate();
        dayArr = timeSchedule.days;
        if (dayArr && dayArr.length) {
          $.each(dayArr, function(i, itemData) {
            if (itemData && typeof(itemData) == 'string') {
              let itemSpace = itemData.trim();
              itemSpace = parseInt(itemSpace);
              monthDayArr.push(itemSpace);
            }
          });
          if (monthDayArr.length) {
            dayArr = monthDayArr;
          } else {
            dayArr = dayArr;
          }
          dayArr = dayArr.slice().sort(function(a, b) {
            return a - b
          });
          for (let i = 0; i < dayArr.length; i++) {
            if (nowDate <= dayArr[i]) {
              nextDay = dayArr[i];
              break;
            } else {
              nextDay = dayArr[0];
            }
          }
        }
        if (nowDate == nextDay) {
          nextTime = timeSchedule.times[0];
          monthdiff = this.calcuTimeDifference(nextTime);
        }
        return monthdiff;
      },
      traverseOpen() {
        this.$refs.traveseDialog.traverseTimeShow = true;
      },
      toRestoreSource(item) {
        var itemCopy = Object.assign({}, item);
        var data = {
          fileId: item.backupRoot.fileId,
          filename: item.backupRoot.filename
        }
        itemCopy.fromItem.fileId = data.fileId;
        itemCopy.fromItem.filename = data.filename;
        var nodes = Object.assign([], item.fromItem.nodes);
        var nodesCopy = Object.assign([], item.fromItem.nodes);
        var toItemCopy = Object.assign({}, item.fromItem);
        var fileId = item.backupRoot.fileId;
        var arr = fileId.split('/');
        var nodeNameArr = [];
        for (var i = 0; i < arr.length; i++) {
          var element = arr[i];
          for (var j = 0; j < nodes.length; j++) {
            var node = nodes[j];
            nodeNameArr.push(node.filename);
          }
          if (element && !nodeNameArr.includes(element)) {
            var data = {
              fileId: nodes[0].fileId + '/' + element,
              filename: element
            }
            nodesCopy.unshift(data);
          }
        }
        toItemCopy.nodes = nodesCopy;
        this.toSourceCatalog(toItemCopy);
      },
      toOriginal(item) {
        if (!item.fromItem.data) {
          this.toAimCatalog(item.fromItem);
          return;
        }
        this.$parent.$refs.restoreAimMoreDialog.viewBackupShow = true;
        this.$parent.$refs.restoreAimMoreDialog.sourceData = item.fromItem;
      }
    },
    filters: {
      ellipsis(value) {
        if (!value) return '';
        if (value.length > 39) {
          return value.slice(0, 39) + '...';
        }
        return value;
      },


    }

  }
</script>

<style scoped>
  .realtime-position {
    float: left;
    top: 36Px !important;
    margin-right: 8Px;
  }

  @-webkit-keyframes rotation {
    from {
      -webkit-transform: rotate(0deg);
    }

    to {
      -webkit-transform: rotate(360deg);
    }
  }

  .Rotation {
    -webkit-transform: rotate(360deg);
    animation: rotation 3s linear infinite;
    -moz-animation: rotation 3s linear infinite;
    -webkit-animation: rotation 3s linear infinite;
    -o-animation: rotation 3s linear infinite;
  }

  .task-list-welcome {
    position: relative;
    width: 100%;
    height: 100%;
  }



  .task-shedule-position {
    position: relative;
    top: 3Px;
    /*no*/
  }

  .welcome-task-list {
    text-align: center;
    font-size: 28Px !important;
    /*no*/
    margin-bottom: 65Px;
    /*no*/
  }

  .welcome-task {
    position: relative;
    width: 100%;
    height: 50Px;
    /*no*/
    margin-top: 40Px;
    /*no*/
  }

  .welcome-task-button {
    width: 215Px;
    /*no*/
    height: 40Px;
    /*no*/
    font-size: 16Px;
    /*no*/
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    line-height: 40Px;
    /*no*/
  }

  .list-des-position {
    float: left;
    position: relative;
    top: -10Px;
    /*no*/
  }

  .title-des {
    font-size: 18Px;
    /*no*/
    font-weight: bold;
    position: relative;
    top: -5Px;
    /*no*/
    color: #000;
  }

  .task-list-icon-position {
    float: left;
    top: 8Px;
    /*no*/
    position: relative;
  }

  .welcome-font-position {
    float: left;
    margin-left: 10Px;
    /*no*/
  }

  .transfer-operate {
    height: 35Px;
    /*no*/
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .tick-purple-position {
    float: left;
    position: relative;
    top: 10Px;
    /*no*/
    left: 17Px;
    /*no*/
    width: 15Px;
    /*no*/
    height: 15Px;
    /*no*/
  }

  .list-title-name {
    float: left;
    max-width: 160Px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .filter-menu {
    position: absolute;
    z-index: 600;
    background: #fff;
    width: 100Px;
    /*no*/
    height: 100Px;
    /*no*/
    border: 1Px solid #8a96e3;
    /*no*/
    right: 0;
  }

  .share-button {
    float: right !important;
  }

  .filter-menu-item {
    width: 100%;
    height: 33.3Px;
    /*no*/
    line-height: 33Px;
    /*no*/
  }

  .type-menu-item {
    width: 100%;
    height: 34Px;
    /*no*/
    line-height: 34Px;
    /*no*/
    position: relative;
  }

  .type-menu-checked {
    background: #d9e7ff;
  }

  .filter-triangle-position {
    position: relative;
    top: 6Px;
    /*no*/
    margin-right: 10Px;
    /*no*/
  }

  .filter-menu-item:hover,
  .type-menu-item:hover,
  .operate-menu-item:hover {
    background: #d9e7ff;
    cursor: pointer;
  }

  .filter-type-name {
    margin: 0 10Px 0 25Px;
    /*no*/
    float: left;
  }

  .transfers-to-catelogs {
    position: absolute;
    z-index: 3;
    width: 110Px;
    /*no*/
    height: 90Px;
    /*no*/
    border: 1Px solid #8a96e3;
    /*no*/
    background: #fff !important;
    top: 0Px;
    /*no*/
    overflow: auto;
  }

  .task-operating-menu {
    position: relative;
    float: right;
    top: 4Px;
    /*no*/
    margin-left: 15Px;
    /*no*/
  }

  .transfers-button {
    float: right;
    position: relative;
    top: 2Px;
    /*no*/
    font-size: 14Px;
    /*no*/
    color: #fff;
    min-width: 80Px;
  }

  .share-list-button {
    float: right;
    position: relative;
    top: 2Px;
    /*no*/
    font-size: 14Px;
    /*no*/
    border-radius: 2Px;
  }

  .transfers-button-update {
    float: right;
    position: relative;
    top: 2Px;
    /*no*/
    font-size: 14Px;
    /*no*/
    cursor: not-allowed;
    pointer-events: none;
    background: #c8d1f7;
    min-width: 80Px;
  }

  .runnow-button {
    float: right;
    position: relative;
    top: 2Px;
    /*no*/
    font-size: 14Px;
    /*no*/
    cursor: pointer;
    min-width: 80Px;
    color: #5166BD;
    background-color: #fff;
    border: 1px solid #5166BD;/*no*/
    margin-right: 15px;/*no*/
  }

  .runnow-button:hover {
    background-color: #EEF0FF;
  }

  #canceling .el-loading-spinner .circular {
    height: 25Px !important;
    width: 25Px !important;
  }

  .transfers-status {
    float: left;
    width: 13%;
    /*no*/
    font-size: 14Px;
    /*no*/
    color: #6f7886;
    height: 100%;
    /*no*/
    line-height: 95Px;
    /*no*/
    min-width: 85Px;
    /*no*/
    margin-left: 0.7%;
    /*no*/
    position: relative;
  }

  .right-task-list {
    height: 60Px;
    /*no*/
    width: 95%;
    float: left;
    background-color: #f2f7fe;
    padding: 0 2% 0 2%;
    /*no*/
    position: relative;
  }

  .task-list-title {
    font-size: 14Px;
    /*no*/
    color: #6f7886;
    position: absolute;
    top: 0;
    bottom: 0;
    height: 14Px;
    /*no*/
    width: 96%;
    margin: auto;
    float: left;
  }

  .task-list-icons {
    height: 20Px;
    /*no*/
    float: right;
    cursor: pointer;
  }

  .task-list-contens {
    float: left;
    width: 100%;
    height: 100%;
    /*no*/
    box-sizing: border-box;
    padding: 0 2% 0 2%;
    /*no*/
    min-width: 1160Px;
    /*no*/
    overflow-y: overlay;
    overflow-x: hidden;
  }

  .task-list-all {
    width: 100%;
    height: calc(100% - 60Px);
    /*no*/
    overflow-y: hidden;
    overflow-x: hidden;
  }

  .task-list-edit-contens {
    float: left;
    width: 100%;
    height: calc(100% - 100Px) !important;
    /*no*/
    box-sizing: border-box;
    padding: 0 27Px 0 27Px;
    /*no*/
    min-width: 1167Px;
    /*no*/
    overflow: auto;
  }

  .list-node-name {
    color: #4281ff;
    max-width: calc(100% - 50Px);
    /*no*/
    height: 20Px !important;
    /*no*/
    float: left;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  .right-body-box,
  #taskLoading {
    width: 100%;
    height: 100%;
  }

  /*定义滑块，内阴影及圆角*/
  .task-list-all::-webkit-scrollbar {
    width: 8Px;
    /*no*/
    height: 8Px;
    /*no*/
    background-color: #fff;
    position: absolute;
    z-index: 700;
  }

  .task-list-contens::-webkit-scrollbar,
  .task-list-edit-contens::-webkit-scrollbar {
    width: 8Px;
    /*no*/
    height: 8Px;
    /*no*/
    background-color: #fff;
    position: absolute;
    z-index: 700;
  }

  .task-list-all::-webkit-scrollbar-thumb,
  .task-list-edit-contens::-webkit-scrollbar-thumb,
  .task-list-contens::-webkit-scrollbar-thumb {
    height: 1Px;
    /*no*/
    border-radius: 5Px;
    /*no*/
    background-color: #becae4;
    position: absolute;
    z-index: 700;
  }

  .list-radio-position {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .edit-all-box {
    width: 100%;
    height: 95Px;
    /*no*/
    position: relative;
    margin-bottom: 10Px;
    /*no*/
    float: left;
  }

  .team-aims {
    max-width: calc(100% - 30Px);
  }

  .task-list-box {
    width: 100%;
    height: 95Px;
    /*no*/
    border: 1Px solid #becae4;
    /*no*/
    background: #fff;
    position: relative;
    float: right;
    margin-bottom: 10Px;
    /*no*/
  }

  .single-to-collapse-box {
    width: 100%;
    height: 320Px;
    /*no*/
    position: relative;
    margin-bottom: 10Px;
    /*no*/
  }

  .task-list-edit-box {
    width: calc(100% - 45Px) !important;
    /*no*/
    height: 95Px;
    /*no*/
    border: 1Px solid #becae4;
    /*no*/
    background: #fff;
    position: relative;
    float: right;
  }

  .task-list-collapse-box {
    width: 100%;
    border: 1Px solid #becae4;
    /*no*/
    background: #fff;
    position: relative;
    float: right;
  }

  .singletask-collapse-box {
    width: 100%;
    height: 320Px;
    /*no*/
    border: 1Px solid #becae4;
    /*no*/
    background: #fff;
    position: relative;
    float: right;
  }

  .task-list-back {
    width: calc(100% - 10Px);
    /*no*/
    height: 85Px;
    /*no*/
    position: absolute;
    top: 0;
    bottom: 0;
    margin: 5Px 0Px 5Px 5Px;
    /*no*/
  }

  .task-list-backgroud {
    background: #e5f0ff;
    height: 100%;
  }

  .task-list-transfers-detail {
    position: absolute;
    top: 110Px;
    /*no*/
    width: 100%;
  }

  .task-lists-info {
    width: 100%;
    height: 95Px;
    /*no*/
    box-sizing: border-box;
    padding: 0 20Px 0Px 20Px;
    /*no*/
    float: left;
    position: absolute;
  }

  .task-lists-position {
    position: relative;
    top: 20Px;
    /*no*/
  }

  .task-order {
    width: 70Px;
    /*no*/

    height: 20Px;
    /*no*/

    font-size: 14Px;
    /*no*/

    position: relative;
    top: 20Px;
    /*no*/

    text-align: center;
  }

  .transfer-type {
    float: left;
    width: 70Px;
    /*no*/
    height: 100%;
    /*no*/
    margin-right: 1.5%;
    /*no*/
  }

  .task-information {
    float: left;
    width: 26%;
    /*no*/
    height: 100%;
    /*no*/
    min-width: 242Px;
    position: relative;
  }

  .task-information-to {
    float: left;
    width: 20%;
    /*no*/
    height: 100%;
    /*no*/
    position: relative;
    min-width: 240Px;
  }

  .tasks-type {
    line-height: 50Px;
    /*no*/

    font-size: 14Px;
    /*no*/
    width: 100%;
    height: 20Px;
    display: flex;
  }

  .tasks-destion {
    font-size: 12Px;
    /*no*/
    color: #929ba9;
    height: 20Px;
    /*no*/
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    line-height: 20Px;
    /*no*/
    width: 100%;
  }

  .tasks-shedule {
    font-size: 12Px;
    /*no*/
    color: #929ba9;
    position: absolute;
    bottom: 20Px;
    /*no*/
    margin: auto;
    white-space: nowrap;
  }

  .tasks-to-destion {
    height: 20Px;
    /*no*/
    font-size: 12Px;
    /*no*/
    color: #929ba9;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    line-height: 20Px;
    /*no*/
    width: 100%;
  }

  .transfer-operating {
    float: right;
    min-width: 320Px;
    height: 100%;
    /*no*/
    position: relative;
  }

  .transfer-share-operating {
    float: right;
    width: calc(100% - 655Px);
    /*no*/
    height: 100%;
    /*no*/
    position: relative;
  }

  .transfer-edit-operating {
    float: right;
    min-width: 200Px;
    /*no*/
    height: 100%;
    /*no*/
    position: relative;
  }

  .transfer-editshare-operating {
    float: right;
    width: calc(100% - 708Px);
    /*no*/
    height: 100%;
    /*no*/
    position: relative;
  }

  .oprate-not-allowed {
    cursor: not-allowed;
  }

  .oprate-not-allowed:hover {
    cursor: not-allowed;
    background: #5166bd !important;
  }

  .tasks-icon-position {
    position: relative;
    top: 6Px;
    /*no*/
    margin-right: 5Px;
    /*no*/
  }

  .operation-result:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  .edit-small-position {
    position: absolute;
    top: 15Px;
  }

  .transfers-from {
    float: left;
  }

  .transfers-to {
    margin-left: 44Px;
    /*no*/
  }

  .type-menu {
    min-width: 200Px;
    /*no*/
    border: 1Px solid #8a96e3;
    /*no*/
    position: absolute;
    background: #fff;
    right: 101Px;
    /*no*/
    z-index: 300 !important;
  }

  .time-set {
    width: 425Px;
    /*no*/
    height: 50Px;
    /*no*/
    position: absolute;
    z-index: 3;
    background: #fff;
    border: 1Px solid #8a96e3;
    /*no*/
    right: 0;
  }

  .arrow-purple-position {
    float: left;
    margin: 12Px 10Px;
    /*no*/
  }

  .time-set-button {
    margin-top: 10Px;
    /*no*/
  }

  .operate-menu {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    position: absolute;
    z-index: 3;
    border: 1Px solid #8a96e3;
    /*no*/
    width: 180Px;
    /*no*/

    background: #fff;
    right: 0;
    left: 10;
  }

  .operate-menu-item {
    width: 100%;
    height: 35Px;
    /*no*/
    line-height: 35Px;
    /*no*/
    position: relative;
  }

  .operate-menu-name {
    position: relative;
    left: 45Px;
    /*no*/
    color: #6f7886;
    font-size: 14Px;
    /*no*/
    float: left;
  }

  .operate-icon-position {
    position: absolute;
    margin: auto;
    left: 17Px;
    /*no*/
    top: 0;
    bottom: 0;
  }

  .eidt-task-bottom {
    background: #fff;
    width: 100%;
    /*no*/
    height: 100Px;
    /*no*/
    position: absolute;
    top: calc(100% - 100Px);
    /*no*/
  }

  .select-all-button {
    position: absolute;
    top: 0;
    bottom: 0;
    float: left;
    margin: auto;
    left: 70Px;
    /*no*/
    height: 40Px;
    /*no*/
    font-size: 16Px;
    /*no*/
    background: #ecf0fe;
    color: #5562b4;
    border: 1Px solid #c6cefd;
    /*no*/
    margin-right: 15Px;
    /*no*/
    min-width: 118Px;
    /*no*/
    line-height: 20Px;
    /*no*/
  }

  .select-all-button:hover,
  .task-delete-button:hover {
    background: #5562b4;
    color: #fff;
    border: 1Px solid #5562b4;
    /*no*/
    cursor: pointer;
  }

  .task-delete-button {
    position: absolute;
    top: 0;
    bottom: 0;
    float: left;
    margin: auto;
    left: 262Px;
    /*no*/
    height: 40Px;
    /*no*/
    background: #ecf0fe;
    color: #5562b4;
    font-size: 16Px;
    /*no*/
    border: 1Px solid #c6cefd;
    /*no*/
    min-width: 118Px;
    /*no*/
    line-height: 20Px;
    /*no*/
  }

  .task-list-edit-position {
    margin-right: 15Px;
    /*no*/
    float: left;
  }

  #purpleTick {
    display: block;
    float: left;
    margin-right: 10Px;
    /*no*/
  }

  #whiteTick {
    display: none;
    float: left;
    margin-right: 10Px;
    /*no*/
  }

  #purpleFork {
    display: block;
    float: left;
    margin-right: 10Px;
    /*no*/
  }

  #whiteFork {
    display: none;
    float: left;
    margin-right: 10Px;
    /*no*/
  }

  #allButton:hover #whiteTick {
    display: block;
  }

  #allButton:hover #purpleTick {
    display: none;
  }

  #deleteButton:hover #whiteFork {
    display: block;
  }

  #deleteButton:hover #purpleFork {
    display: none;
  }

  .tasks-schedules {
    width: 100%;
    height: 40Px;
    /*no*/
    float: left;
    line-height: 40Px;
    /*no*/
    position: relative;
  }

  .schedules-icon-position {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .schedules-font {
    font-size: 12Px;
    /*no*/
    color: #6f7886;
    position: absolute;
    left: 23Px;
    /*no*/
  }

  .more-transfers {
    width: 100%;
    position: absolute;
    top: 95Px;
    /*no*/
  }

  .operate-option {
    float: left;
  }

  .coll-enter-active {
    transition: all 0.3s ease;
    height: 250Px;
    /*no*/
    overflow: hidden;
  }

  .coll-leave-active {
    transition: all 0.3s ease;
    height: 0Px;
    /*no*/
    overflow: hidden;
  }

  .coll-enter,
  .coll-leave {
    height: 0;
    opacity: 0;
  }

  .deu-class {
    width: 375Px;
    /*no*/
  }

  .status-txt {
    white-space: nowrap;
  }

  .tasks-edit-name {
    height: 28Px;
    /*no*/
    position: relative;
    left: 71Px;
    /*no*/
    top: -30Px;
    /*no*/
  }

  .tasks-lists-name {
    float: left;
    max-width: 100%;
    /*no*/
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .traverse-time-out {
    float: left;
    line-height: 95Px;
    color: red;
    cursor: pointer;
  }

  .traverse-time-out:hover {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_task_list/tabs_single_task.vue